const viewOptionDefaultValues = {
                box_shadow: {
                    value: false,
                    units: '',
                    subfields: {
                       vertical: {active: false, value: '', units: ''},
                       horizontal: {active: false, value: '', units: ''},
                       blur: {active: false, value: '', units: ''},
                       color: {active: false, value: '', units: ''},
                       inset: {active: false, value: '', units: ''},
                     }
                  },
                font: {
                  value: '',
                  units: '',
                    font_size: {active: false, value: '', units: ''},
                    font_family: {active: false, value: '', units: ''},
                    font_style: {active: false, value: '', units: ''},
                    font_weight: {active: false, value: '', units: ''},
                    text_transform: {active: false, value: '', units: ''},
                    letter_spacing: {active: false, value: '', units: ''},
                    line_height: {active: false, value: '', units: ''},
                },
                title_font: {
                        active: false, type: 'subtab', isButton: true, value: false,
                        subfields: [
                           {heading_level: {value: 'h2', units: ''},},
                           {font_size: {active: false, type: 'range', value: 'auto', units: '', unit_options: ['px'],  max: 124, min: 0, parentlabel: 'sizing_label'},
                           },
                           {font_family: {value: {"family":"Poppins","variants":["100","100italic","200","200italic","300","300italic","regular","italic","500","500italic","600","600italic","700","700italic","800","800italic","900","900italic"],"subsets":["devanagari","latin","latin-ext"],"version":"v20","lastModified":"2022-09-22","files":{"100":"http://fonts.gstatic.com/s/poppins/v20/pxiGyp8kv8JHgFVrLPTed3FBGPaTSQ.ttf","200":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLFj_V1tvFP-KUEg.ttf","300":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLDz8V1tvFP-KUEg.ttf","500":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLGT9V1tvFP-KUEg.ttf","600":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLEj6V1tvFP-KUEg.ttf","700":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLCz7V1tvFP-KUEg.ttf","800":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLDD4V1tvFP-KUEg.ttf","900":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLBT5V1tvFP-KUEg.ttf","100italic":"http://fonts.gstatic.com/s/poppins/v20/pxiAyp8kv8JHgFVrJJLmE3tFOvODSVFF.ttf","200italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmv1plEN2PQEhcqw.ttf","300italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLm21llEN2PQEhcqw.ttf","regular":"http://fonts.gstatic.com/s/poppins/v20/pxiEyp8kv8JHgFVrFJDUc1NECPY.ttf","italic":"http://fonts.gstatic.com/s/poppins/v20/pxiGyp8kv8JHgFVrJJLed3FBGPaTSQ.ttf","500italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmg1hlEN2PQEhcqw.ttf","600italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmr19lEN2PQEhcqw.ttf","700italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmy15lEN2PQEhcqw.ttf","800italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLm111lEN2PQEhcqw.ttf","900italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLm81xlEN2PQEhcqw.ttf"},"category":"sans-serif","kind":"webfonts#webfont"}, type: 'fontselect', options: []},
                           },
                           {font_style: {value: '', type: 'select', options: ['normal','italic','oblique','initial','inherit']},
                           },
                           {font_weight: {value: '', type: 'select', options: [100,200,300,400,500,600,700,800,900]},
                           },
                           {text_transform: {value: '', type: 'select', options: ['none','capitalize','uppercase','lowercase','initial','inherit']},
                           },
                           {letter_spacing: {active: false, type: 'range', value: 'auto', units: '', unit_options: ['px'],  max: 124, min: 0, parentlabel: 'sizing_label'},
                           },
                           {line_height: {active: false, type: 'range', value: 'auto', units: '', unit_options: ['px'],  max: 124, min: 0, parentlabel: 'sizing_label'}
                            }
                       ]
                  },
                font2: {
                        active: false, type: 'subtab', isButton: true, value: false,
                        subfields: [
                           
                           {font_size: {active: false, type: 'range', value: 'auto', units: '', unit_options: ['px'],  max: 124, min: 0, parentlabel: 'sizing_label'},
                           },
                           {font_family: {value: {"family":"Poppins","variants":["100","100italic","200","200italic","300","300italic","regular","italic","500","500italic","600","600italic","700","700italic","800","800italic","900","900italic"],"subsets":["devanagari","latin","latin-ext"],"version":"v20","lastModified":"2022-09-22","files":{"100":"http://fonts.gstatic.com/s/poppins/v20/pxiGyp8kv8JHgFVrLPTed3FBGPaTSQ.ttf","200":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLFj_V1tvFP-KUEg.ttf","300":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLDz8V1tvFP-KUEg.ttf","500":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLGT9V1tvFP-KUEg.ttf","600":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLEj6V1tvFP-KUEg.ttf","700":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLCz7V1tvFP-KUEg.ttf","800":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLDD4V1tvFP-KUEg.ttf","900":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLBT5V1tvFP-KUEg.ttf","100italic":"http://fonts.gstatic.com/s/poppins/v20/pxiAyp8kv8JHgFVrJJLmE3tFOvODSVFF.ttf","200italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmv1plEN2PQEhcqw.ttf","300italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLm21llEN2PQEhcqw.ttf","regular":"http://fonts.gstatic.com/s/poppins/v20/pxiEyp8kv8JHgFVrFJDUc1NECPY.ttf","italic":"http://fonts.gstatic.com/s/poppins/v20/pxiGyp8kv8JHgFVrJJLed3FBGPaTSQ.ttf","500italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmg1hlEN2PQEhcqw.ttf","600italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmr19lEN2PQEhcqw.ttf","700italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmy15lEN2PQEhcqw.ttf","800italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLm111lEN2PQEhcqw.ttf","900italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLm81xlEN2PQEhcqw.ttf"},"category":"sans-serif","kind":"webfonts#webfont"}, type: 'fontselect', options: []},
                           },
                           {font_style: {value: '', type: 'select', options: ['normal','italic','oblique','initial','inherit']},
                           },
                           {font_weight: {value: '', type: 'select', options: [100,200,300,400,500,600,700,800,900]},
                           },
                           {text_transform: {value: '', type: 'select', options: ['none','capitalize','uppercase','lowercase','initial','inherit']},
                           },
                           {letter_spacing: {active: false, type: 'range', value: 'auto', units: '', unit_options: ['px'],  max: 124, min: 0, parentlabel: 'sizing_label'},
                           },
                           {line_height: {active: false, type: 'range', value: 'auto', units: '', unit_options: ['px'],  max: 124, min: 0, parentlabel: 'sizing_label'}
                            }
                       ]
                  },
                lightbox: {value: false, units: ''},
                view: {active: false, value: 'grid', units: ''},
                columns: {value: {type: 'cols', xl: 4, lg: 4, md: 4, sm: 12, xs: 12 }, units: ''},
                column: {
                 subfields: [
                  {padding: {
                    active: false,
                    type: 'numbergroup',
                    parentlabel: '',
                    left: null,
                    right: null,
                    top: null,
                    bottom: null, 
                  },    
                  },
                  {margin: {
                      active: false,
                      type: 'numbergroup',
                      parentlabel: '',
                      left: null,
                      right: null,
                      top: null,
                      bottom: null,
                  },
                  },
                  {border_label: {active: false, type: 'label', text: 'Borders', parentname: 'border_label'},
                  },
                  {border_style: {
                        active: false, type: 'select', value: '', options: ['dotted','dashed','solid','double','groove','ridge','inset','outset','none','hidden']
                  },
                  },
                  {border: {
                      active: true,
                      type: 'numbergroup',
                      parentlabel: '',
                      left: 0,
                      right: 0,
                      top: 0,
                      bottom: 0,
                  },  
                  },
                  {border_colour: {
                      active: false,
                      value: '#000000',
                      type: 'color'
                    },
                  },
                  {border_radius: {
                      active: false,
                      type: 'numbergroup',
                      parentlabel: '',
                      top_left: null,
                      top_right: null,
                      bottom_left: null,
                      bottom_right: null,
                    },
                  },
                ]
                },
                carousel: {
                    dependentOn: {field: 'view', value: 'carousel'},
                    type: 'subtab',
                    subfields: [
                        {autoplay: {type: 'switch', value: false, units: ''},},
                        {arrows_navigation: {type: 'switch', value: false, units: ''},},
                        {dots_navigation: {type: 'switch', value: false, units: ''},},
                        {total: {type: 'number', value: 12, units: ''},},
                        {show: {type: 'number', value: 4, units: ''},},
                        {margin: {type: 'number', value: 10, units: ''},},
                        {loop: {type: 'switch', value: false, units: ''},},
                        {direction: {type: 'radiogroup', value: 'horizontal', units: ''},},
                        ],
                },
                masonry: {
                    subfields: [
                        {columns: {value: 4, units: ''},},
                        {space_between: {value: 15, units: ''},},
                        {total: {value: 12, units: ''}},
                    ]
                },
                show_elements: {
                    menu: [
                          {show_search: {type: 'radiogroup', isButton: true, value: true, options: [true, false]}, },
                          {show_cart: {type: 'radiogroup', isButton: true, value: true, options: [true, false]},},
                          {show_currency: {type: 'radiogroup', isButton: true, value: true, options: [true, false]},},
                          {show_account: {type: 'radiogroup', isButton: true, value: true, options: [true, false]},},
                    ],
                    products: [
                          {pagination: {value: true, units: ''},},
                          {pagination_alignment: {value: 'left', units: ''},},
                          {pagination_shape: {value: 'square', units: ''},},
                          //items_per_page: {value: true, units: ''},},
                          //total_items: {value: 'auto', units: ''},},
                          {show_limits: {value: true, units: ''},},
                          {show_search: {value: true, units: ''},},
                          {allow_filters: {value: true, units: ''},},
                          {truncate_title: {value: true, units: ''},},
                          {truncate_description: {value: true, units: ''},},
                          //switcher: {value: '', units: ''},
                        ],
                    listingmap: [
                          {map_type: {value: 'roadmap', units: ''},},
                          {zoom_level: {value: 12, units: ''},},
                          {allow_zoom: {value: true, units: ''},},
                          {map_type_switcher: {value: true, units: ''},},
                          {allow_scaling: {value: true, units: ''},},
                          {allow_streetview: {value: true, units: ''},},
                          {allow_rotate: {value: true, units: ''},},
                          {allow_fullscreen: {value: true, units: ''},},
                          {disable_default_ui: {value: true, units: ''},},
                    ],
                    map: {
                      map_type: {value: 'roadmap', units: ''},
                      zoom_level: {value: 12, units: ''},
                      allow_zoom: {value: true, units: ''},
                      map_type_switcher: {value: true, units: ''},
                      allow_scaling: {value: true, units: ''},
                      allow_streetview: {value: true, units: ''},
                      allow_rotate: {value: true, units: ''},
                      allow_fullscreen: {value: true, units: ''},
                      disable_default_ui: {value: true, units: ''},
                    },
                    search: [
                          {show_button: {value: '', units: ''},},
                          {results: {value: 'Dropdown', units: ''},},
                          {show_image: {value: true, units: ''},},
                          {max_results: {value: '', units: ''},},
                          {results_per_page: {value: '', units: ''},},
                    ]
                  },
};

const viewOptionConfigs = {
                  box_shadow: {
                    active: false, type: 'subtab', isButton: true, value: false,
                        subfields: {
                           vertical: {active: false, type: 'range', value: 'auto', units: '', unit_options: ['px'],  max: 124, min: 0, parentlabel: 'sizing_label'},
                           horizontal: {active: false, type: 'range', value: 'auto', units: '', unit_options: ['px'],  max: 124, min: 0, parentlabel: 'sizing_label'},
                           blur: {active: false, type: 'range', value: 'auto', units: '', unit_options: ['px'],  max: 124, min: 0, parentlabel: 'sizing_label'},
                           color: {active: false, value: '#000000', type: 'color', units: ''},
                           inset: { active: false, type: 'radiogroup', isButton: true, value: false, options: [true, false]}
                         }
                  },
                  font: {
                        active: false, type: 'subtab', isButton: true, value: false,
                        subfields: {
                           font_size: {active: false, type: 'range', value: 'auto', units: '', unit_options: ['px'],  max: 124, min: 0, parentlabel: 'sizing_label'},
                           font_family: {value: {"family":"Poppins","variants":["100","100italic","200","200italic","300","300italic","regular","italic","500","500italic","600","600italic","700","700italic","800","800italic","900","900italic"],"subsets":["devanagari","latin","latin-ext"],"version":"v20","lastModified":"2022-09-22","files":{"100":"http://fonts.gstatic.com/s/poppins/v20/pxiGyp8kv8JHgFVrLPTed3FBGPaTSQ.ttf","200":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLFj_V1tvFP-KUEg.ttf","300":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLDz8V1tvFP-KUEg.ttf","500":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLGT9V1tvFP-KUEg.ttf","600":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLEj6V1tvFP-KUEg.ttf","700":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLCz7V1tvFP-KUEg.ttf","800":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLDD4V1tvFP-KUEg.ttf","900":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLBT5V1tvFP-KUEg.ttf","100italic":"http://fonts.gstatic.com/s/poppins/v20/pxiAyp8kv8JHgFVrJJLmE3tFOvODSVFF.ttf","200italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmv1plEN2PQEhcqw.ttf","300italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLm21llEN2PQEhcqw.ttf","regular":"http://fonts.gstatic.com/s/poppins/v20/pxiEyp8kv8JHgFVrFJDUc1NECPY.ttf","italic":"http://fonts.gstatic.com/s/poppins/v20/pxiGyp8kv8JHgFVrJJLed3FBGPaTSQ.ttf","500italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmg1hlEN2PQEhcqw.ttf","600italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmr19lEN2PQEhcqw.ttf","700italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmy15lEN2PQEhcqw.ttf","800italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLm111lEN2PQEhcqw.ttf","900italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLm81xlEN2PQEhcqw.ttf"},"category":"sans-serif","kind":"webfonts#webfont"}, type: 'fontselect', options: []},
                           font_style: {value: '', type: 'select', options: ['normal','italic','oblique','initial','inherit']},
                           font_weight: {value: '', type: 'select', options: [100,200,300,400,500,600,700,800,900]},
                           text_transform: {value: '', type: 'select', options: ['none','capitalize','uppercase','lowercase','initial','inherit']},
                           letter_spacing: {active: false, type: 'range', value: 'auto', units: '', unit_options: ['px'],  max: 124, min: 0, parentlabel: 'sizing_label'},
                           line_height: {active: false, type: 'range', value: 'auto', units: '', unit_options: ['px'],  max: 124, min: 0, parentlabel: 'sizing_label'}
                       }
                  },
                  title_font: {
                        active: false, type: 'subtab', isButton: true, value: false,
                        subfields: [
                           {heading_level: {type: 'radiogroup', isButton: true, options: ['h1', 'h2', 'h3', 'h4', 'h5']},
                       },
                           {font_size: {active: false, type: 'range', value: 'auto', units: '', unit_options: ['px'],  max: 124, min: 0, parentlabel: 'sizing_label'},
                           },
                           {font_family: {value: {"family":"Poppins","variants":["100","100italic","200","200italic","300","300italic","regular","italic","500","500italic","600","600italic","700","700italic","800","800italic","900","900italic"],"subsets":["devanagari","latin","latin-ext"],"version":"v20","lastModified":"2022-09-22","files":{"100":"http://fonts.gstatic.com/s/poppins/v20/pxiGyp8kv8JHgFVrLPTed3FBGPaTSQ.ttf","200":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLFj_V1tvFP-KUEg.ttf","300":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLDz8V1tvFP-KUEg.ttf","500":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLGT9V1tvFP-KUEg.ttf","600":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLEj6V1tvFP-KUEg.ttf","700":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLCz7V1tvFP-KUEg.ttf","800":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLDD4V1tvFP-KUEg.ttf","900":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLBT5V1tvFP-KUEg.ttf","100italic":"http://fonts.gstatic.com/s/poppins/v20/pxiAyp8kv8JHgFVrJJLmE3tFOvODSVFF.ttf","200italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmv1plEN2PQEhcqw.ttf","300italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLm21llEN2PQEhcqw.ttf","regular":"http://fonts.gstatic.com/s/poppins/v20/pxiEyp8kv8JHgFVrFJDUc1NECPY.ttf","italic":"http://fonts.gstatic.com/s/poppins/v20/pxiGyp8kv8JHgFVrJJLed3FBGPaTSQ.ttf","500italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmg1hlEN2PQEhcqw.ttf","600italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmr19lEN2PQEhcqw.ttf","700italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmy15lEN2PQEhcqw.ttf","800italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLm111lEN2PQEhcqw.ttf","900italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLm81xlEN2PQEhcqw.ttf"},"category":"sans-serif","kind":"webfonts#webfont"}, type: 'fontselect', options: []},
                           },
                           {font_style: {value: '', type: 'select', options: ['normal','italic','oblique','initial','inherit']},
                           },
                           {font_weight: {value: '', type: 'select', options: [100,200,300,400,500,600,700,800,900]},
                           },
                           {text_transform: {value: '', type: 'select', options: ['none','capitalize','uppercase','lowercase','initial','inherit']},
                           },
                           {letter_spacing: {active: false, type: 'range', value: 'auto', units: '', unit_options: ['px'],  max: 124, min: 0, parentlabel: 'sizing_label'},
                           },
                           {line_height: {active: false, type: 'range', value: 'auto', units: '', unit_options: ['px'],  max: 124, min: 0, parentlabel: 'sizing_label'}
                            }
                       ]
                  },
                  font2: {
                        active: false, type: 'subtab', isButton: true, value: false,
                        subfields: [
                           {font_size: {active: false, type: 'range', value: 'auto', units: '', unit_options: ['px'],  max: 124, min: 0, parentlabel: 'sizing_label'},
                           },
                           {font_family: {value: {"family":"Poppins","variants":["100","100italic","200","200italic","300","300italic","regular","italic","500","500italic","600","600italic","700","700italic","800","800italic","900","900italic"],"subsets":["devanagari","latin","latin-ext"],"version":"v20","lastModified":"2022-09-22","files":{"100":"http://fonts.gstatic.com/s/poppins/v20/pxiGyp8kv8JHgFVrLPTed3FBGPaTSQ.ttf","200":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLFj_V1tvFP-KUEg.ttf","300":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLDz8V1tvFP-KUEg.ttf","500":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLGT9V1tvFP-KUEg.ttf","600":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLEj6V1tvFP-KUEg.ttf","700":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLCz7V1tvFP-KUEg.ttf","800":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLDD4V1tvFP-KUEg.ttf","900":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLBT5V1tvFP-KUEg.ttf","100italic":"http://fonts.gstatic.com/s/poppins/v20/pxiAyp8kv8JHgFVrJJLmE3tFOvODSVFF.ttf","200italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmv1plEN2PQEhcqw.ttf","300italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLm21llEN2PQEhcqw.ttf","regular":"http://fonts.gstatic.com/s/poppins/v20/pxiEyp8kv8JHgFVrFJDUc1NECPY.ttf","italic":"http://fonts.gstatic.com/s/poppins/v20/pxiGyp8kv8JHgFVrJJLed3FBGPaTSQ.ttf","500italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmg1hlEN2PQEhcqw.ttf","600italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmr19lEN2PQEhcqw.ttf","700italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmy15lEN2PQEhcqw.ttf","800italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLm111lEN2PQEhcqw.ttf","900italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLm81xlEN2PQEhcqw.ttf"},"category":"sans-serif","kind":"webfonts#webfont"}, type: 'fontselect', options: []},
                           },
                           {font_style: {value: '', type: 'select', options: ['normal','italic','oblique','initial','inherit']},
                           },
                           {font_weight: {value: '', type: 'select', options: [100,200,300,400,500,600,700,800,900]},
                           },
                           {text_transform: {value: '', type: 'select', options: ['none','capitalize','uppercase','lowercase','initial','inherit']},
                           },
                           {letter_spacing: {active: false, type: 'range', value: 'auto', units: '', unit_options: ['px'],  max: 124, min: 0, parentlabel: 'sizing_label'},
                           },
                           {line_height: {active: false, type: 'range', value: 'auto', units: '', unit_options: ['px'],  max: 124, min: 0, parentlabel: 'sizing_label'}
                            }
                       ]
                  },
                  show_elements: {
                    menu: {
                      active: false, type: 'subtab', isButton: true, value: false,
                       subfields: [
                        
                          {show_search: {type: 'radiogroup', isButton: true, value: false, options: [true, false]}, 
                          },
                          {show_cart: {type: 'radiogroup', isButton: true, value: false, options: [true, false]},
                          },
                          {show_currency: {type: 'radiogroup', isButton: true, value: false, options: [true, false]},
                          },
                          {show_account: {type: 'radiogroup', isButton: true, value: false, options: [true, false]},
                          },
                       ]
                    },
                    products: {
                       active: false, type: 'subtab', isButton: true, value: false,
                       subfields: [
                          {pagination: {type: 'radiogroup', isButton: true, value: false, options: [true, false]},},
                          {pagination_alignment: {type: 'radiogroup', isButton: true, value: false, options: ['left', 'center', 'right']},},
                          {pagination_shape: {type: 'radiogroup', isButton: true, value: false, options: ['square', 'circle', 'underline', 'plain']},},
                          //items_per_page: {active: false, type: 'range', value: 'auto', units: '', max: 50, min: 0, parentlabel: 'sizing_label'},
                          //total_items: {active: false, type: 'range', value: 'auto', units: '', max: 500, min: 0, parentlabel: 'sizing_label'},
                          {show_limits: {type: 'radiogroup', isButton: true, value: false, options: [true, false]},},
                          {show_search: {type: 'radiogroup', isButton: true, value: false, options: [true, false]},},
                          {allow_filters: {type: 'radiogroup', isButton: true, value: false, options: [true, false]},},
                          {truncate_title: {type: 'radiogroup', isButton: true, value: false, options: [true, false]},},
                          {truncate_description: {type: 'radiogroup', isButton: true, value: false, options: [true, false]},},
                          //switcher: {type: 'radiogroup', isButton: true, value: false, options: [true, false]},
                        ],
                    },
                    listingmap: {
                       active: false, type: 'subtab', isButton: true, value: false,
                       subfields: [
                          {map_type: {type: 'radiogroup', isButton: true, value: false, options: ['roadmap', 'satellite', 'hybrid', 'terrain']},},
                          {zoom_level: {active: false, type: 'range', value: 'auto', units: '', max: 100, min: 0, parentlabel: 'sizing_label'},},
                          {allow_zoom: {type: 'radiogroup', isButton: true, value: false, options: [true, false]},},
                          {map_type_switcher: {type: 'radiogroup', isButton: true, value: false, options: [true, false]},},
                          {allow_scaling: {type: 'radiogroup', isButton: true, value: false, options: [true, false]},},
                          {allow_streetview: {type: 'radiogroup', isButton: true, value: false, options: [true, false]},},
                          {allow_rotate: {type: 'radiogroup', isButton: true, value: false, options: [true, false]},},
                          {allow_fullscreen: {type: 'radiogroup', isButton: true, value: false, options: [true, false]},},
                          {disable_default_ui: {type: 'radiogroup', isButton: true, value: false, options: [true, false]},},
                        ],
                    },
                    map: {
                       active: false, type: 'subtab', isButton: true, value: false,
                       subfields: {
                          map_type: {type: 'radiogroup', isButton: true, value: false, options: ['roadmap', 'satellite', 'hybrid', 'terrain']},
                          zoom_level: {active: false, type: 'range', value: 'auto', units: '', max: 18, min: 0, parentlabel: 'sizing_label'},
                          allow_zoom: {type: 'radiogroup', isButton: true, value: false, options: [true, false]},
                          map_type_switcher: {type: 'radiogroup', isButton: true, value: false, options: [true, false]},
                          allow_scaling: {type: 'radiogroup', isButton: true, value: false, options: [true, false]},
                          allow_streetview: {type: 'radiogroup', isButton: true, value: false, options: [true, false]},
                          allow_rotate: {type: 'radiogroup', isButton: true, value: false, options: [true, false]},
                          allow_fullscreen: {type: 'radiogroup', isButton: true, value: false, options: [true, false]},
                          disable_default_ui: {type: 'radiogroup', isButton: true, value: false, options: [true, false]},
                          },
                    },
                    search: {
                       active: false, type: 'subtab', isButton: true, value: false,
                       subfields: [
                          //show_icon: {type: 'radiogroup', isButton: true, value: false, options: [true, false]},
                          {results: {type: 'radiogroup', isButton: true, value: false, options: ['Dropdown', 'Page'], description: 'Show results in a dropdown list or load a search results page'},},
                          {max_results: {active: false, type: 'range', value: 'auto', units: '', max: 10000, min: 0, parentlabel: 'sizing_label'},},
                          {results_per_page: {active: false, type: 'range', value: 'auto', units: '', max: 100, min: 0, parentlabel: 'sizing_label'},},
                        ],
                    }

                  },
                  lightbox: {active: false, type: 'radiogroup', isButton: true, value: false, options: [true, false]},
                  view: {
                    default: {active: false, type: 'select', value: '', options: ['grid', 'list', 'carousel', 'masonry']},
                    products: {active: false, type: 'select', value: '', options: ['grid', 'list', 'carousel']}
                  },
                  column_templates: {
                    one_column:  {type: 'cols', xl: 12, lg: 12, md: 12, sm: 12, xs: 12 },
                    two_columns:  {type: 'cols', xl: 6, lg: 6, md: 6, sm: 12, xs: 12 },
                    three_columns:  {type: 'cols', xl: 4, lg: 4, md: 4, sm: 12, xs: 12 },
                    four_columns:  {type: 'cols', xl: 3, lg: 3, md: 3, sm: 6, xs: 12 },
                  },
                  columns: {
                    active: false, type: 'radiogroup', isButton: true, value: false, isStacked: true, dependentOn: {field: 'view', value: 'grid'}, 
                    options: [{text: 'one column', value: {type: 'cols', xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }},
                    {text: 'two columns', value: {type: 'cols', xl: 6, lg: 6, md: 6, sm: 12, xs: 12 }},
                    {text: 'three columns', value: {type: 'cols', xl: 4, lg: 4, md: 4, sm: 12, xs: 12 }},
                    {text: 'four columns', value: {type: 'cols', xl: 3, lg: 3, md: 3, sm: 6, xs: 12 }}]
                  },
                  column: {
                    dependentOn: {field: 'view', value: 'grid'},
                    type: 'subtab',
                    subfields: [
                    {column_label: {active: false, type: 'label', text: 'Grid Column Options', parentname: 'column_label'}},
                    {padding: {
                      active: false,
                      type: 'numbergroup',
                      parentlabel: '',
                      left: null,
                      right: null,
                      top: null,
                      bottom: null,
                      
                    },
                    },
                    {margin: {
                      active: false,
                      type: 'numbergroup',
                      parentlabel: '',
                      left: null,
                      right: null,
                      top: null,
                      bottom: null,
                      
                    },
                    },
                    {border_label: {active: false, type: 'label', text: 'Borders', parentname: 'border_label'},
                    },
                    {border_style: {
                        active: false, type: 'select', value: '', options: ['dotted','dashed','solid','double','groove','ridge','inset','outset','none','hidden']
                    },
                    },
                    {border: {
                      
                      active: true,
                      type: 'numbergroup',
                      parentlabel: '',
                      left: 0,
                      right: 0,
                      top: 0,
                      bottom: 0,
                    },
                    },
                    {border_colour: {
                      
                      active: false,
                      value: '#000000',
                      type: 'color'
                    },
                    },
                    {border_radius: {
                      
                      active: false,
                      type: 'numbergroup',
                      parentlabel: '',
                      top_left: null,
                      top_right: null,
                      bottom_left: null,
                      bottom_right: null,
                      },
                    },
                    ]

                  },
                  carousel_label: {active: false, type: 'label', text: 'Carousel Gallery Settings', parentname: 'border_label', dependentOn: {field: 'view', value: 'carousel'},},
                  carousel: {
                    default: {
                      dependentOn: {field: 'view', value: 'carousel'},
                      type: 'subtab',
                      subfields: [
                      {autoplay: {type: 'radiogroup', isButton: true, value: false, options: [true, false]},},
                      {arrows_navigation: {type: 'radiogroup', isButton: true, value: false, options: [true, false]},},
                      {dots_navigation: {type: 'radiogroup', isButton: true, value: false, options: [true, false]},},
                      {total: {active: false, type: 'range', value: 'auto', units: '%', max: 1000, min: 0, parentlabel: 'sizing_label'},},
                      {show: {active: false, type: 'range', value: 'auto', units: '%', max: 12, min: 0, parentlabel: 'sizing_label'},},
                      {margin: {active: false, type: 'range', value: 'auto', units: '%', max: 12, min: 0, parentlabel: 'sizing_label'},},
                      {loop: {type: 'radiogroup', isButton: true, value: false, options: [true, false]},},
                      {direction: {type: 'radiogroup', isButton: true, value: false, options: ['horizontal', 'vertical']},},
                      ],
                    },
                    products: {
                      dependentOn: {field: 'view', value: 'carousel'},
                      type: 'subtab',
                      subfields: {
                      autoplay: {type: 'radiogroup', isButton: true, value: false, options: [true, false]},
                      arrows_navigation: {type: 'radiogroup', isButton: true, value: false, options: [true, false]},
                      dots_navigation: {type: 'radiogroup', isButton: true, value: false, options: [true, false]},
                      //total: {active: false, type: 'range', value: 'auto', units: '%', max: 1000, min: 0, parentlabel: 'sizing_label'},
                      show: {active: false, type: 'range', value: 'auto', units: '%', max: 1240, min: 0, parentlabel: 'sizing_label'},
                      loop: {type: 'radiogroup', isButton: true, value: false, options: [true, false]},
                      },
                    },
                    products2: {
                      dependentOn: {field: 'view', value: 'carousel'},
                      type: 'subtab',
                      subfields: [
                          {autoplay: {type: 'radiogroup', isButton: true, value: false, options: [true, false]},},
                          {arrows_navigation: {type: 'radiogroup', isButton: true, value: false, options: [true, false]},},
                          {dots_navigation: {type: 'radiogroup', isButton: true, value: false, options: [true, false]},},
                          //total: {active: false, type: 'range', value: 'auto', units: '%', max: 1000, min: 0, parentlabel: 'sizing_label'},
                          {show: {active: false, type: 'range', value: 'auto', units: '%', max: 1240, min: 0, parentlabel: 'sizing_label'},},
                          {loop: {type: 'radiogroup', isButton: true, value: false, options: [true, false]},},
                        ],
                      
                    },
                  },
                  masonry_label: {active: false, type: 'label', text: 'Masonry Gallery Settings', parentname: 'border_label', dependentOn: {field: 'view', value: 'masonry'}},
                  masonry: {
                    dependentOn: {field: 'view', value: 'masonry'},
                    type: 'subtab',
                    subfields: [
                      {columns: {active: false, type: 'range', value: 'auto', units: '', max: 1000, min: 0, parentlabel: 'sizing_label'},},
                      {space_between: {active: false, type: 'range', value: 'auto', units: '', max: 1000, min: 0, parentlabel: 'sizing_label'},},
                      {total: {active: false, type: 'range', value: 'auto', units: '', max: 1000, min: 0, parentlabel: 'sizing_label'},},
                    ],
                  },
                  
              };

/*const webPageWidgetsOrginal = {
    {
              widgetname: 'Menu',
              widgettype: 'menu',
              widgeticon: 'bx bx-menu',
              widgetcontent: {
                config: {
                  view: 'horizontal',
                  view_options: ['horizontal', 'vertical'],
                  layout: 'logo left', 
                  layouts: ['logo left', 'logo right', 'logo center'],
                  info_bar: false,
                  default_company_logo: true, 
                  logo: '',
                  logo_width: 150,
                  size: {type: 'cols', xl: 4, lg: 4, md: 4, sm: 12, xs: 12 },
                  
                },

                list: [],
                url: {value: '', units: ''},
                width: {value: 'auto', units: '%'},
                height: {value: 'auto', units: '%'},
                max_width: {value: 'auto', units: '%'},
                max_height: {value: 'auto', units: '%'},
                text_align: {value: 'text-left', units: ''},
                fullwidth: {value: false, units: ''},
                view: {value: false, units: ''},
                layout: {value: 'Layout 1', units: ''},
                layout_colour: {value: 'Light', units: ''},
                custom_colour: {
                  value: false,
                  units: '',
                },
                topbar_colour: {value: '', units: ''},
                topbar_text_colour: {value: '', units: ''}, 
                bottombar_colour: {value: '', units: ''},
                bottombar_text_colour: {value: '', units: ''},
                layout_alignment: {value: 'horizontal', units: ''},
                logo_position: {value: 'logo left', units: ''},
                //custom_logo: {value: false, units: ''},
                logo: {
                        active: true,
                        width: {value: 'auto', units: ''},
                        height: {value: 65, units: ''},
                        value: '',
                        units: '',
                      },
                menu_text: viewOptionDefaultValues.font,
                dropdown_text: viewOptionDefaultValues.font,
              },
              widgetconfigs: {
                  layout_label: {active: false, type: 'label', text: 'Layout Options', parentname: 'background_label'},
                  fullwidth: {active: false, type: 'radiogroup', isButton: true, value: false, options: [true, false]},
                  layout: {active: false, type: 'radiogroup', isButton: true, value: false, options: ['Layout 1', 'Layout 2']},
                  layout_colour: {active: false, type: 'radiogroup', isButton: true, value: false, options: ['Light', 'Dark']},
                  custom_colour: {active: false, type: 'radiogroup', isButton: true, value: false, options: [true, false]},
                  custom_colour_label: {active: false, type: 'label', text: 'Select Custom Colors', parentname: 'imgsize_label', dependentOn: {field: 'custom_colour', value: true}},
                  topbar_colour: {
                            active: false,
                            value: '#000000',
                            type: 'color',
                            dependentOn: {field: 'custom_colour', value: true},
                          },
                  topbar_text_colour: {
                            active: false,
                            value: '#000000',
                            type: 'color',
                            dependentOn: {field: 'custom_colour', value: true},
                          },
                  bottombar_colour: {
                            active: false,
                            value: '#000000',
                            type: 'color',
                            dependentOn: {field: 'custom_colour', value: true},
                          },
                  bottombar_text_colour: {
                            active: false,
                            value: '#000000',
                            type: 'color',
                            dependentOn: {field: 'custom_colour', value: true},
                          },
                  layout_alignment: {active: false, type: 'radiogroup', isButton: true, value: false, options: ['horizontal', 'vertical']},
                  logo_position: {active: false, type: 'radiogroup', isButton: true, value: false, options: ['logo left', 'logo right', 'logo center']},
                  //custom_logo: {active: false, type: 'radiogroup', isButton: true, value: false, options: [true, false]},
                  logo: {
                        active: true,
                        custom_size: 100,
                        image_repeat_options: ['repeat','repeat-x','repeat-y','no-repeat','initial','inherit'],
                        image_size_options: ['auto', 'contain', 'cover', 'custom'],
                        image_position_options: ['top right', 'top left', 'top center', 'center right', 'center left', 'center center', 'bottom right', 'bottom left', 'bottom center'],
                        type: 'image',
                        value: '',
                        subfields: {
                          imgsize_label: {active: false, type: 'label', text: 'Image Size', parentname: 'imgsize_label'},
                          width: {active: false, type: 'range', value: 'auto', units: '%', unit_options: ['px', '%'], max: 100, min: 0, parentlabel: 'imgsize_label'},
                          height: {active: false, type: 'range', value: 'auto', units: '%', unit_options: ['px', '%'], max: 100, min: 0, parentlabel: 'imgsize_label'},
                        }
                      },
                    menu_label: {active: false, type: 'label', text: 'Menu Text Options', parentname: 'background_label'},
                    menu_text: viewOptionConfigs.font,
                    dropdown_label: {active: false, type: 'label', text: 'Dropdown Text Options', parentname: 'background_label'},
                    dropdown_text: viewOptionConfigs.font,
                },
              widgetstyles: '',
              widgetfilters: {
                    filter: {menus: {active: true, switchHidden: true, type: 'customselect', options: []}},
                    active_filters: {menus: {active: true, switchHidden: true, type: 'customselect', options: []}},
              },
              widgetelements: {
                    active_elements:  viewOptionDefaultValues.show_elements.menu,
                    elements: viewOptionConfigs.show_elements.menu.subfields,
              },
              editable: 0,
              id: '',
            }
}*/        

const templateWidgets = 
    [
        {
              widgetname: 'Page: Content',
              widgettype: 'page-content',
              widgetresource: 'pages',
              widgetplaceholder: '',
              widgetdescription: 'Insert where you want the page content to render within your template',
              widgeticon: 'mdi mdi-page-layout-header-footer',
              widgetcontent: [
                /*{spacer_height:  {value: 30, units: 'px'},},
                {spacer_width:  {value: 100, units: '%'},},
                {spacer_max_height:  {value: 30, units: 'px'},},
                {spacer_max_width:  {value: 100, units: '%'},},
                {spacer_background_colour: {value: '', units: ''},},*/
              ],
              widgetconfigs: [

                /*{sizing_label: {active: false, type: 'label', text: 'Spacer Options', parentname: 'alignment_label'},                
                },
                {spacer_height: {active: false, type: 'range', value: 'auto', units: '%', unit_options: ['px', '%'],  max: 2400, min: 0, parentlabel: 'sizing_label'},
                },
                {spacer_width: {active: false, type: 'range', value: 'auto', units: '%', unit_options: ['px', '%'],  max: 2400, min: 0, parentlabel: 'sizing_label'},
                },
                {spacer_max_height: {active: false, type: 'range', value: 'auto', units: '%', unit_options: ['px', '%'],  max: 2400, min: 0, parentlabel: 'sizing_label'},
                },
                {spacer_max_width: {active: false, type: 'range', value: 'auto', units: '%', unit_options: ['px', '%'],  max: 2400, min: 0, parentlabel: 'sizing_label'},
                },
                {spacer_background_colour: {
                    active: false,
                    value: '#000000',
                    type: 'color'
                },
                },*/
              ],
              widgetstyles: '',
              editable: 0,
              id: '',
        },
        {
              widgetname: 'Category: Title',
              widgettype: 'category-title',
              widgetresource: 'category',
              widgetplaceholder: '',
              widgetdescription: '',
              widgeticon: 'mdi mdi-format-title',
              widgetcontent: [
                /*{spacer_height:  {value: 30, units: 'px'},},
                {spacer_width:  {value: 100, units: '%'},},
                {spacer_max_height:  {value: 30, units: 'px'},},
                {spacer_max_width:  {value: 100, units: '%'},},
                {spacer_background_colour: {value: '', units: ''},},*/
              ],
              widgetconfigs: [

                /*{sizing_label: {active: false, type: 'label', text: 'Spacer Options', parentname: 'alignment_label'},                
                },
                {spacer_height: {active: false, type: 'range', value: 'auto', units: '%', unit_options: ['px', '%'],  max: 2400, min: 0, parentlabel: 'sizing_label'},
                },
                {spacer_width: {active: false, type: 'range', value: 'auto', units: '%', unit_options: ['px', '%'],  max: 2400, min: 0, parentlabel: 'sizing_label'},
                },
                {spacer_max_height: {active: false, type: 'range', value: 'auto', units: '%', unit_options: ['px', '%'],  max: 2400, min: 0, parentlabel: 'sizing_label'},
                },
                {spacer_max_width: {active: false, type: 'range', value: 'auto', units: '%', unit_options: ['px', '%'],  max: 2400, min: 0, parentlabel: 'sizing_label'},
                },
                {spacer_background_colour: {
                    active: false,
                    value: '#000000',
                    type: 'color'
                },
                },*/
              ],
              widgetstyles: '',
              editable: 0,
              id: '',
        },
        {
              widgetname: 'Category: Description',
              widgettype: 'category-description',
              widgetresource: 'category',
              widgetplaceholder: '',
              widgetdescription: '',
              widgeticon: 'mdi mdi-format-wrap-tight',
              widgetcontent: [
                /*{spacer_height:  {value: 30, units: 'px'},},
                {spacer_width:  {value: 100, units: '%'},},
                {spacer_max_height:  {value: 30, units: 'px'},},
                {spacer_max_width:  {value: 100, units: '%'},},
                {spacer_background_colour: {value: '', units: ''},},*/
              ],
              widgetconfigs: [

                /*{sizing_label: {active: false, type: 'label', text: 'Spacer Options', parentname: 'alignment_label'},                
                },
                {spacer_height: {active: false, type: 'range', value: 'auto', units: '%', unit_options: ['px', '%'],  max: 2400, min: 0, parentlabel: 'sizing_label'},
                },
                {spacer_width: {active: false, type: 'range', value: 'auto', units: '%', unit_options: ['px', '%'],  max: 2400, min: 0, parentlabel: 'sizing_label'},
                },
                {spacer_max_height: {active: false, type: 'range', value: 'auto', units: '%', unit_options: ['px', '%'],  max: 2400, min: 0, parentlabel: 'sizing_label'},
                },
                {spacer_max_width: {active: false, type: 'range', value: 'auto', units: '%', unit_options: ['px', '%'],  max: 2400, min: 0, parentlabel: 'sizing_label'},
                },
                {spacer_background_colour: {
                    active: false,
                    value: '#000000',
                    type: 'color'
                },
                },*/
              ],
              widgetstyles: '',
              editable: 0,
              id: '',
        },
        {
              widgetname: 'Category: Image',
              widgettype: 'category-grid',
              widgetresource: 'category',
              widgetplaceholder: '',
              widgetdescription: '',
              widgeticon: 'mdi mdi-image',
              widgetcontent: [
                /*{spacer_height:  {value: 30, units: 'px'},},
                {spacer_width:  {value: 100, units: '%'},},
                {spacer_max_height:  {value: 30, units: 'px'},},
                {spacer_max_width:  {value: 100, units: '%'},},
                {spacer_background_colour: {value: '', units: ''},},*/
              ],
              widgetconfigs: [

                /*{sizing_label: {active: false, type: 'label', text: 'Spacer Options', parentname: 'alignment_label'},                
                },
                {spacer_height: {active: false, type: 'range', value: 'auto', units: '%', unit_options: ['px', '%'],  max: 2400, min: 0, parentlabel: 'sizing_label'},
                },
                {spacer_width: {active: false, type: 'range', value: 'auto', units: '%', unit_options: ['px', '%'],  max: 2400, min: 0, parentlabel: 'sizing_label'},
                },
                {spacer_max_height: {active: false, type: 'range', value: 'auto', units: '%', unit_options: ['px', '%'],  max: 2400, min: 0, parentlabel: 'sizing_label'},
                },
                {spacer_max_width: {active: false, type: 'range', value: 'auto', units: '%', unit_options: ['px', '%'],  max: 2400, min: 0, parentlabel: 'sizing_label'},
                },
                {spacer_background_colour: {
                    active: false,
                    value: '#000000',
                    type: 'color'
                },
                },*/
              ],
              widgetstyles: '',
              editable: 0,
              id: '',
        },
        {
              widgetname: 'Category: Grid',
              widgettype: 'category-grid',
              widgetresource: 'category',
              widgetplaceholder: '',
              widgetdescription: '',
              widgeticon: 'mdi mdi-view-grid-plus-outline',
              widgetcontent: [
                /*{spacer_height:  {value: 30, units: 'px'},},
                {spacer_width:  {value: 100, units: '%'},},
                {spacer_max_height:  {value: 30, units: 'px'},},
                {spacer_max_width:  {value: 100, units: '%'},},
                {spacer_background_colour: {value: '', units: ''},},*/
              ],
              widgetconfigs: [

                /*{sizing_label: {active: false, type: 'label', text: 'Spacer Options', parentname: 'alignment_label'},                
                },
                {spacer_height: {active: false, type: 'range', value: 'auto', units: '%', unit_options: ['px', '%'],  max: 2400, min: 0, parentlabel: 'sizing_label'},
                },
                {spacer_width: {active: false, type: 'range', value: 'auto', units: '%', unit_options: ['px', '%'],  max: 2400, min: 0, parentlabel: 'sizing_label'},
                },
                {spacer_max_height: {active: false, type: 'range', value: 'auto', units: '%', unit_options: ['px', '%'],  max: 2400, min: 0, parentlabel: 'sizing_label'},
                },
                {spacer_max_width: {active: false, type: 'range', value: 'auto', units: '%', unit_options: ['px', '%'],  max: 2400, min: 0, parentlabel: 'sizing_label'},
                },
                {spacer_background_colour: {
                    active: false,
                    value: '#000000',
                    type: 'color'
                },
                },*/
              ],
              widgetstyles: '',
              editable: 0,
              id: '',
        },
        {
              widgetname: 'Product: Title Block',
              widgettype: 'product-title-block',
              widgetresource: 'product',
              widgetplaceholder: '<p class="mb-2 text-muted font-size-14">REFERENCE: FKER0001</p><h1 class="text-capitalize mb-3">Emerald Cut Sapphire and Diamond Ring</h1>',
              widgetdescription: 'Product title, reference and review',
              widgeticon: 'mdi mdi-view-grid-plus-outline',
              widgetcontent: [
                /*{spacer_height:  {value: 30, units: 'px'},},
                {spacer_width:  {value: 100, units: '%'},},
                {spacer_max_height:  {value: 30, units: 'px'},},
                {spacer_max_width:  {value: 100, units: '%'},},
                {spacer_background_colour: {value: '', units: ''},},*/
              ],
              widgetconfigs: [

                /*{sizing_label: {active: false, type: 'label', text: 'Spacer Options', parentname: 'alignment_label'},                
                },
                {spacer_height: {active: false, type: 'range', value: 'auto', units: '%', unit_options: ['px', '%'],  max: 2400, min: 0, parentlabel: 'sizing_label'},
                },
                {spacer_width: {active: false, type: 'range', value: 'auto', units: '%', unit_options: ['px', '%'],  max: 2400, min: 0, parentlabel: 'sizing_label'},
                },
                {spacer_max_height: {active: false, type: 'range', value: 'auto', units: '%', unit_options: ['px', '%'],  max: 2400, min: 0, parentlabel: 'sizing_label'},
                },
                {spacer_max_width: {active: false, type: 'range', value: 'auto', units: '%', unit_options: ['px', '%'],  max: 2400, min: 0, parentlabel: 'sizing_label'},
                },
                {spacer_background_colour: {
                    active: false,
                    value: '#000000',
                    type: 'color'
                },
                },*/
              ],
              widgetstyles: '',
              editable: 0,
              id: '',
        },
        {
              widgetname: 'Product: Short Description',
              widgettype: 'product-short-desc',
              widgetresource: 'product',
              widgetplaceholder: '<p  class="mt-3"><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p></p>',
              widgetdescription: '',
              widgeticon: 'mdi mdi-view-grid-plus-outline',
              widgetcontent: [
                /*{spacer_height:  {value: 30, units: 'px'},},
                {spacer_width:  {value: 100, units: '%'},},
                {spacer_max_height:  {value: 30, units: 'px'},},
                {spacer_max_width:  {value: 100, units: '%'},},
                {spacer_background_colour: {value: '', units: ''},},*/
              ],
              widgetconfigs: [

                /*{sizing_label: {active: false, type: 'label', text: 'Spacer Options', parentname: 'alignment_label'},                
                },
                {spacer_height: {active: false, type: 'range', value: 'auto', units: '%', unit_options: ['px', '%'],  max: 2400, min: 0, parentlabel: 'sizing_label'},
                },
                {spacer_width: {active: false, type: 'range', value: 'auto', units: '%', unit_options: ['px', '%'],  max: 2400, min: 0, parentlabel: 'sizing_label'},
                },
                {spacer_max_height: {active: false, type: 'range', value: 'auto', units: '%', unit_options: ['px', '%'],  max: 2400, min: 0, parentlabel: 'sizing_label'},
                },
                {spacer_max_width: {active: false, type: 'range', value: 'auto', units: '%', unit_options: ['px', '%'],  max: 2400, min: 0, parentlabel: 'sizing_label'},
                },
                {spacer_background_colour: {
                    active: false,
                    value: '#000000',
                    type: 'color'
                },
                },*/
              ],
              widgetstyles: '',
              editable: 0,
              id: '',
        },
         {
              widgetname: 'Product: Description',
              widgettype: 'product-desc',
              widgetresource: 'product',
              widgetplaceholder: '<p  class="mt-3"><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p></p>',
              widgetdescription: '',
              widgeticon: 'mdi mdi-view-grid-plus-outline',
              widgetcontent: [
                /*{spacer_height:  {value: 30, units: 'px'},},
                {spacer_width:  {value: 100, units: '%'},},
                {spacer_max_height:  {value: 30, units: 'px'},},
                {spacer_max_width:  {value: 100, units: '%'},},
                {spacer_background_colour: {value: '', units: ''},},*/
              ],
              widgetconfigs: [

                /*{sizing_label: {active: false, type: 'label', text: 'Spacer Options', parentname: 'alignment_label'},                
                },
                {spacer_height: {active: false, type: 'range', value: 'auto', units: '%', unit_options: ['px', '%'],  max: 2400, min: 0, parentlabel: 'sizing_label'},
                },
                {spacer_width: {active: false, type: 'range', value: 'auto', units: '%', unit_options: ['px', '%'],  max: 2400, min: 0, parentlabel: 'sizing_label'},
                },
                {spacer_max_height: {active: false, type: 'range', value: 'auto', units: '%', unit_options: ['px', '%'],  max: 2400, min: 0, parentlabel: 'sizing_label'},
                },
                {spacer_max_width: {active: false, type: 'range', value: 'auto', units: '%', unit_options: ['px', '%'],  max: 2400, min: 0, parentlabel: 'sizing_label'},
                },
                {spacer_background_colour: {
                    active: false,
                    value: '#000000',
                    type: 'color'
                },
                },*/
              ],
              widgetstyles: '',
              editable: 0,
              id: '',
        },
         {
              widgetname: 'Product: Features Block',
              widgettype: 'product-features',
              widgetresource: 'product',
              widgetplaceholder: '<div class="list-group list-group list-group-flush"><div><li class="list-group-item p-0 d-flex py-3"><span class="my-auto pl-4 w-25"><div>Metal</div></span> <span class="w-25">Silver</span> <span class="my-auto pl-4 w-50 d-flex"><span class="ml-auto">14ct</span></span></li></div><div><li class="list-group-item p-0 d-flex py-3"><span class="my-auto pl-4 w-25"><div>Gemstone</div></span> <span class="w-25"><!---->Sapphire</span> <span class="my-auto pl-4 w-50 d-flex"><span class="ml-auto">21ct</span></span></li></div><div><li class="list-group-item p-0 d-flex py-3"><span class="my-auto pl-4 w-25"><div>Chain</div></span> <span class="w-25">18mm Thick</span> <span class="my-auto pl-4 w-50 d-flex"><span class="ml-auto">14cm</span></span></li></div><div><li class="list-group-item p-0 d-flex py-3"><span class="my-auto pl-4 w-25"><div>Setting</div></span> <span class="w-25"><!---->Claw</span> <span class="my-auto pl-4 w-50 d-flex"><span class="ml-auto">10cm</span></span></li></div></div>',
              widgetdescription: '',
              widgeticon: 'mdi mdi-view-grid-plus-outline',
              widgetcontent: [
                /*{spacer_height:  {value: 30, units: 'px'},},
                {spacer_width:  {value: 100, units: '%'},},
                {spacer_max_height:  {value: 30, units: 'px'},},
                {spacer_max_width:  {value: 100, units: '%'},},
                {spacer_background_colour: {value: '', units: ''},},*/
              ],
              widgetconfigs: [

                /*{sizing_label: {active: false, type: 'label', text: 'Spacer Options', parentname: 'alignment_label'},                
                },
                {spacer_height: {active: false, type: 'range', value: 'auto', units: '%', unit_options: ['px', '%'],  max: 2400, min: 0, parentlabel: 'sizing_label'},
                },
                {spacer_width: {active: false, type: 'range', value: 'auto', units: '%', unit_options: ['px', '%'],  max: 2400, min: 0, parentlabel: 'sizing_label'},
                },
                {spacer_max_height: {active: false, type: 'range', value: 'auto', units: '%', unit_options: ['px', '%'],  max: 2400, min: 0, parentlabel: 'sizing_label'},
                },
                {spacer_max_width: {active: false, type: 'range', value: 'auto', units: '%', unit_options: ['px', '%'],  max: 2400, min: 0, parentlabel: 'sizing_label'},
                },
                {spacer_background_colour: {
                    active: false,
                    value: '#000000',
                    type: 'color'
                },
                },*/
              ],
              widgetstyles: '',
              editable: 0,
              id: '',
        },
        {
              widgetname: 'Product: Price Block',
              widgettype: 'product-price',
              widgetresource: 'product',
              widgetplaceholder: '<h4 class="font-size-28 mb-4">£1200.00</h4>',
              widgetdescription: '',
              widgeticon: 'mdi mdi-view-grid-plus-outline',
              widgetcontent: [
                /*{spacer_height:  {value: 30, units: 'px'},},
                {spacer_width:  {value: 100, units: '%'},},
                {spacer_max_height:  {value: 30, units: 'px'},},
                {spacer_max_width:  {value: 100, units: '%'},},
                {spacer_background_colour: {value: '', units: ''},},*/
              ],
              widgetconfigs: [

                /*{sizing_label: {active: false, type: 'label', text: 'Spacer Options', parentname: 'alignment_label'},                
                },
                {spacer_height: {active: false, type: 'range', value: 'auto', units: '%', unit_options: ['px', '%'],  max: 2400, min: 0, parentlabel: 'sizing_label'},
                },
                {spacer_width: {active: false, type: 'range', value: 'auto', units: '%', unit_options: ['px', '%'],  max: 2400, min: 0, parentlabel: 'sizing_label'},
                },
                {spacer_max_height: {active: false, type: 'range', value: 'auto', units: '%', unit_options: ['px', '%'],  max: 2400, min: 0, parentlabel: 'sizing_label'},
                },
                {spacer_max_width: {active: false, type: 'range', value: 'auto', units: '%', unit_options: ['px', '%'],  max: 2400, min: 0, parentlabel: 'sizing_label'},
                },
                {spacer_background_colour: {
                    active: false,
                    value: '#000000',
                    type: 'color'
                },
                },*/
              ],
              widgetstyles: '',
              editable: 0,
              id: '',
        },
        {
              widgetname: 'Product: Cart Button',
              widgettype: 'product-cart-button',
              widgetresource: 'product',
              widgetplaceholder: '<div><h5 class="text-uppercase font-size-12 text-underline spaced-title mt-2 pt-3">Select Customisation Options</h5> <div class="w-100"><a href="javascript:;"><div class="card border-radius-1em border shadow-none text-dark"><div class="card-body"><div class="row"><div class="col-md-3"><span>Metal</span> <span>Silver</span> 14<span>ct</span></div><div class="col-md-3"><span>Setting</span> <span>Fishtail</span> 10<span>cm</span></div> <div class="d-flex col-md-12"><span class="badge badge-light bg-light ml-auto mt-2 font-size-14"><span>+</span><span>£</span>100.0000</span></div></div></div></div></a></div></div><div class="d-flex mb-2"><button id="tooltip-add" type="button" disabled="disabled" class="btn btn btn-light font-size-16 btn-rounded w-25 mr-1 my-auto btn--light disabled"><i class="mdi mdi-minus"></i></button> <fieldset class="form-group w-50 my-auto mx-1" id="__BVID__787"><div><input type="number" class="form-control form-control-lg" id="__BVID__788"></div></fieldset> <button type="button" class="btn btn btn-light font-size-16 btn-rounded w-25 my-auto m1-1 btn--light"><i class="mdi mdi-plus"></i></button></div><div class="d-flex"><button type="button" class="btn btn-rounded btn-block w-100 text-white btn-lg btn-peach">Add to Cart</button></div>',
              widgetdescription: '',
              widgeticon: 'mdi mdi-view-grid-plus-outline',
              widgetcontent: [
                /*{spacer_height:  {value: 30, units: 'px'},},
                {spacer_width:  {value: 100, units: '%'},},
                {spacer_max_height:  {value: 30, units: 'px'},},
                {spacer_max_width:  {value: 100, units: '%'},},
                {spacer_background_colour: {value: '', units: ''},},*/
              ],
              widgetconfigs: [

                /*{sizing_label: {active: false, type: 'label', text: 'Spacer Options', parentname: 'alignment_label'},                
                },
                {spacer_height: {active: false, type: 'range', value: 'auto', units: '%', unit_options: ['px', '%'],  max: 2400, min: 0, parentlabel: 'sizing_label'},
                },
                {spacer_width: {active: false, type: 'range', value: 'auto', units: '%', unit_options: ['px', '%'],  max: 2400, min: 0, parentlabel: 'sizing_label'},
                },
                {spacer_max_height: {active: false, type: 'range', value: 'auto', units: '%', unit_options: ['px', '%'],  max: 2400, min: 0, parentlabel: 'sizing_label'},
                },
                {spacer_max_width: {active: false, type: 'range', value: 'auto', units: '%', unit_options: ['px', '%'],  max: 2400, min: 0, parentlabel: 'sizing_label'},
                },
                {spacer_background_colour: {
                    active: false,
                    value: '#000000',
                    type: 'color'
                },
                },*/
              ],
              widgetstyles: '',
              editable: 0,
              id: '',
        },
        {
              widgetname: 'Product: Image Gallery',
              widgettype: 'product-image-gallery',
              widgetresource: 'product',
              widgetplaceholder: '<div  class="px-3 overflow-hidden w-100"><a  class="position-relative d-block"><img  src="/images/product-placeholder.png" class="img-fluid w-100 border mb-3"> <!----></a> <div  class="swiper-container swiper-initialized swiper-horizontal swiper-pointer-events"><div class="swiper-wrapper" style="transform: translate3d(0px, 0px, 0px);"><div class="h-100 swiper-slide swiper-slide-active" style="width: 140.8px; margin-right: 10px;"><img src="/images/product-placeholder.png" class="border-radius-1em border img-fluid"></div><div class="h-100 swiper-slide swiper-slide-active" style="width: 140.8px; margin-right: 10px;"><img src="/images/product-placeholder.png" class="border-radius-1em border img-fluid"></div><div class="h-100 swiper-slide swiper-slide-active" style="width: 140.8px; margin-right: 10px;"><img src="/images/product-placeholder.png" class="border-radius-1em border img-fluid"></div><div class="h-100 swiper-slide swiper-slide-active" style="width: 140.8px; margin-right: 10px;"><img src="/images/product-placeholder.png" class="border-radius-1em border img-fluid"></div></div></div></div>',
              widgetdescription: '',
              widgeticon: 'mdi mdi-view-grid-plus-outline',
              widgetcontent: [
                /*{spacer_height:  {value: 30, units: 'px'},},
                {spacer_width:  {value: 100, units: '%'},},
                {spacer_max_height:  {value: 30, units: 'px'},},
                {spacer_max_width:  {value: 100, units: '%'},},
                {spacer_background_colour: {value: '', units: ''},},*/
              ],
              widgetconfigs: [

                /*{sizing_label: {active: false, type: 'label', text: 'Spacer Options', parentname: 'alignment_label'},                
                },
                {spacer_height: {active: false, type: 'range', value: 'auto', units: '%', unit_options: ['px', '%'],  max: 2400, min: 0, parentlabel: 'sizing_label'},
                },
                {spacer_width: {active: false, type: 'range', value: 'auto', units: '%', unit_options: ['px', '%'],  max: 2400, min: 0, parentlabel: 'sizing_label'},
                },
                {spacer_max_height: {active: false, type: 'range', value: 'auto', units: '%', unit_options: ['px', '%'],  max: 2400, min: 0, parentlabel: 'sizing_label'},
                },
                {spacer_max_width: {active: false, type: 'range', value: 'auto', units: '%', unit_options: ['px', '%'],  max: 2400, min: 0, parentlabel: 'sizing_label'},
                },
                {spacer_background_colour: {
                    active: false,
                    value: '#000000',
                    type: 'color'
                },
                },*/
              ],
              widgetstyles: '',
              editable: 0,
              id: '',
        },
         {
              widgetname: 'Product: Reviews Block',
              widgettype: 'product-reviews',
              widgetresource: 'product',
              widgetplaceholder: '',
              widgetdescription: '',
              widgeticon: 'mdi mdi-view-grid-plus-outline',
              widgetcontent: [
                /*{spacer_height:  {value: 30, units: 'px'},},
                {spacer_width:  {value: 100, units: '%'},},
                {spacer_max_height:  {value: 30, units: 'px'},},
                {spacer_max_width:  {value: 100, units: '%'},},
                {spacer_background_colour: {value: '', units: ''},},*/
              ],
              widgetconfigs: [

                /*{sizing_label: {active: false, type: 'label', text: 'Spacer Options', parentname: 'alignment_label'},                
                },
                {spacer_height: {active: false, type: 'range', value: 'auto', units: '%', unit_options: ['px', '%'],  max: 2400, min: 0, parentlabel: 'sizing_label'},
                },
                {spacer_width: {active: false, type: 'range', value: 'auto', units: '%', unit_options: ['px', '%'],  max: 2400, min: 0, parentlabel: 'sizing_label'},
                },
                {spacer_max_height: {active: false, type: 'range', value: 'auto', units: '%', unit_options: ['px', '%'],  max: 2400, min: 0, parentlabel: 'sizing_label'},
                },
                {spacer_max_width: {active: false, type: 'range', value: 'auto', units: '%', unit_options: ['px', '%'],  max: 2400, min: 0, parentlabel: 'sizing_label'},
                },
                {spacer_background_colour: {
                    active: false,
                    value: '#000000',
                    type: 'color'
                },
                },*/
              ],
              widgetstyles: '',
              editable: 0,
              id: '',
        },
         {
              widgetname: 'Product: Related Products',
              widgettype: 'product-related',
              widgetresource: 'product',
              widgetplaceholder: '<div class="row"><div class="col-md-3"><div class="card border-radius-1em border shadow-none"><img src="/images/product-placeholder.png" class="card-img"> <div class="card-text p-4 peach-border-top-5 d-flex flex-column"><h3 class="font-size-18 my-auto py-2">The Gold and Diamond Sideways Cross Necklace</h3> <p class="text-dark mb-0 paragraph-truncate-line2">The Sideways Cross Necklace is one of our most popular designs and now we’ve given it an update with a splash of sparkling diamonds. Our Gold and Diamond Sideways Cross Necklace is available in 9ct rose gold, 9ct yellow gold and 9ct white gold, set with 0.14 carats of white diamonds that are expertly micro-set.</p> <div class="d-flex"><span class="badge badge-light text-dark bg-light font-size-14 my-2">15000.00</span></div></div></div></div><div class="col-md-3"><div class="card border-radius-1em border shadow-none"><img src="/images/product-placeholder.png" class="card-img"> <div class="card-text p-4 peach-border-top-5 d-flex flex-column"><h3 class="font-size-18 my-auto py-2">The Gold and Diamond Sideways Cross Necklace</h3> <p class="text-dark mb-0 paragraph-truncate-line2">The Sideways Cross Necklace is one of our most popular designs and now we’ve given it an update with a splash of sparkling diamonds. Our Gold and Diamond Sideways Cross Necklace is available in 9ct rose gold, 9ct yellow gold and 9ct white gold, set with 0.14 carats of white diamonds that are expertly micro-set.</p> <div class="d-flex"><span class="badge badge-light text-dark bg-light font-size-14 my-2">15000.00</span></div></div></div></div><div class="col-md-3"><div class="card border-radius-1em border shadow-none"><img src="/images/product-placeholder.png" class="card-img"> <div class="card-text p-4 peach-border-top-5 d-flex flex-column"><h3 class="font-size-18 my-auto py-2">The Gold and Diamond Sideways Cross Necklace</h3> <p class="text-dark mb-0 paragraph-truncate-line2">The Sideways Cross Necklace is one of our most popular designs and now we’ve given it an update with a splash of sparkling diamonds. Our Gold and Diamond Sideways Cross Necklace is available in 9ct rose gold, 9ct yellow gold and 9ct white gold, set with 0.14 carats of white diamonds that are expertly micro-set.</p> <div class="d-flex"><span class="badge badge-light text-dark bg-light font-size-14 my-2">15000.00</span></div></div></div></div><div class="col-md-3"><div class="card border-radius-1em border shadow-none"><img src="/images/product-placeholder.png" class="card-img"> <div class="card-text p-4 peach-border-top-5 d-flex flex-column"><h3 class="font-size-18 my-auto py-2">The Gold and Diamond Sideways Cross Necklace</h3> <p class="text-dark mb-0 paragraph-truncate-line2">The Sideways Cross Necklace is one of our most popular designs and now we’ve given it an update with a splash of sparkling diamonds. Our Gold and Diamond Sideways Cross Necklace is available in 9ct rose gold, 9ct yellow gold and 9ct white gold, set with 0.14 carats of white diamonds that are expertly micro-set.</p> <div class="d-flex"><span class="badge badge-light text-dark bg-light font-size-14 my-2">15000.00</span></div></div></div></div></div>',
              widgetdescription: '',
              widgeticon: 'mdi mdi-view-grid-plus-outline',
              widgetcontent: [
                /*{spacer_height:  {value: 30, units: 'px'},},
                {spacer_width:  {value: 100, units: '%'},},
                {spacer_max_height:  {value: 30, units: 'px'},},
                {spacer_max_width:  {value: 100, units: '%'},},
                {spacer_background_colour: {value: '', units: ''},},*/
              ],
              widgetconfigs: [

                /*{sizing_label: {active: false, type: 'label', text: 'Spacer Options', parentname: 'alignment_label'},                
                },
                {spacer_height: {active: false, type: 'range', value: 'auto', units: '%', unit_options: ['px', '%'],  max: 2400, min: 0, parentlabel: 'sizing_label'},
                },
                {spacer_width: {active: false, type: 'range', value: 'auto', units: '%', unit_options: ['px', '%'],  max: 2400, min: 0, parentlabel: 'sizing_label'},
                },
                {spacer_max_height: {active: false, type: 'range', value: 'auto', units: '%', unit_options: ['px', '%'],  max: 2400, min: 0, parentlabel: 'sizing_label'},
                },
                {spacer_max_width: {active: false, type: 'range', value: 'auto', units: '%', unit_options: ['px', '%'],  max: 2400, min: 0, parentlabel: 'sizing_label'},
                },
                {spacer_background_colour: {
                    active: false,
                    value: '#000000',
                    type: 'color'
                },
                },*/
              ],
              widgetstyles: '',
              editable: 0,
              id: '',
        },
         {
              widgetname: 'Product: Recently Viewed',
              widgettype: 'product-recentely-viewed',
              widgetresource: 'product',
              widgetplaceholder: '<div class="row"><div class="col-md-3"><div class="card border-radius-1em border shadow-none"><img src="/images/product-placeholder.png" class="card-img"> <div class="card-text p-4 peach-border-top-5 d-flex flex-column"><h3 class="font-size-18 my-auto py-2">The Gold and Diamond Sideways Cross Necklace</h3> <p class="text-dark mb-0 paragraph-truncate-line2">The Sideways Cross Necklace is one of our most popular designs and now we’ve given it an update with a splash of sparkling diamonds. Our Gold and Diamond Sideways Cross Necklace is available in 9ct rose gold, 9ct yellow gold and 9ct white gold, set with 0.14 carats of white diamonds that are expertly micro-set.</p> <div class="d-flex"><span class="badge badge-light text-dark bg-light font-size-14 my-2">15000.00</span></div></div></div></div><div class="col-md-3"><div class="card border-radius-1em border shadow-none"><img src="/images/product-placeholder.png" class="card-img"> <div class="card-text p-4 peach-border-top-5 d-flex flex-column"><h3 class="font-size-18 my-auto py-2">The Gold and Diamond Sideways Cross Necklace</h3> <p class="text-dark mb-0 paragraph-truncate-line2">The Sideways Cross Necklace is one of our most popular designs and now we’ve given it an update with a splash of sparkling diamonds. Our Gold and Diamond Sideways Cross Necklace is available in 9ct rose gold, 9ct yellow gold and 9ct white gold, set with 0.14 carats of white diamonds that are expertly micro-set.</p> <div class="d-flex"><span class="badge badge-light text-dark bg-light font-size-14 my-2">15000.00</span></div></div></div></div><div class="col-md-3"><div class="card border-radius-1em border shadow-none"><img src="/images/product-placeholder.png" class="card-img"> <div class="card-text p-4 peach-border-top-5 d-flex flex-column"><h3 class="font-size-18 my-auto py-2">The Gold and Diamond Sideways Cross Necklace</h3> <p class="text-dark mb-0 paragraph-truncate-line2">The Sideways Cross Necklace is one of our most popular designs and now we’ve given it an update with a splash of sparkling diamonds. Our Gold and Diamond Sideways Cross Necklace is available in 9ct rose gold, 9ct yellow gold and 9ct white gold, set with 0.14 carats of white diamonds that are expertly micro-set.</p> <div class="d-flex"><span class="badge badge-light text-dark bg-light font-size-14 my-2">15000.00</span></div></div></div></div><div class="col-md-3"><div class="card border-radius-1em border shadow-none"><img src="/images/product-placeholder.png" class="card-img"> <div class="card-text p-4 peach-border-top-5 d-flex flex-column"><h3 class="font-size-18 my-auto py-2">The Gold and Diamond Sideways Cross Necklace</h3> <p class="text-dark mb-0 paragraph-truncate-line2">The Sideways Cross Necklace is one of our most popular designs and now we’ve given it an update with a splash of sparkling diamonds. Our Gold and Diamond Sideways Cross Necklace is available in 9ct rose gold, 9ct yellow gold and 9ct white gold, set with 0.14 carats of white diamonds that are expertly micro-set.</p> <div class="d-flex"><span class="badge badge-light text-dark bg-light font-size-14 my-2">15000.00</span></div></div></div></div></div>',
              widgetdescription: '',
              widgeticon: 'mdi mdi-view-grid-plus-outline',
              widgetcontent: [
                /*{spacer_height:  {value: 30, units: 'px'},},
                {spacer_width:  {value: 100, units: '%'},},
                {spacer_max_height:  {value: 30, units: 'px'},},
                {spacer_max_width:  {value: 100, units: '%'},},
                {spacer_background_colour: {value: '', units: ''},},*/
              ],
              widgetconfigs: [

                /*{sizing_label: {active: false, type: 'label', text: 'Spacer Options', parentname: 'alignment_label'},                
                },
                {spacer_height: {active: false, type: 'range', value: 'auto', units: '%', unit_options: ['px', '%'],  max: 2400, min: 0, parentlabel: 'sizing_label'},
                },
                {spacer_width: {active: false, type: 'range', value: 'auto', units: '%', unit_options: ['px', '%'],  max: 2400, min: 0, parentlabel: 'sizing_label'},
                },
                {spacer_max_height: {active: false, type: 'range', value: 'auto', units: '%', unit_options: ['px', '%'],  max: 2400, min: 0, parentlabel: 'sizing_label'},
                },
                {spacer_max_width: {active: false, type: 'range', value: 'auto', units: '%', unit_options: ['px', '%'],  max: 2400, min: 0, parentlabel: 'sizing_label'},
                },
                {spacer_background_colour: {
                    active: false,
                    value: '#000000',
                    type: 'color'
                },
                },*/
              ],
              widgetstyles: '',
              editable: 0,
              id: '',
        },
    ];


const webPageWidgets = [
            {
              widgetname: 'Menu',
              widgettype: 'menu',
              widgeticon: 'bx bx-menu',
              widgetcontent: [
                {config: {
                  view: 'horizontal',
                  view_options: ['horizontal', 'vertical'],
                  layout: 'logo left', 
                  layouts: ['logo left', 'logo right', 'logo center'],
                  info_bar: false,
                  default_company_logo: true, 
                  logo: '',
                  logo_width: 150,
                  size: {type: 'cols', xl: 4, lg: 4, md: 4, sm: 12, xs: 12 },
                  
                    },
                },
                {
                list: [],
                },
                {url: {value: '', units: ''},
                },
                {width: {value: 'auto', units: '%'},
                },
                {height: {value: 'auto', units: '%'},
                },
                {max_width: {value: 'auto', units: '%'},
                },
                {max_height: {value: 'auto', units: '%'},
                },
                {text_align: {value: 'text-left', units: ''},
                },
                {fullwidth: {value: false, units: ''},
                },
                {view: {value: false, units: ''},
                },
                {layout: {value: 'Layout 1', units: ''},
                },
                {layout_colour: {value: 'Light', units: ''},
                },
                {custom_colour: {
                  value: false,
                  units: '',
                },
                },
                {topbar_colour: {value: '', units: ''},
                },
                {topbar_text_colour: {value: '', units: ''}, 
                },
                {bottombar_colour: {value: '', units: ''},
                },
                {bottombar_text_colour: {value: '', units: ''},
                },
                {layout_alignment: {value: 'horizontal', units: ''},
                },
                {logo_position: {value: 'logo left', units: ''},
                },
                //custom_logo: {value: false, units: ''},
                {logo: {
                        active: true,
                        width: {value: 'auto', units: ''},
                        height: {value: 65, units: ''},
                        value: '/',
                        units: '',
                        subfields: [
                          {width: {active: false, type: 'range', value: 'auto', units: '%', unit_options: ['px', '%'], max: 100, min: 0, parentlabel: 'imgsize_label'},
                          },
                          {height: {active: false, type: 'range', value: 'auto', units: '%', unit_options: ['px', '%'], max: 100, min: 0, parentlabel: 'imgsize_label'},
                          }
                        ]
                      },
                  },
                {menu_text: viewOptionDefaultValues.font2},
                {dropdown_text: viewOptionDefaultValues.font2},
              ],
              widgetconfigs: [
                  {layout_label: {active: false, type: 'label', text: 'Layout Options', parentname: 'background_label'},
                  },
                  {fullwidth: {active: false, type: 'radiogroup', isButton: true, value: false, options: [true, false]},
                  },
                  {layout: {active: false, type: 'radiogroup', isButton: true, value: false, options: ['Layout 1', 'Layout 2']},
                  },
                  {layout_colour: {active: false, type: 'radiogroup', isButton: true, value: false, options: ['Light', 'Dark']},
                  },
                  {custom_colour: {active: false, type: 'radiogroup', isButton: true, value: false, options: [true, false]},
                  },
                  {custom_colour_label: {active: false, type: 'label', text: 'Select Custom Colors', parentname: 'imgsize_label', dependentOn: {field: 'custom_colour', value: true}},
                  },
                  {topbar_colour: {
                            active: false,
                            value: '#000000',
                            type: 'color',
                            dependentOn: {field: 'custom_colour', value: true},
                          },
                  },
                  {topbar_text_colour: {
                            active: false,
                            value: '#000000',
                            type: 'color',
                            dependentOn: {field: 'custom_colour', value: true},
                          },
                  },
                  {bottombar_colour: {
                            active: false,
                            value: '#000000',
                            type: 'color',
                            dependentOn: {field: 'custom_colour', value: true},
                          },
                  },
                  {bottombar_text_colour: {
                            active: false,
                            value: '#000000',
                            type: 'color',
                            dependentOn: {field: 'custom_colour', value: true},
                          },
                  },
                  {layout_alignment: {active: false, type: 'radiogroup', isButton: true, value: false, options: ['horizontal', 'vertical']},
                  },
                  {logo_position: {active: false, type: 'radiogroup', isButton: true, value: false, options: ['logo left', 'logo right', 'logo center']},
                  //custom_logo: {active: false, type: 'radiogroup', isButton: true, value: false, options: [true, false]},
                  },
                  {logo: {
                        active: true,
                        custom_size: 100,
                        image_repeat_options: ['repeat','repeat-x','repeat-y','no-repeat','initial','inherit'],
                        image_size_options: ['auto', 'contain', 'cover', 'custom'],
                        image_position_options: ['top right', 'top left', 'top center', 'center right', 'center left', 'center center', 'bottom right', 'bottom left', 'bottom center'],
                        type: 'image',
                        value: '',
                        subfields: [
                          {imgsize_label: {active: false, type: 'label', text: 'Image Size', parentname: 'imgsize_label'},
                          },
                          {width: {active: false, type: 'range', value: 'auto', units: '%', unit_options: ['px', '%'], max: 100, min: 0, parentlabel: 'imgsize_label'},
                          },
                          {height: {active: false, type: 'range', value: 'auto', units: '%', unit_options: ['px', '%'], max: 100, min: 0, parentlabel: 'imgsize_label'},
                          }
                        ]
                      },
                  },
                 {menu_label: {active: false, type: 'label', text: 'Menu Text Options', parentname: 'background_label'},
                 },
                 {menu_text: viewOptionConfigs.font2},
                 {dropdown_label: {active: false, type: 'label', text: 'Dropdown Text Options', parentname: 'background_label'}},
                 {dropdown_text: viewOptionConfigs.font2},
                ],
              widgetstyles: '',
              widgetfilters: {
                    filter: {menus: {active: true, switchHidden: true, type: 'customselect', options: []}},
                    active_filters: {menus: {active: true, switchHidden: true, type: 'customselect', options: []}},
              },
              widgetelements: {
                    active_elements:  viewOptionDefaultValues.show_elements.menu,
                    elements: viewOptionConfigs.show_elements.menu.subfields,
              },
              editable: 0,
              id: '',
            },
            {
              widgetname: 'Image',
              widgettype: 'image',
              widgeticon: 'bx bx-image',
              widgetcontent: [
                {url: {value: '', units: ''},},
                {width: {value: 100, units: '%'},},
                {height: {value: 100, units: '%'},},
                {max_width: {value: 100, units: '%'},},
                {max_height: {value: 100, units: '%'},},
                {text_align: {value: 'text-left', units: ''},},
                {fullwidth: {value: false, units: ''},},
              ],
              widgetconfigs: [
                {background_label: {active: false, type: 'label', text: 'Image Options', parentname: 'background_label'},},
                {fullwidth: {active: false, type: 'radiogroup', isButton: true, value: false, options: [true, false]},},
                {width: {active: false, type: 'range', value: 'auto', units: '%', unit_options: ['px', '%'],  max: 2400, min: 0, parentlabel: 'sizing_label'},},
                {max_width: {active: false, type: 'range', value: 'auto', units: '%', unit_options: ['px', '%'],  max: 2400, min: 0, parentlabel: 'sizing_label'},},
                {height: {active: false, type: 'range', value: 'auto', units: '%', unit_options: ['px', '%'],  max: 2400, min: 0, parentlabel: 'sizing_label'},},
                {max_height: {active: false, type: 'range', value: 'auto', units: '%', unit_options: ['px', '%'],  max: 2400, min: 0, parentlabel: 'sizing_label'}, },
                {alignment_label: {active: false, type: 'label', text: 'Content Alignment', parentname: 'alignment_label'},},
                {text_align: {active: false, type: 'radiogroup', isButton: true, value: 'text-left', options: ['text-left', 'text-center', 'text-right']},},
              ],
              widgetstyles: '',
              editable: 0,
              id: '',
            },
            {
              widgetname: 'Image Gallery',
              widgettype: 'imagegallery',
              widgeticon: 'bx bx-images',
              widgetcontent: [
                {config: {
                  view: 'grid',
                  view_options: ['grid', 'list', 'carousel'],
              		columns: '',
                  gutters: '',
                  size: {type: 'cols', xl: 4, lg: 4, md: 4, sm: 12, xs: 12 },
                  column_templates: {
                    one_column:  {type: 'cols', xl: 12, lg: 12, md: 12, sm: 12, xs: 12 },
                    two_columns:  {type: 'cols', xl: 6, lg: 6, md: 6, sm: 12, xs: 12 },
                    three_columns:  {type: 'cols', xl: 4, lg: 4, md: 4, sm: 12, xs: 12 },
                    four_columns:  {type: 'cols', xl: 3, lg: 3, md: 3, sm: 6, xs: 12 },
                  }
              	},
              },
            {
                list: [],
            },
            {
                list_item: {
                	title: 'Slide',
                	description: '',
                	type: '',
                	imageUrl: '',
                	backgroundColor: '',
                	button: false,
                	buttonText: 'Click Me',
                	buttonUrl: '',
                	slideLinked: '',
                	styles: '',
                },
            },
            {lightbox: {value: false, units: ''},},
                {columns: viewOptionDefaultValues.columns,},
                {column: viewOptionDefaultValues.column,},
                {view: {active: false, value: 'grid', units: ''},},
                {text_align: {value: 'text-left', units: ''},},
                {fullwidth: {value: false, units: ''},},
                {image_width: {value: 'auto', units: '%'},},
                {image_height: {value: 'auto', units: '%'},},
                {image_max_width: {value: 'auto', units: '%'},},
                {image_max_height: {value: 'auto', units: '%'},},
                {image_padding: {
                    active: false,
                    type: 'numbergroup',
                    parentlabel: '',
                    left: null,
                    right: null,
                    top: null,
                    bottom: null, 
                },},
                {image_margin: {
                    active: false,
                    type: 'numbergroup',
                    parentlabel: '',
                    left: null,
                    right: null,
                    top: null,
                    bottom: null,
                },},
                {image_border_label: {active: false, type: 'label', text: 'Borders', parentname: 'border_label'},
                },
                {image_border_style: {
                      active: false, type: 'select', value: '', options: ['dotted','dashed','solid','double','groove','ridge','inset','outset','none','hidden']
                },
                },
                {image_border: {
                    active: true,
                    type: 'numbergroup',
                    parentlabel: '',
                    left: 0,
                    right: 0,
                    top: 0,
                    bottom: 0,
                },  
                },
                {image_border_colour: {
                    active: false,
                    value: '#000000',
                    type: 'color'
                  },
                },
                {image_border_radius: {
                    active: false,
                    type: 'numbergroup',
                    parentlabel: '',
                    top_left: null,
                    top_right: null,
                    bottom_left: null,
                    bottom_right: null,
                },},
                {carousel: viewOptionDefaultValues.carousel,},
                {masonry: viewOptionDefaultValues.masonry,},
                {list_item_raw: {},},
                {list_index: 0,},
              ],
              widgetconfigs: [
                  {layout_label: {active: false, type: 'label', text: 'View', parentname: 'spacing_label'},},
                  {lightbox: {active: false, type: 'radiogroup', isButton: true, value: false, options: [true, false]},},
                  {view: {active: false, type: 'select', value: '', options: ['grid', 'list', 'carousel', 'masonry']},},
                  {columns_label: {active: false, type: 'label', text: 'Grid Gallery Settings', parentname: 'spacing_label',  dependentOn: {field: 'view', value: 'grid'}},},
                  {columns: viewOptionConfigs.columns,},
                  {column: viewOptionConfigs.column,},
                  {carousel_label: {active: false, type: 'label', text: 'Carousel Gallery Settings', parentname: 'border_label', dependentOn: {field: 'view', value: 'carousel'},},},
                  {carousel: viewOptionConfigs.carousel.default,},
                  {masonry_label: {active: false, type: 'label', text: 'Masonry Gallery Settings', parentname: 'border_label', dependentOn: {field: 'view', value: 'masonry'}},},
                  {masonry: viewOptionConfigs.masonry,},
                  {alignment_label: {active: false, type: 'label', text: 'Image Alignment', parentname: 'alignment_label'},},
                  {text_align: {active: false, type: 'radiogroup', isButton: true, value: 'text-left', options: ['text-left', 'text-center', 'text-right']},},
                  {fullwidth: {active: false, type: 'radiogroup', isButton: true, value: false, options: [true, false]},},
                  {sizing_label: {active: false, type: 'label', text: 'Image Sizing', parentname: 'alignment_label'},},
                  {image_width: {active: false, type: 'range', value: 'auto', units: '%', unit_options: ['px', '%'],  max: 100, min: 0, parentlabel: 'sizing_label'},},
                  {image_max_width: {active: false, type: 'range', value: 'auto', units: '%', unit_options: ['px', '%'],  max: 100, min: 0, parentlabel: 'sizing_label'},},
                  {image_height: {active: false, type: 'range', value: 'auto', units: '%', unit_options: ['px', '%'],  max: 100, min: 0, parentlabel: 'sizing_label'},},
                  {image_max_height: {active: false, type: 'range', value: 'auto', units: '%', unit_options: ['px', '%'],  max: 100, min: 0, parentlabel: 'sizing_label'},},
                  {spacing_label: {active: false, type: 'label', text: 'Image Spacing', parentname: 'alignment_label'},},
                  {image_padding: {
                    active: false,
                    type: 'numbergroup',
                    parentlabel: '',
                    left: null,
                    right: null,
                    top: null,
                    bottom: null, 
                     },
                 },
                  {image_margin: {
                    active: false,
                    type: 'numbergroup',
                    parentlabel: '',
                    left: null,
                    right: null,
                    top: null,
                    bottom: null,
                  },
                  },
                  {image_border_label: {active: false, type: 'label', text: 'Borders', parentname: 'border_label'},
                  },
                  {image_border_style: {
                      active: false, type: 'select', value: '', options: ['dotted','dashed','solid','double','groove','ridge','inset','outset','none','hidden']
                  },
                  },
                  {image_border: {
                    active: true,
                    type: 'numbergroup',
                    parentlabel: '',
                    left: 0,
                    right: 0,
                    top: 0,
                    bottom: 0,
                  },
                  },
                  {image_border_colour: {
                    active: false,
                    value: '#000000',
                    type: 'color'
                  },
                  },
                  {image_border_radius: {
                    active: false,
                    type: 'numbergroup',
                    parentlabel: '',
                    top_left: null,
                    top_right: null,
                    bottom_left: null,
                    bottom_right: null,
                  },
                    },
              ],
              widgetadvancedconfigs: {
                  widgetIdName: '',
                  widgetCssClasses: '',
                  widgetCustomCss: '',
              },
              widgetstyles: '',
              editable: 0,
              id: '',
            },
            {
              widgetname: 'Slider',
              widgettype: 'slider',
              widgeticon: 'bx bx-carousel',
              widgetcontent: [
                {
                    config: {
              		    slider: '',
              	         },
              	},
                {
                    list: [],
                },
                {
                    list_item_raw: {},
                },
                {
                    list_index: 0,
                },
                {layout: {value: 'Layout 1', units: ''},
                },
                {controls: {value: '', units: ''},
                },
                {fade: {value: '', units: ''},
                },
                {indicators: {value: '', units: ''},
                },
                {interval: {value: '', units: ''},
                },
                {button_colour: {
                    active: false,
                    value: '',
                    units: ''
                },
                },
                {button_text_colour: {
                    active: false,
                    value: '',
                    units: ''
                },
                },
                {button_border: {
                    active: true,
                    type: 'numbergroup',
                    parentlabel: '',
                    left: 0,
                    right: 0,
                    top: 0,
                    bottom: 0,
                },  
                },
                {button_border_colour: {
                    active: false,
                    value: '',
                    units: ''
                    },
                },
              ],
              widgetconfigs: [
            
                {layout_label: {active: false, type: 'label', text: 'Layout Options', parentname: 'background_label'},
                },
                {layout: {active: false, type: 'radiogroup', isButton: true, value: false, options: ['Layout 1', 'Layout 2']},
                },
                {controls_label: {active: false, type: 'label', text: 'Slider Controls', parentname: 'border_label'},
                },
                {controls:  {active: false, type: 'radiogroup', isButton: true, value: false, options: [true, false]},
                },
                {fade:  {active: false, type: 'radiogroup', isButton: true, value: false, options: [true, false]},
                },
                {indicators:  {active: false, type: 'radiogroup', isButton: true, value: false, options: [true, false]},
                },
                {interval: {active: false, type: 'range', value: 'auto', units: '', unit_options: ['px'],  max: 5000, min: 0, parentlabel: 'sizing_label'},
                },
                {button_label: {active: false, type: 'label', text: 'Button Styles', parentname: 'border_label'},
                },
                {button_colour: {
                    active: false,
                    value: '#000000',
                    type: 'color'
                },
                },
                {button_text_colour: {
                    active: false,
                    value: '#000000',
                    type: 'color'
                },
                },
                {button_border_style: {
                    active: false, type: 'select', value: '', options: ['dotted','dashed','solid','double','groove','ridge','inset','outset','none','hidden']
                },
                },
                {button_border: {
                    active: true,
                    type: 'numbergroup',
                    parentlabel: '',
                    left: 0,
                    right: 0,
                    top: 0,
                    bottom: 0,
                },  
                },
                {
                    button_border_radius: {
                        active: false,
                        type: 'numbergroup',
                        parentlabel: '',
                        top_left: null,
                        top_right: null,
                        bottom_left: null,
                        bottom_right: null,
                    },
                },
                {
                    button_border_colour: {
                        active: false,
                        value: '#000000',
                        type: 'color'
                    },
                },
              ],
              widgetlistconfigs: {
                list_item: [
                  {title: {type: 'text', value: 'Slide 1'},
                  },
                  {description: {type: 'textarea', value: 'Slide 1'},
                  },
                  {image: {type: 'image'},
                  },
                  {
                    background_colour: {
                        active: false,
                        value: '#000000',
                        type: 'color'
                    },
                  },
                  {show_button: {active: false, type: 'radiogroup', isButton: true, value: false, options: [true, false]},},
                  {button_text: {type: 'text', value: 'Slide 1'},},
                  {button_url: {type: 'text', value: 'Slide 1'},},
                ],
                list_item_values: [
                  {title: {value: 'Slide', units: ''},},
                  {description: {value: '', units: ''},},
                  {type:  {value: '', units: ''},},
                  {image: {value: '', units: ''},},
                  {background_colour: {value: '', units: ''},},
                  {show_button: {value: '', units: ''},},
                  {button_text: {value: '', units: ''},},
                  {button_url: {value: '', units: ''},},
                ],
              },
              widgetstyles: '',
              editable: 0,
              id: '',
            },
            {
              widgetname: 'Text',
              widgettype: 'text',
              widgeticon: 'bx bx-text',
              widgetcontent: [
                {title: {
                  value: 'Your title text',
                  units: '',
                  subfields:[
                      {heading_level: {value: 'h2', units: ''},},
                      {font_family: {value: {"family":"Poppins","variants":["100","100italic","200","200italic","300","300italic","regular","italic","500","500italic","600","600italic","700","700italic","800","800italic","900","900italic"],"subsets":["devanagari","latin","latin-ext"],"version":"v20","lastModified":"2022-09-22","files":{"100":"http://fonts.gstatic.com/s/poppins/v20/pxiGyp8kv8JHgFVrLPTed3FBGPaTSQ.ttf","200":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLFj_V1tvFP-KUEg.ttf","300":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLDz8V1tvFP-KUEg.ttf","500":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLGT9V1tvFP-KUEg.ttf","600":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLEj6V1tvFP-KUEg.ttf","700":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLCz7V1tvFP-KUEg.ttf","800":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLDD4V1tvFP-KUEg.ttf","900":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLBT5V1tvFP-KUEg.ttf","100italic":"http://fonts.gstatic.com/s/poppins/v20/pxiAyp8kv8JHgFVrJJLmE3tFOvODSVFF.ttf","200italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmv1plEN2PQEhcqw.ttf","300italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLm21llEN2PQEhcqw.ttf","regular":"http://fonts.gstatic.com/s/poppins/v20/pxiEyp8kv8JHgFVrFJDUc1NECPY.ttf","italic":"http://fonts.gstatic.com/s/poppins/v20/pxiGyp8kv8JHgFVrJJLed3FBGPaTSQ.ttf","500italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmg1hlEN2PQEhcqw.ttf","600italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmr19lEN2PQEhcqw.ttf","700italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmy15lEN2PQEhcqw.ttf","800italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLm111lEN2PQEhcqw.ttf","900italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLm81xlEN2PQEhcqw.ttf"},"category":"sans-serif","kind":"webfonts#webfont"}, units: ''},},
                      {font_style: {value: '', units: ''},},
                      {font_weight: {value: '', units: ''},},
                      {text_transform: {value: '', units: ''},},
                      {letter_spacing: {value: '', units: ''},},
                      {line_height: {value: '', units: ''},},
                    ]
                },
            },
             {   text: {
                        active: true,
                        value: '<p>Your text</p>',
                        units: '',
                        subtabs: [
                        {
                            p: 
                                [
                                 {font_family: {value: {"family":"Poppins","variants":["100","100italic","200","200italic","300","300italic","regular","italic","500","500italic","600","600italic","700","700italic","800","800italic","900","900italic"],"subsets":["devanagari","latin","latin-ext"],"version":"v20","lastModified":"2022-09-22","files":{"100":"http://fonts.gstatic.com/s/poppins/v20/pxiGyp8kv8JHgFVrLPTed3FBGPaTSQ.ttf","200":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLFj_V1tvFP-KUEg.ttf","300":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLDz8V1tvFP-KUEg.ttf","500":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLGT9V1tvFP-KUEg.ttf","600":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLEj6V1tvFP-KUEg.ttf","700":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLCz7V1tvFP-KUEg.ttf","800":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLDD4V1tvFP-KUEg.ttf","900":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLBT5V1tvFP-KUEg.ttf","100italic":"http://fonts.gstatic.com/s/poppins/v20/pxiAyp8kv8JHgFVrJJLmE3tFOvODSVFF.ttf","200italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmv1plEN2PQEhcqw.ttf","300italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLm21llEN2PQEhcqw.ttf","regular":"http://fonts.gstatic.com/s/poppins/v20/pxiEyp8kv8JHgFVrFJDUc1NECPY.ttf","italic":"http://fonts.gstatic.com/s/poppins/v20/pxiGyp8kv8JHgFVrJJLed3FBGPaTSQ.ttf","500italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmg1hlEN2PQEhcqw.ttf","600italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmr19lEN2PQEhcqw.ttf","700italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmy15lEN2PQEhcqw.ttf","800italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLm111lEN2PQEhcqw.ttf","900italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLm81xlEN2PQEhcqw.ttf"},"category":"sans-serif","kind":"webfonts#webfont"}, units: ''},},
                                 {font_style: {value: '', units: ''},},
                                 {font_weight: {value: '', units: ''},},
                                 {text_transform: {value: '', units: ''},},
                                 {font_size: {value: '', units: ''},},
                                 {letter_spacing: {value: '', units: ''},},
                                 {line_height: {value: '', units: ''}},
                                ],
                        },
                        {
                            h1: 
                                [
                                 {font_family: {value: {"family":"Poppins","variants":["100","100italic","200","200italic","300","300italic","regular","italic","500","500italic","600","600italic","700","700italic","800","800italic","900","900italic"],"subsets":["devanagari","latin","latin-ext"],"version":"v20","lastModified":"2022-09-22","files":{"100":"http://fonts.gstatic.com/s/poppins/v20/pxiGyp8kv8JHgFVrLPTed3FBGPaTSQ.ttf","200":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLFj_V1tvFP-KUEg.ttf","300":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLDz8V1tvFP-KUEg.ttf","500":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLGT9V1tvFP-KUEg.ttf","600":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLEj6V1tvFP-KUEg.ttf","700":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLCz7V1tvFP-KUEg.ttf","800":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLDD4V1tvFP-KUEg.ttf","900":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLBT5V1tvFP-KUEg.ttf","100italic":"http://fonts.gstatic.com/s/poppins/v20/pxiAyp8kv8JHgFVrJJLmE3tFOvODSVFF.ttf","200italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmv1plEN2PQEhcqw.ttf","300italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLm21llEN2PQEhcqw.ttf","regular":"http://fonts.gstatic.com/s/poppins/v20/pxiEyp8kv8JHgFVrFJDUc1NECPY.ttf","italic":"http://fonts.gstatic.com/s/poppins/v20/pxiGyp8kv8JHgFVrJJLed3FBGPaTSQ.ttf","500italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmg1hlEN2PQEhcqw.ttf","600italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmr19lEN2PQEhcqw.ttf","700italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmy15lEN2PQEhcqw.ttf","800italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLm111lEN2PQEhcqw.ttf","900italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLm81xlEN2PQEhcqw.ttf"},"category":"sans-serif","kind":"webfonts#webfont"}, units: ''},},
                                 {font_style: {value: '', units: ''},},
                                 {font_weight: {value: '', units: ''},},
                                 {text_transform: {value: '', units: ''},},
                                 {font_size: {value: '', units: ''},},
                                 {letter_spacing: {value: '', units: ''},},
                                 {line_height: {value: '', units: ''}},
                                ],
                        },
                        {
                            h2: 
                                [
                                 {font_family: {value: {"family":"Poppins","variants":["100","100italic","200","200italic","300","300italic","regular","italic","500","500italic","600","600italic","700","700italic","800","800italic","900","900italic"],"subsets":["devanagari","latin","latin-ext"],"version":"v20","lastModified":"2022-09-22","files":{"100":"http://fonts.gstatic.com/s/poppins/v20/pxiGyp8kv8JHgFVrLPTed3FBGPaTSQ.ttf","200":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLFj_V1tvFP-KUEg.ttf","300":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLDz8V1tvFP-KUEg.ttf","500":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLGT9V1tvFP-KUEg.ttf","600":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLEj6V1tvFP-KUEg.ttf","700":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLCz7V1tvFP-KUEg.ttf","800":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLDD4V1tvFP-KUEg.ttf","900":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLBT5V1tvFP-KUEg.ttf","100italic":"http://fonts.gstatic.com/s/poppins/v20/pxiAyp8kv8JHgFVrJJLmE3tFOvODSVFF.ttf","200italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmv1plEN2PQEhcqw.ttf","300italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLm21llEN2PQEhcqw.ttf","regular":"http://fonts.gstatic.com/s/poppins/v20/pxiEyp8kv8JHgFVrFJDUc1NECPY.ttf","italic":"http://fonts.gstatic.com/s/poppins/v20/pxiGyp8kv8JHgFVrJJLed3FBGPaTSQ.ttf","500italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmg1hlEN2PQEhcqw.ttf","600italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmr19lEN2PQEhcqw.ttf","700italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmy15lEN2PQEhcqw.ttf","800italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLm111lEN2PQEhcqw.ttf","900italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLm81xlEN2PQEhcqw.ttf"},"category":"sans-serif","kind":"webfonts#webfont"}, units: ''},},
                                 {font_style: {value: '', units: ''},},
                                 {font_weight: {value: '', units: ''},},
                                 {text_transform: {value: '', units: ''},},
                                 {font_size: {value: '', units: ''},},
                                 {letter_spacing: {value: '', units: ''},},
                                 {line_height: {value: '', units: ''}},
                                ],
                        },
                        {
                            h3: 
                                [
                                 {font_family: {value: {"family":"Poppins","variants":["100","100italic","200","200italic","300","300italic","regular","italic","500","500italic","600","600italic","700","700italic","800","800italic","900","900italic"],"subsets":["devanagari","latin","latin-ext"],"version":"v20","lastModified":"2022-09-22","files":{"100":"http://fonts.gstatic.com/s/poppins/v20/pxiGyp8kv8JHgFVrLPTed3FBGPaTSQ.ttf","200":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLFj_V1tvFP-KUEg.ttf","300":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLDz8V1tvFP-KUEg.ttf","500":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLGT9V1tvFP-KUEg.ttf","600":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLEj6V1tvFP-KUEg.ttf","700":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLCz7V1tvFP-KUEg.ttf","800":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLDD4V1tvFP-KUEg.ttf","900":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLBT5V1tvFP-KUEg.ttf","100italic":"http://fonts.gstatic.com/s/poppins/v20/pxiAyp8kv8JHgFVrJJLmE3tFOvODSVFF.ttf","200italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmv1plEN2PQEhcqw.ttf","300italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLm21llEN2PQEhcqw.ttf","regular":"http://fonts.gstatic.com/s/poppins/v20/pxiEyp8kv8JHgFVrFJDUc1NECPY.ttf","italic":"http://fonts.gstatic.com/s/poppins/v20/pxiGyp8kv8JHgFVrJJLed3FBGPaTSQ.ttf","500italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmg1hlEN2PQEhcqw.ttf","600italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmr19lEN2PQEhcqw.ttf","700italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmy15lEN2PQEhcqw.ttf","800italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLm111lEN2PQEhcqw.ttf","900italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLm81xlEN2PQEhcqw.ttf"},"category":"sans-serif","kind":"webfonts#webfont"}, units: ''},},
                                 {font_style: {value: '', units: ''},},
                                 {font_weight: {value: '', units: ''},},
                                 {text_transform: {value: '', units: ''},},
                                 {font_size: {value: '', units: ''},},
                                 {letter_spacing: {value: '', units: ''},},
                                 {line_height: {value: '', units: ''}},
                               ],
                        },
                        {
                            h4: 
                                [
                                 {font_family: {value: {"family":"Poppins","variants":["100","100italic","200","200italic","300","300italic","regular","italic","500","500italic","600","600italic","700","700italic","800","800italic","900","900italic"],"subsets":["devanagari","latin","latin-ext"],"version":"v20","lastModified":"2022-09-22","files":{"100":"http://fonts.gstatic.com/s/poppins/v20/pxiGyp8kv8JHgFVrLPTed3FBGPaTSQ.ttf","200":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLFj_V1tvFP-KUEg.ttf","300":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLDz8V1tvFP-KUEg.ttf","500":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLGT9V1tvFP-KUEg.ttf","600":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLEj6V1tvFP-KUEg.ttf","700":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLCz7V1tvFP-KUEg.ttf","800":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLDD4V1tvFP-KUEg.ttf","900":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLBT5V1tvFP-KUEg.ttf","100italic":"http://fonts.gstatic.com/s/poppins/v20/pxiAyp8kv8JHgFVrJJLmE3tFOvODSVFF.ttf","200italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmv1plEN2PQEhcqw.ttf","300italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLm21llEN2PQEhcqw.ttf","regular":"http://fonts.gstatic.com/s/poppins/v20/pxiEyp8kv8JHgFVrFJDUc1NECPY.ttf","italic":"http://fonts.gstatic.com/s/poppins/v20/pxiGyp8kv8JHgFVrJJLed3FBGPaTSQ.ttf","500italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmg1hlEN2PQEhcqw.ttf","600italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmr19lEN2PQEhcqw.ttf","700italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmy15lEN2PQEhcqw.ttf","800italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLm111lEN2PQEhcqw.ttf","900italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLm81xlEN2PQEhcqw.ttf"},"category":"sans-serif","kind":"webfonts#webfont"}, units: ''},},
                                 {font_style: {value: '', units: ''},},
                                 {font_weight: {value: '', units: ''},},
                                 {text_transform: {value: '', units: ''},},
                                 {font_size: {value: '', units: ''},},
                                 {letter_spacing: {value: '', units: ''},},
                                 {line_height: {value: '', units: ''}},
                             ],
                        },
                        {
                            h5: 
                                [
                                 {font_family: {value: {"family":"Poppins","variants":["100","100italic","200","200italic","300","300italic","regular","italic","500","500italic","600","600italic","700","700italic","800","800italic","900","900italic"],"subsets":["devanagari","latin","latin-ext"],"version":"v20","lastModified":"2022-09-22","files":{"100":"http://fonts.gstatic.com/s/poppins/v20/pxiGyp8kv8JHgFVrLPTed3FBGPaTSQ.ttf","200":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLFj_V1tvFP-KUEg.ttf","300":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLDz8V1tvFP-KUEg.ttf","500":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLGT9V1tvFP-KUEg.ttf","600":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLEj6V1tvFP-KUEg.ttf","700":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLCz7V1tvFP-KUEg.ttf","800":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLDD4V1tvFP-KUEg.ttf","900":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLBT5V1tvFP-KUEg.ttf","100italic":"http://fonts.gstatic.com/s/poppins/v20/pxiAyp8kv8JHgFVrJJLmE3tFOvODSVFF.ttf","200italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmv1plEN2PQEhcqw.ttf","300italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLm21llEN2PQEhcqw.ttf","regular":"http://fonts.gstatic.com/s/poppins/v20/pxiEyp8kv8JHgFVrFJDUc1NECPY.ttf","italic":"http://fonts.gstatic.com/s/poppins/v20/pxiGyp8kv8JHgFVrJJLed3FBGPaTSQ.ttf","500italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmg1hlEN2PQEhcqw.ttf","600italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmr19lEN2PQEhcqw.ttf","700italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmy15lEN2PQEhcqw.ttf","800italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLm111lEN2PQEhcqw.ttf","900italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLm81xlEN2PQEhcqw.ttf"},"category":"sans-serif","kind":"webfonts#webfont"}, units: ''},},
                                 {font_style: {value: '', units: ''},},
                                 {font_weight: {value: '', units: ''},},
                                 {text_transform: {value: '', units: ''},},
                                 {font_size: {value: '', units: ''},},
                                 {letter_spacing: {value: '', units: ''},},
                                 {line_height: {value: '', units: ''}},
                             ],
                        },
                        ]
                }
            },
              ],
              widgetconfigs: [
                {text_label: {active: false, type: 'label', text: 'Body Font Settings', parentname: 'border_label'},},
                {text: {active: false, value: '', type: 'subtab', subtabs: [
                  {p: [{font_family: {type: 'fontselect', options: []},},
                       {font_style: {type: 'select', options: ['normal','italic','oblique','initial','inherit']},},
                       {font_weight: {type: 'select', options: [100,200,300,400,500,600,700,800,900]},},
                       {text_transform: {type: 'select', options: ['none','capitalize','uppercase','lowercase','initial','inherit']},},
                       {font_size: {active: false, type: 'range', value: 'auto', units: '', unit_options: ['px'],  max: 200, min: 0, parentlabel: 'sizing_label'},},
                       {letter_spacing: {active: false, type: 'range', value: 'auto', units: '', unit_options: ['px'],  max: 24, min: 0, parentlabel: 'sizing_label'},},
                       {line_height: {active: false, type: 'range', value: 'auto', units: '', unit_options: ['px'],  max: 200, min: 0, parentlabel: 'sizing_label'},},
                     ],
                  },
                  {h1: [
                       {font_family: {type: 'fontselect', options: []},},
                       {font_style: {type: 'select', options: ['normal','italic','oblique','initial','inherit']},},
                       {font_weight: {type: 'select', options: [100,200,300,400,500,600,700,800,900]},},
                       {text_transform: {type: 'select', options: ['none','capitalize','uppercase','lowercase','initial','inherit']},},
                      {font_size: {active: false, type: 'range', value: 'auto', units: '', unit_options: ['px'],  max: 200, min: 0, parentlabel: 'sizing_label'},},
                      {letter_spacing: {active: false, type: 'range', value: 'auto', units: '', unit_options: ['px'],  max: 24, min: 0, parentlabel: 'sizing_label'},},
                      {line_height: {active: false, type: 'range', value: 'auto', units: '', unit_options: ['px'],  max: 200, min: 0, parentlabel: 'sizing_label'},},
                     ],
                  },
                  {h2: [
                       {font_family: {type: 'fontselect', options: []},},
                       {font_style: {type: 'select', options: ['normal','italic','oblique','initial','inherit']},},
                       {font_weight: {type: 'select', options: [100, 200,300,400,500,600,700,800,900]},},
                       {text_transform: {type: 'select', options: ['none','capitalize','uppercase','lowercase','initial','inherit']},},
                       {font_size: {active: false, type: 'range', value: 'auto', units: '', unit_options: ['px'],  max: 200, min: 0, parentlabel: 'sizing_label'},},
                       {letter_spacing: {active: false, type: 'range', value: 'auto', units: '', unit_options: ['px'],  max: 24, min: 0, parentlabel: 'sizing_label'},},
                       {line_height: {active: false, type: 'range', value: 'auto', units: '', unit_options: ['px'],  max: 200, min: 0, parentlabel: 'sizing_label'},},
                     ],
                  },
                  {h3: [
                       {font_family: {type: 'fontselect', options: []},},
                       {font_style: {type: 'select', options: ['normal','italic','oblique','initial','inherit']},},
                       {font_weight: {type: 'select', options: [100,200,300,400,500,600,700,800,900]},},
                       {text_transform: {type: 'select', options: ['none','capitalize','uppercase','lowercase','initial','inherit']},},
                       {font_size: {active: false, type: 'range', value: 'auto', units: '', unit_options: ['px'],  max: 200, min: 0, parentlabel: 'sizing_label'},},
                       {letter_spacing: {active: false, type: 'range', value: 'auto', units: '', unit_options: ['px'],  max: 24, min: 0, parentlabel: 'sizing_label'},},
                       {line_height: {active: false, type: 'range', value: 'auto', units: '', unit_options: ['px'],  max: 200, min: 0, parentlabel: 'sizing_label'},},
                     ],
                  },
                  {h4: [
                        {font_family: {type: 'fontselect', options: []},},
                       {font_style: {type: 'select', options: ['normal','italic','oblique','initial','inherit']},},
                       {font_weight: {type: 'select', options: [100, 200,300,400,500,600,700,800,900]},},
                       {text_transform: {type: 'select', options: ['none','capitalize','uppercase','lowercase','initial','inherit']},},
                       {font_size: {active: false, type: 'range', value: 'auto', units: '', unit_options: ['px'],  max: 200, min: 0, parentlabel: 'sizing_label'},},
                       {letter_spacing: {active: false, type: 'range', value: 'auto', units: '', unit_options: ['px'],  max: 24, min: 0, parentlabel: 'sizing_label'},},
                       {line_height: {active: false, type: 'range', value: 'auto', units: '', unit_options: ['px'],  max: 200, min: 0, parentlabel: 'sizing_label'},},
                     ],
                  },
                  {h5: [
                       {font_family: {type: 'fontselect', options: []},},
                       {font_style: {type: 'select', options: ['normal','italic','oblique','initial','inherit']},},
                       {font_weight: {type: 'select', options: [100,200,300,400,500,600,700,800,900]},},
                       {text_transform: {type: 'select', options: ['none','capitalize','uppercase','lowercase','initial','inherit']},},
                       {font_size: {active: false, type: 'range', value: 'auto', units: '', unit_options: ['px'],  max: 200, min: 0, parentlabel: 'sizing_label'},},
                       {letter_spacing: {active: false, type: 'range', value: 'auto', units: '', unit_options: ['px'],  max: 24, min: 0, parentlabel: 'sizing_label'},},
                       {line_height: {active: false, type: 'range', value: 'auto', units: '', unit_options: ['px'],  max: 200, min: 0, parentlabel: 'sizing_label'},},
                        ],
                    },
                ]
            },
            },
            {title_label: {active: false, type: 'label', text: 'Title Font Settings', parentname: 'border_label'},},
            {title: {active: false, value: '', type: 'subtab', subfields: [
                       {heading_level: {type: 'radiogroup', isButton: true, options: ['h1', 'h2', 'h3', 'h4', 'h5']},
                       },
                       {font_family: {type: 'fontselect', options: []},
                       },
                       {font_style: {type: 'select', options: ['normal','italic','oblique','initial','inherit']},
                       },
                       {font_weight: {type: 'select', options: [100,200,300,400,500,600,700,800,900]},
                       },
                       {text_transform: {type: 'select', options: ['none','capitalize','uppercase','lowercase','initial','inherit']},},
                       {letter_spacing: {active: false, type: 'range', value: 'auto', units: '', unit_options: ['px'],  max: 124, min: 0, parentlabel: 'sizing_label'},},
                       {line_height: {active: false, type: 'range', value: 'auto', units: '', unit_options: ['px'],  max: 124, min: 0, parentlabel: 'sizing_label'}},
                ]}
            },
                
              ],
              widgetstyles: '',
              editable: 0,
              id: '',
            },
            {
              widgetname: 'Cards',
              widgettype: 'cards',
              widgeticon: 'bx bx-carousel',
              widgetcontent: [
                {config: {
                  slider: '',
                    },
                },
                {styles: {
                  widgetStyles: '',
                    },
                },
                {advanced: {
                  widgetIdName: '',
                  widgetCssClasses: '',
                  widgetCustomCss: '',
                    },
                },
                {list: [],},
                {list_item_raw: {},},
                {list_index: 0,},
                {controls: {value: '', units: ''},},
                {fade: {value: '', units: ''},},
                {indicators: {value: '', units: ''},},
                {interval: {value: '', units: ''},},
                {view: viewOptionDefaultValues.view,},
                {columns: viewOptionDefaultValues.columns,},
                {column: viewOptionDefaultValues.column,},
                {carousel: viewOptionDefaultValues.carousel,},
                {masonry: viewOptionDefaultValues.masonry,},
                {card_layout: {value: 'vertical', units: ''},},
                {card_padding: {
                    active: false,
                    type: 'numbergroup',
                    parentlabel: '',
                    left: null,
                    right: null,
                    top: null,
                    bottom: null, 
                  },
                  },
                  {card_margin: {
                      active: false,
                      type: 'numbergroup',
                      parentlabel: '',
                      left: null,
                      right: null,
                      top: null,
                      bottom: null,
                  },
                  },
                  {card_border_style: {
                        active: false, type: 'select', value: '', options: ['dotted','dashed','solid','double','groove','ridge','inset','outset','none','hidden']
                  },
                  },
                  {card_border: {
                      active: true,
                      type: 'numbergroup',
                      parentlabel: '',
                      left: 0,
                      right: 0,
                      top: 0,
                      bottom: 0,
                  },  
                  },
                  {card_border_colour: {
                      active: false,
                      value: '#000000',
                      type: 'color'
                    },
                  },
                  {card_border_radius: {
                      active: false,
                      type: 'numbergroup',
                      parentlabel: '',
                      top_left: null,
                      top_right: null,
                      bottom_left: null,
                      bottom_right: null,
                  }, 
                  },
                  {card_padding: {
                    active: false,
                    type: 'numbergroup',
                    parentlabel: '',
                    left: null,
                    right: null,
                    top: null,
                    bottom: null, 
                  },    
                  },
                  {card_margin: {
                      active: false,
                      type: 'numbergroup',
                      parentlabel: '',
                      left: null,
                      right: null,
                      top: null,
                      bottom: null,
                  },
                  },
                  {card_border_style: {
                        active: false, type: 'select', value: '', options: ['dotted','dashed','solid','double','groove','ridge','inset','outset','none','hidden']
                  },
                  },
                  {card_border: {
                      active: true,
                      type: 'numbergroup',
                      parentlabel: '',
                      left: 0,
                      right: 0,
                      top: 0,
                      bottom: 0,
                  },  
                  },
                  {card_border_colour: {
                      active: false,
                      value: '#000000',
                      type: 'color'
                    },
                  },
                  {card_border_radius: {
                      active: false,
                      type: 'numbergroup',
                      parentlabel: '',
                      top_left: null,
                      top_right: null,
                      bottom_left: null,
                      bottom_right: null,
                  }, 
                },
                {card_padding: {
                    active: false,
                    type: 'numbergroup',
                    parentlabel: '',
                    left: null,
                    right: null,
                    top: null,
                    bottom: null, 
                  },    
                  },
                  {card_margin: {
                      active: false,
                      type: 'numbergroup',
                      parentlabel: '',
                      left: null,
                      right: null,
                      top: null,
                      bottom: null,
                  },
                  },
                  {card_border_style: {
                        active: false, type: 'select', value: '', options: ['dotted','dashed','solid','double','groove','ridge','inset','outset','none','hidden']
                  },
                  },
                  {card_border: {
                      active: true,
                      type: 'numbergroup',
                      parentlabel: '',
                      left: 0,
                      right: 0,
                      top: 0,
                      bottom: 0,
                  },  
                  },
                  {card_border_colour: {
                      active: false,
                      value: '#000000',
                      type: 'color'
                    },
                  },
                  {card_border_radius: {
                      active: false,
                      type: 'numbergroup',
                      parentlabel: '',
                      top_left: null,
                      top_right: null,
                      bottom_left: null,
                      bottom_right: null,
                  },  
                  },
                  {
                    card_body_padding: {
                    active: false,
                    type: 'numbergroup',
                    parentlabel: '',
                    left: null,
                    right: null,
                    top: null,
                    bottom: null, 
                  },    
                  },
                  {card_body_margin: {
                      active: false,
                      type: 'numbergroup',
                      parentlabel: '',
                      left: null,
                      right: null,
                      top: null,
                      bottom: null,
                  },
                  },
                  {card_body_border_style: {
                        active: false, type: 'select', value: '', options: ['dotted','dashed','solid','double','groove','ridge','inset','outset','none','hidden']
                  },
                  },
                  {card_body_border: {
                      active: true,
                      type: 'numbergroup',
                      parentlabel: '',
                      left: 0,
                      right: 0,
                      top: 0,
                      bottom: 0,
                  },  
                  },
                  {card_body_border_colour: {
                      active: false,
                      value: '#000000',
                      type: 'color'
                    },
                  },
                  {card_body_border_radius: {
                      active: false,
                      type: 'numbergroup',
                      parentlabel: '',
                      top_left: null,
                      top_right: null,
                      bottom_left: null,
                      bottom_right: null,
                  }, 
                },
                {show_button: {value: true, units: ''},
                },
                {title: viewOptionDefaultValues.title_font
                },
                {text: viewOptionDefaultValues.font2
                },
                {button_position: {value: 'vertical', units: ''},
                },
                {button_hover_effect: {value: false, units: ''},
                },
                {button_colour: {
                    active: false,
                    value: '',
                    units: ''
                },
                },
                {button_text_colour: {
                    active: false,
                    value: '',
                    units: ''
                },
                },
                {button_border_radius: {
                    active: true,
                    type: 'numbergroup',
                    parentlabel: '',
                    left: 0,
                    right: 0,
                    top: 0,
                    bottom: 0,
                },
                },
                {button_border_style: {
                    active: false,
                    value: '',
                    units: ''
                },
                },
                {button_border: {
                    active: true,
                    type: 'numbergroup',
                    parentlabel: '',
                    left: 0,
                    right: 0,
                    top: 0,
                    bottom: 0,
                },  
                },
                {button_border_colour: {
                    active: false,
                    value: '',
                    units: ''
                },
                },
                {image_width: {value: 'auto', units: '%'},
                },
                {image_height: {value: 'auto', units: '%'},
                },
                {image_max_width: {value: 'auto', units: '%'},
                },
                {image_max_height: {value: 'auto', units: '%'},
                },
                {image_padding: {
                    active: false,
                    type: 'numbergroup',
                    parentlabel: '',
                    left: null,
                    right: null,
                    top: null,
                    bottom: null, 
                },    
                },
                {image_margin: {
                    active: false,
                    type: 'numbergroup',
                    parentlabel: '',
                    left: null,
                    right: null,
                    top: null,
                    bottom: null,
                },
                },
                {image_border_label: {active: false, type: 'label', text: 'Borders', parentname: 'border_label'},
                },
                {image_border_style: {
                      active: false, type: 'select', value: '', options: ['dotted','dashed','solid','double','groove','ridge','inset','outset','none','hidden']
                },
                },
                {image_border: {
                    active: true,
                    type: 'numbergroup',
                    parentlabel: '',
                    left: 0,
                    right: 0,
                    top: 0,
                    bottom: 0,
                },  
                },
                {image_border_colour: {
                    active: false,
                    value: '#000000',
                    type: 'color'
                  },
                },
                {image_border_radius: {
                    active: false,
                    type: 'numbergroup',
                    parentlabel: '',
                    top_left: null,
                    top_right: null,
                    bottom_left: null,
                    bottom_right: null,
                },
                },
              ],
              widgetconfigs: [
                {view_label: {active: false, type: 'label', text: 'View Settings', parentname: 'spacing_label'},},
                {view: viewOptionConfigs.view.default,},
                {columns_label: {active: false, type: 'label', text: 'Grid Gallery Settings', parentname: 'spacing_label',  dependentOn: {field: 'view', value: 'grid'}},},
                {columns: viewOptionConfigs.columns,},
                {column: viewOptionConfigs.column,},
                {carousel_label: {active: false, type: 'label', text: 'Carousel Gallery Settings', parentname: 'border_label', dependentOn: {field: 'view', value: 'carousel'},},},
                {carousel: viewOptionConfigs.carousel.products2,},
                {masonry_label: {active: false, type: 'label', text: 'Masonry Gallery Settings', parentname: 'border_label', dependentOn: {field: 'view', value: 'masonry'}},},
                {masonry: viewOptionConfigs.masonry,},
                {card_label: {active: false, type: 'label', text: 'Card Layout', parentname: 'alignment_label'},},
                {card_layout: {active: false, type: 'radiogroup', isButton: true, value: false, options: ['vertical', 'horizontal']},},
                {card_padding: {
                    active: false,
                    type: 'numbergroup',
                    parentlabel: '',
                    left: null,
                    right: null,
                    top: null,
                    bottom: null, 
                  },    
                  },
                  {card_margin: {
                      active: false,
                      type: 'numbergroup',
                      parentlabel: '',
                      left: null,
                      right: null,
                      top: null,
                      bottom: null,
                  },
                  },
                  {card_border_style: {
                        active: false, type: 'select', value: '', options: ['dotted','dashed','solid','double','groove','ridge','inset','outset','none','hidden']
                  },
                  },
                  {card_border: {
                      active: true,
                      type: 'numbergroup',
                      parentlabel: '',
                      left: 0,
                      right: 0,
                      top: 0,
                      bottom: 0,
                  },  
                  },
                  {card_border_colour: {
                      active: false,
                      value: '#000000',
                      type: 'color'
                    },
                  },
                  {card_border_radius: {
                      active: false,
                      type: 'numbergroup',
                      parentlabel: '',
                      top_left: null,
                      top_right: null,
                      bottom_left: null,
                      bottom_right: null,
                  },  
                },
                {card_body_padding: {
                    active: false,
                    type: 'numbergroup',
                    parentlabel: '',
                    left: null,
                    right: null,
                    top: null,
                    bottom: null, 
                  },    
                  },
                  {card_body_margin: {
                      active: false,
                      type: 'numbergroup',
                      parentlabel: '',
                      left: null,
                      right: null,
                      top: null,
                      bottom: null,
                  },
                  },
                  {card_body_border_style: {
                        active: false, type: 'select', value: '', options: ['dotted','dashed','solid','double','groove','ridge','inset','outset','none','hidden']
                  },
                  },
                  {card_body_border: {
                      active: true,
                      type: 'numbergroup',
                      parentlabel: '',
                      left: 0,
                      right: 0,
                      top: 0,
                      bottom: 0,
                  },  
                  },
                  {card_body_border_colour: {
                      active: false,
                      value: '#000000',
                      type: 'color'
                    },
                  },
                  {card_body_border_radius: {
                      active: false,
                      type: 'numbergroup',
                      parentlabel: '',
                      top_left: null,
                      top_right: null,
                      bottom_left: null,
                      bottom_right: null,
                  }, 
                },
                {title_label: {active: false, type: 'label', text: 'Card Title Options', parentname: 'alignment_label'},},
                {title: viewOptionConfigs.title_font
                },
                {text_label: {active: false, type: 'label', text: 'Card Body Text Options', parentname: 'alignment_label'},},
                {text: viewOptionConfigs.font2
                },
                {controls_label: {active: false, type: 'label', text: 'Slider Controls', parentname: 'border_label'},},
                {controls:  {active: false, type: 'radiogroup', isButton: true, value: false, options: [true, false]},},
                {fade:  {active: false, type: 'radiogroup', isButton: true, value: false, options: [true, false]},},
                {indicators:  {active: false, type: 'radiogroup', isButton: true, value: false, options: [true, false]},},
                {interval: {active: false, type: 'range', value: 'auto', units: '', unit_options: ['px'],  max: 5000, min: 0, parentlabel: 'sizing_label'},},
                {button_label: {active: false, type: 'label', text: 'Button Styles', parentname: 'alignment_label'},},
                {show_button: {active: false, type: 'radiogroup', isButton: true, value: false, options: [true,false]},},
                {button_position: {active: false, type: 'radiogroup', isButton: true, value: false, options: ['left', 'right', 'center']},},
                {button_hover_effect: {active: false, type: 'radiogroup', isButton: true, value: false, options: [true,false]},},
                {button_colour: {active: false, value: '#000000', type: 'color'},},
                {button_text_colour: {
                    active: false,
                    value: '#000000',
                    type: 'color'
                },
                },
                {button_border_style: {
                    active: false, type: 'select', value: '', options: ['dotted','dashed','solid','double','groove','ridge','inset','outset','none','hidden']
                },
                },
                {button_border: {
                    active: true,
                    type: 'numbergroup',
                    parentlabel: '',
                    left: 0,
                    right: 0,
                    top: 0,
                    bottom: 0,
                },  
                },
                {button_border_radius: {
                    active: false,
                    type: 'numbergroup',
                    parentlabel: '',
                    top_left: null,
                    top_right: null,
                    bottom_left: null,
                    bottom_right: null,
                },
                },
                {
                    button_border_colour: {
                    active: false,
                    value: '#000000',
                    type: 'color'
                    },
                },
                {image_width: {value: 'auto', units: '%'},
                },
                {image_height: {value: 'auto', units: '%'},
                },
                {image_max_width: {value: 'auto', units: '%'},
                },
                {image_max_height: {value: 'auto', units: '%'},
                },
                {image_padding: {
                    active: false,
                    type: 'numbergroup',
                    parentlabel: '',
                    left: null,
                    right: null,
                    top: null,
                    bottom: null, 
                },    
                },
                {image_margin: {
                    active: false,
                    type: 'numbergroup',
                    parentlabel: '',
                    left: null,
                    right: null,
                    top: null,
                    bottom: null,
                },
                },
                {image_border_label: {active: false, type: 'label', text: 'Borders', parentname: 'border_label'},
                },
                {image_border_style: {
                      active: false, type: 'select', value: '', options: ['dotted','dashed','solid','double','groove','ridge','inset','outset','none','hidden']
                },
                },
                {image_border: {
                    active: true,
                    type: 'numbergroup',
                    parentlabel: '',
                    left: 0,
                    right: 0,
                    top: 0,
                    bottom: 0,
                },  
                },
                {image_border_colour: {
                    active: false,
                    value: '#000000',
                    type: 'color'
                  },
                },
                {image_border_radius: {
                    active: false,
                    type: 'numbergroup',
                    parentlabel: '',
                    top_left: null,
                    top_right: null,
                    bottom_left: null,
                    bottom_right: null,
                },
                },
              ],
              widgetlistconfigs: {
                list_item: [
                  {title: {type: 'text', value: 'Slide 1'},},
                  {description: {type: 'textarea', value: 'Slide 1'},},
                  {image: {type: 'image'},},
                  {button: {active: false, type: 'radiogroup', isButton: true, value: false, options: [true, false]},},
                  {button_text: {type: 'text', value: 'Slide 1', dependentOn: {field: 'button', value: true}},},
                  {button_url: {type: 'text', value: 'Slide 1', dependentOn: {field: 'button', value: true}},},
                  {background_colour: {
                    active: false,
                    value: '#000000',
                    type: 'color'
                  },
                 },
                {title_label: {active: false, type: 'label', text: 'Font Styles', parentname: 'alignment_label'},},
                {
                    body_text: {
                    active: false, type: 'subtab', isButton: true, value: false,
                       subfields: [
                           {font_size: {active: false, type: 'range', value: 'auto', units: '', unit_options: ['px'],  max: 124, min: 0, parentlabel: 'sizing_label'},},
                           {font_family: {type: 'fontselect', options: []},},
                           {font_style: {type: 'select', options: ['normal','italic','oblique','initial','inherit']},},
                           {font_weight: {type: 'select', options: [100,200,300,400,500,600,700,800,900]},},
                           {text_transform: {type: 'select', options: ['none','capitalize','uppercase','lowercase','initial','inherit']},},
                           {letter_spacing: {active: false, type: 'range', value: 'auto', units: '', unit_options: ['px'],  max: 124, min: 0, parentlabel: 'sizing_label'},},
                           {line_height: {active: false, type: 'range', value: 'auto', units: '', unit_options: ['px'],  max: 124, min: 0, parentlabel: 'sizing_label'}},
                        ],
                  },
                },
                ],
                list_item_values: [
                  {title: {value: 'Slide', units: ''},},
                  {description: {value: '', units: ''},},
                  {type:  {value: '', units: ''},},
                  {image: {value: '', units: ''},},
                  {background_colour: {value: '', units: ''},},
                  {button: {value: '', units: ''},},
                  {button_text: {value: '', units: ''},},
                  {button_url: {value: '', units: ''},},
                  {body_text: {
                    value: '',
                    units: '',
                    subfields: [
                            {font_size: {value: '', units: ''},},
                            {font_family: {value: {"family":"Poppins","variants":["100","100italic","200","200italic","300","300italic","regular","italic","500","500italic","600","600italic","700","700italic","800","800italic","900","900italic"],"subsets":["devanagari","latin","latin-ext"],"version":"v20","lastModified":"2022-09-22","files":{"100":"http://fonts.gstatic.com/s/poppins/v20/pxiGyp8kv8JHgFVrLPTed3FBGPaTSQ.ttf","200":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLFj_V1tvFP-KUEg.ttf","300":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLDz8V1tvFP-KUEg.ttf","500":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLGT9V1tvFP-KUEg.ttf","600":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLEj6V1tvFP-KUEg.ttf","700":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLCz7V1tvFP-KUEg.ttf","800":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLDD4V1tvFP-KUEg.ttf","900":"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLBT5V1tvFP-KUEg.ttf","100italic":"http://fonts.gstatic.com/s/poppins/v20/pxiAyp8kv8JHgFVrJJLmE3tFOvODSVFF.ttf","200italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmv1plEN2PQEhcqw.ttf","300italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLm21llEN2PQEhcqw.ttf","regular":"http://fonts.gstatic.com/s/poppins/v20/pxiEyp8kv8JHgFVrFJDUc1NECPY.ttf","italic":"http://fonts.gstatic.com/s/poppins/v20/pxiGyp8kv8JHgFVrJJLed3FBGPaTSQ.ttf","500italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmg1hlEN2PQEhcqw.ttf","600italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmr19lEN2PQEhcqw.ttf","700italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmy15lEN2PQEhcqw.ttf","800italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLm111lEN2PQEhcqw.ttf","900italic":"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLm81xlEN2PQEhcqw.ttf"},"category":"sans-serif","kind":"webfonts#webfont"}, units: ''},},
                            {font_style: {value: '', units: ''},},
                            {font_weight: {value: '', units: ''},},
                            {text_transform: {value: '', units: ''},},
                            {letter_spacing: {value: '', units: ''},},
                            {line_height: {value: '', units: ''},},
                    ]
                  },
                },
                
                ],
              },
              widgetfilters: {
                    filter: {page: {active: 0, type: 'number', value: 1}, limit: {active: 0, type: 'range', value: 16}},
                    active_filters: {page: {active: 0, type: 'number', value: 1}, limit: {active: 0, type: 'range', value: 16}},
              },
              widgetstyles: '',
              editable: 0,
              id: '',
            },
        	{
              widgetname: 'Products',
              widgettype: 'products',
              widgeticon: 'bx bx-tag',
              widgetcontent: [
                {config: {
                  view: 'grid',
                  view_options: ['grid', 'list', 'carousel'],
                  columns: '',
                  gutters: '',
                  carousel: {
                    autoplay: {type: 'switch', value: false},
                    arrows_navigation: {type: 'switch', value: false},
                    dots_navigation: {type: 'switch', value: false},
                    total: {type: 'number', value: 12},
                    show: {type: 'number', value: 4},
                    loop: {type: 'switch', value: false},
                  },
                  size: {type: 'cols', xl: 4, lg: 4, md: 4, sm: 12, xs: 12 },
                  column_templates: viewOptionConfigs.column_templates,
                  
                },
                },
                {list: [],
                },
                {view: viewOptionDefaultValues.view,
                },
                {columns: viewOptionDefaultValues.columns,
                },
                {column: viewOptionDefaultValues.column,
                },
                {carousel: viewOptionDefaultValues.carousel,
                },
                {masonry: viewOptionDefaultValues.masonry,                
                },
                {card_layout: {value: 'vertical', units: ''},
               },
               { card_padding: {
                    active: false,
                    type: 'numbergroup',
                    parentlabel: '',
                    left: null,
                    right: null,
                    top: null,
                    bottom: null, 
                  },    
                  },
                  {card_margin: {
                      active: false,
                      type: 'numbergroup',
                      parentlabel: '',
                      left: null,
                      right: null,
                      top: null,
                      bottom: null,
                  },
                  },
                  {card_border_style: {
                        active: false, type: 'select', value: '', options: ['dotted','dashed','solid','double','groove','ridge','inset','outset','none','hidden']
                  },
                  },
                  {card_border: {
                      active: true,
                      type: 'numbergroup',
                      parentlabel: '',
                      left: 0,
                      right: 0,
                      top: 0,
                      bottom: 0,
                  },  
                  },
                  {card_border_colour: {
                      active: false,
                      value: '#000000',
                      type: 'color'
                    },
                  },
                  {card_border_radius: {
                      active: false,
                      type: 'numbergroup',
                      parentlabel: '',
                      top_left: null,
                      top_right: null,
                      bottom_left: null,
                      bottom_right: null,
                  }, 
                  
                },
                {card_body_padding: {
                    active: false,
                    type: 'numbergroup',
                    parentlabel: '',
                    left: null,
                    right: null,
                    top: null,
                    bottom: null, 
                  },    
                  },
                  {card_body_margin: {
                      active: false,
                      type: 'numbergroup',
                      parentlabel: '',
                      left: null,
                      right: null,
                      top: null,
                      bottom: null,
                  },
                  },
                  {card_body_border_style: {
                        active: false, type: 'select', value: '', options: ['dotted','dashed','solid','double','groove','ridge','inset','outset','none','hidden']
                  },
                  },
                  {card_body_border: {
                      active: true,
                      type: 'numbergroup',
                      parentlabel: '',
                      left: 0,
                      right: 0,
                      top: 0,
                      bottom: 0,
                  },  
                  },
                  {card_body_border_colour: {
                      active: false,
                      value: '#000000',
                      type: 'color'
                    },
                  },
                  {card_body_border_radius: {
                      active: false,
                      type: 'numbergroup',
                      parentlabel: '',
                      top_left: null,
                      top_right: null,
                      bottom_left: null,
                      bottom_right: null,
                  }, 
                },
                {
                    show_button: {value: true, units: ''},
                },
                {title: viewOptionDefaultValues.title_font
                },
                {text: viewOptionDefaultValues.font2
                },
                {button_position: {value: 'vertical', units: ''},
                },
                {button_hover_effect: {value: false, units: ''},
                },
                {button_colour: {
                    active: false,
                    value: '',
                    units: ''
                },
                },
                {button_text_colour: {
                    active: false,
                    value: '',
                    units: ''
                },
                },
                {button_border_radius: {
                    active: true,
                    type: 'numbergroup',
                    parentlabel: '',
                    left: 0,
                    right: 0,
                    top: 0,
                    bottom: 0,
                },
                },
                {button_border_style: {
                    active: false,
                    value: '',
                    units: ''
                },
                },
                {button_border: {
                    active: true,
                    type: 'numbergroup',
                    parentlabel: '',
                    left: 0,
                    right: 0,
                    top: 0,
                    bottom: 0,
                },  
                },
                {button_border_colour: {
                    active: false,
                    value: '',
                    units: ''
                },
                },
                {text_align: {value: 'text-left', units: ''},
                },
                {fullwidth: {value: false, units: ''},
                },
                {image_width: {value: 'auto', units: '%'},
                },
                {image_height: {value: 'auto', units: '%'},
                },
                {image_max_width: {value: 'auto', units: '%'},
                },
                {image_max_height: {value: 'auto', units: '%'},
                },
                {image_padding: {
                    active: false,
                    type: 'numbergroup',
                    parentlabel: '',
                    left: null,
                    right: null,
                    top: null,
                    bottom: null, 
                },    
                },
                {image_margin: {
                    active: false,
                    type: 'numbergroup',
                    parentlabel: '',
                    left: null,
                    right: null,
                    top: null,
                    bottom: null,
                },
                },
                {image_border_label: {active: false, type: 'label', text: 'Borders', parentname: 'border_label'},
                },
                {image_border_style: {
                      active: false, type: 'select', value: '', options: ['dotted','dashed','solid','double','groove','ridge','inset','outset','none','hidden']
                },
                },
                {image_border: {
                    active: true,
                    type: 'numbergroup',
                    parentlabel: '',
                    left: 0,
                    right: 0,
                    top: 0,
                    bottom: 0,
                },  
                },
                {image_border_colour: {
                    active: false,
                    value: '#000000',
                    type: 'color'
                  },
                },
                {image_border_radius: {
                    active: false,
                    type: 'numbergroup',
                    parentlabel: '',
                    top_left: null,
                    top_right: null,
                    bottom_left: null,
                    bottom_right: null,
                },
                }
              ],
              widgetconfigs: [
                {view_label: {active: false, type: 'label', text: 'View Settings', parentname: 'spacing_label'},},
                {view: viewOptionConfigs.view.default,},
                {columns_label: {active: false, type: 'label', text: 'Grid Gallery Settings', parentname: 'spacing_label',  dependentOn: {field: 'view', value: 'grid'}},},
                {columns: viewOptionConfigs.columns,},
                {column: viewOptionConfigs.column,},
                {carousel_label: {active: false, type: 'label', text: 'Carousel Gallery Settings', parentname: 'border_label', dependentOn: {field: 'view', value: 'carousel'},},},
                {carousel: viewOptionConfigs.carousel.products2,},
                {masonry_label: {active: false, type: 'label', text: 'Masonry Gallery Settings', parentname: 'border_label', dependentOn: {field: 'view', value: 'masonry'}},},
                {masonry: viewOptionConfigs.masonry,},
                {card_label: {active: false, type: 'label', text: 'Card Layout', parentname: 'alignment_label'},},
                {card_layout: {active: false, type: 'radiogroup', isButton: true, value: false, options: ['vertical', 'horizontal']},},
                {card_padding: {
                    active: false,
                    type: 'numbergroup',
                    parentlabel: '',
                    left: null,
                    right: null,
                    top: null,
                    bottom: null, 
                  },    
                  },
                  {card_margin: {
                      active: false,
                      type: 'numbergroup',
                      parentlabel: '',
                      left: null,
                      right: null,
                      top: null,
                      bottom: null,
                  },
                  },
                  {card_border_style: {
                        active: false, type: 'select', value: '', options: ['dotted','dashed','solid','double','groove','ridge','inset','outset','none','hidden']
                  },
                  },
                  {card_border: {
                      active: true,
                      type: 'numbergroup',
                      parentlabel: '',
                      left: 0,
                      right: 0,
                      top: 0,
                      bottom: 0,
                  },  
                  },
                  {card_border_colour: {
                      active: false,
                      value: '#000000',
                      type: 'color'
                    },
                  },
                  {card_border_radius: {
                      active: false,
                      type: 'numbergroup',
                      parentlabel: '',
                      top_left: null,
                      top_right: null,
                      bottom_left: null,
                      bottom_right: null,
                  }, 
                  
                    },
                    {card_body_padding: {
                    active: false,
                    type: 'numbergroup',
                    parentlabel: '',
                    left: null,
                    right: null,
                    top: null,
                    bottom: null, 
                  },    
                  },
                  {card_body_margin: {
                      active: false,
                      type: 'numbergroup',
                      parentlabel: '',
                      left: null,
                      right: null,
                      top: null,
                      bottom: null,
                  },
                  },
                  {card_body_border_style: {
                        active: false, type: 'select', value: '', options: ['dotted','dashed','solid','double','groove','ridge','inset','outset','none','hidden']
                  },
                  },
                  {card_body_border: {
                      active: true,
                      type: 'numbergroup',
                      parentlabel: '',
                      left: 0,
                      right: 0,
                      top: 0,
                      bottom: 0,
                  },  
                  },
                  {card_body_border_colour: {
                      active: false,
                      value: '#000000',
                      type: 'color'
                    },
                  },
                  {card_body_border_radius: {
                      active: false,
                      type: 'numbergroup',
                      parentlabel: '',
                      top_left: null,
                      top_right: null,
                      bottom_left: null,
                      bottom_right: null,
                  }, 
                },
                {title_label: {active: false, type: 'label', text: 'Card Title Options', parentname: 'alignment_label'},},
                {title: viewOptionConfigs.title_font
                },
                {text_label: {active: false, type: 'label', text: 'Card Body Text Options', parentname: 'alignment_label'},},
                {text: viewOptionConfigs.font2
                },
                {button_label: {active: false, type: 'label', text: 'Button Styles', parentname: 'alignment_label'},},
                {show_button: {active: false, type: 'radiogroup', isButton: true, value: false, options: [true,false]},},
                {button_position: {active: false, type: 'radiogroup', isButton: true, value: false, options: ['left', 'right', 'center']},},
                {button_hover_effect: {active: false, type: 'radiogroup', isButton: true, value: false, options: [true,false]},},
                {button_colour: {
                    active: false,
                    value: '#000000',
                    type: 'color'
                },
                },
                {button_text_colour: {
                    active: false,
                    value: '#000000',
                    type: 'color'
                },
                },
                {button_border_style: {
                    active: false, type: 'select', value: '', options: ['dotted','dashed','solid','double','groove','ridge','inset','outset','none','hidden']
                },
                },
                {button_border: {
                    active: true,
                    type: 'numbergroup',
                    parentlabel: '',
                    left: 0,
                    right: 0,
                    top: 0,
                    bottom: 0,
                },  
                },
                {button_border_radius: {
                    active: false,
                    type: 'numbergroup',
                    parentlabel: '',
                    top_left: null,
                    top_right: null,
                    bottom_left: null,
                    bottom_right: null,
                },
                },
                {button_border_colour: {
                    active: false,
                    value: '#000000',
                    type: 'color'
                },
                },
                {alignment_label: {active: false, type: 'label', text: 'Image Alignment', parentname: 'alignment_label'},
                },
                {text_align: {active: false, type: 'radiogroup', isButton: true, value: 'text-left', options: ['text-left', 'text-center', 'text-right']},
                },
                {fullwidth: {active: false, type: 'radiogroup', isButton: true, value: false, options: [true, false]},
                },
                {sizing_label: {active: false, type: 'label', text: 'Image Sizing', parentname: 'alignment_label'},
                },
                {image_width: {active: false, type: 'range', value: 'auto', units: '%', unit_options: ['px', '%'],  max: 2400, min: 0, parentlabel: 'sizing_label'},
                },
                {image_max_width: {active: false, type: 'range', value: 'auto', units: '%', unit_options: ['px', '%'],  max: 2400, min: 0, parentlabel: 'sizing_label'},
                },
                {image_height: {active: false, type: 'range', value: 'auto', units: '%', unit_options: ['px', '%'],  max: 2400, min: 0, parentlabel: 'sizing_label'},
                },
                {image_max_height: {active: false, type: 'range', value: 'auto', units: '%', unit_options: ['px', '%'],  max: 2400, min: 0, parentlabel: 'sizing_label'},
                },
                {spacing_label: {active: false, type: 'label', text: 'Image Spacing', parentname: 'alignment_label'},
                },
                {image_padding: {
                    active: false,
                    type: 'numbergroup',
                    parentlabel: '',
                    left: null,
                    right: null,
                    top: null,
                    bottom: null, 
                },
                },
                {image_margin: {
                    active: false,
                    type: 'numbergroup',
                    parentlabel: '',
                    left: null,
                    right: null,
                    top: null,
                    bottom: null,
                },
                },
                {image_border_label: {active: false, type: 'label', text: 'Borders', parentname: 'border_label'},
                },
                {image_border_style: {
                    active: false, type: 'select', value: '', options: ['dotted','dashed','solid','double','groove','ridge','inset','outset','none','hidden']
                },
                },
                {image_border: {
                    active: true,
                    type: 'numbergroup',
                    parentlabel: '',
                    left: 0,
                    right: 0,
                    top: 0,
                    bottom: 0,
                },
                },
                {image_border_colour: {
                    active: false,
                    value: '#000000',
                    type: 'color'
                },
                },
                {image_border_radius: {
                    active: false,
                    type: 'numbergroup',
                    parentlabel: '',
                    top_left: null,
                    top_right: null,
                    bottom_left: null,
                    bottom_right: null,
                },
                },
              ],
              widgetstyles: '',
              widgetelements: {
                    active_elements:  viewOptionDefaultValues.show_elements.products,
                    elements: viewOptionConfigs.show_elements.products.subfields,
                  },
              widgetfilters: {
                    filter: {search: {active: 0, type: 'hidden', value: ''}, categories: {active: 0, type: 'customselect', value: ''}, collections: {active: 0, type: 'customselect', value: []}, price_range: {active: 0, type: 'multirange', value: [0,999999]}, page: {active: 0, type: 'number', value: 1}, limit: {active: 0, type: 'range', value: 16}, order: {active: 0, type: 'select', value: 'DESC', options: ['ASC','DESC']}, sortby: {active: 0, type: 'select', value: 'id', options: ['id', 'name', 'created_at', 'updated_at']}},
                    active_filters: {search: {active: 0, type: 'hidden', value: ''}, categories: {active: 0, type: 'customselect', value: []}, collections: {active: 0, type: 'customselect', value: []}, price_range: {active: 0, type: 'multirange', value: [0,999999]}, page: {active: 0, type: 'number', value: 1}, limit: {active: 0, type: 'range', value: 16}, order: {active: 0, type: 'select', value: 'DESC', options: ['ASC','DESC']}, sortby: {active: 0, type: 'select', value: 'id', options: ['id', 'name', 'created_at', 'updated_at']}},
              },
              editable: 0,
              id: '',
            },
            {
              widgetname: 'Services',
              widgettype: 'services',
              widgeticon: 'bx bx-wrench',
              widgetcontent: [
                {config: {
                  view: 'grid',
                  view_options: ['grid', 'list', 'carousel'],
                  columns: '',
                  gutters: '',
                  carousel: {
                    autoplay: {type: 'switch', value: false},
                    arrows_navigation: {type: 'switch', value: false},
                    dots_navigation: {type: 'switch', value: false},
                    total: {type: 'number', value: 12},
                    show: {type: 'number', value: 4},
                    loop: {type: 'switch', value: false},
                  },
                  size: {type: 'cols', xl: 4, lg: 4, md: 4, sm: 12, xs: 12 },
                  column_templates: viewOptionConfigs.column_templates,
                  
                },
                },
                {list: [],
                },
                {view: viewOptionDefaultValues.view,
                },
                {columns: viewOptionDefaultValues.columns,
                },
                {column: viewOptionDefaultValues.column,
                },
                {carousel: viewOptionDefaultValues.carousel,
                },
                {masonry: viewOptionDefaultValues.masonry,                
                },
                {card_layout: {value: 'vertical', units: ''},
               },
               { card_padding: {
                    active: false,
                    type: 'numbergroup',
                    parentlabel: '',
                    left: null,
                    right: null,
                    top: null,
                    bottom: null, 
                  },    
                  },
                  {card_margin: {
                      active: false,
                      type: 'numbergroup',
                      parentlabel: '',
                      left: null,
                      right: null,
                      top: null,
                      bottom: null,
                  },
                  },
                  {card_border_style: {
                        active: false, type: 'select', value: '', options: ['dotted','dashed','solid','double','groove','ridge','inset','outset','none','hidden']
                  },
                  },
                  {card_border: {
                      active: true,
                      type: 'numbergroup',
                      parentlabel: '',
                      left: 0,
                      right: 0,
                      top: 0,
                      bottom: 0,
                  },  
                  },
                  {card_border_colour: {
                      active: false,
                      value: '#000000',
                      type: 'color'
                    },
                  },
                  {card_border_radius: {
                      active: false,
                      type: 'numbergroup',
                      parentlabel: '',
                      top_left: null,
                      top_right: null,
                      bottom_left: null,
                      bottom_right: null,
                  }, 
                  
                },
                {card_body_padding: {
                    active: false,
                    type: 'numbergroup',
                    parentlabel: '',
                    left: null,
                    right: null,
                    top: null,
                    bottom: null, 
                  },    
                  },
                  {card_body_margin: {
                      active: false,
                      type: 'numbergroup',
                      parentlabel: '',
                      left: null,
                      right: null,
                      top: null,
                      bottom: null,
                  },
                  },
                  {card_body_border_style: {
                        active: false, type: 'select', value: '', options: ['dotted','dashed','solid','double','groove','ridge','inset','outset','none','hidden']
                  },
                  },
                  {card_body_border: {
                      active: true,
                      type: 'numbergroup',
                      parentlabel: '',
                      left: 0,
                      right: 0,
                      top: 0,
                      bottom: 0,
                  },  
                  },
                  {card_body_border_colour: {
                      active: false,
                      value: '#000000',
                      type: 'color'
                    },
                  },
                  {card_body_border_radius: {
                      active: false,
                      type: 'numbergroup',
                      parentlabel: '',
                      top_left: null,
                      top_right: null,
                      bottom_left: null,
                      bottom_right: null,
                  }, 
                },
                {
                    show_button: {value: true, units: ''},
                },
                {title: viewOptionDefaultValues.title_font
                },
                {text: viewOptionDefaultValues.font2
                },
                {button_position: {value: 'vertical', units: ''},
                },
                {button_hover_effect: {value: false, units: ''},
                },
                {button_colour: {
                    active: false,
                    value: '',
                    units: ''
                },
                },
                {button_text_colour: {
                    active: false,
                    value: '',
                    units: ''
                },
                },
                {button_border_radius: {
                    active: true,
                    type: 'numbergroup',
                    parentlabel: '',
                    left: 0,
                    right: 0,
                    top: 0,
                    bottom: 0,
                },
                },
                {button_border_style: {
                    active: false,
                    value: '',
                    units: ''
                },
                },
                {button_border: {
                    active: true,
                    type: 'numbergroup',
                    parentlabel: '',
                    left: 0,
                    right: 0,
                    top: 0,
                    bottom: 0,
                },  
                },
                {button_border_colour: {
                    active: false,
                    value: '',
                    units: ''
                },
                },
                {text_align: {value: 'text-left', units: ''},
                },
                {fullwidth: {value: false, units: ''},
                },
                {image_width: {value: 'auto', units: '%'},
                },
                {image_height: {value: 'auto', units: '%'},
                },
                {image_max_width: {value: 'auto', units: '%'},
                },
                {image_max_height: {value: 'auto', units: '%'},
                },
                {image_padding: {
                    active: false,
                    type: 'numbergroup',
                    parentlabel: '',
                    left: null,
                    right: null,
                    top: null,
                    bottom: null, 
                },    
                },
                {image_margin: {
                    active: false,
                    type: 'numbergroup',
                    parentlabel: '',
                    left: null,
                    right: null,
                    top: null,
                    bottom: null,
                },
                },
                {image_border_label: {active: false, type: 'label', text: 'Borders', parentname: 'border_label'},
                },
                {image_border_style: {
                      active: false, type: 'select', value: '', options: ['dotted','dashed','solid','double','groove','ridge','inset','outset','none','hidden']
                },
                },
                {image_border: {
                    active: true,
                    type: 'numbergroup',
                    parentlabel: '',
                    left: 0,
                    right: 0,
                    top: 0,
                    bottom: 0,
                },  
                },
                {image_border_colour: {
                    active: false,
                    value: '#000000',
                    type: 'color'
                  },
                },
                {image_border_radius: {
                    active: false,
                    type: 'numbergroup',
                    parentlabel: '',
                    top_left: null,
                    top_right: null,
                    bottom_left: null,
                    bottom_right: null,
                },
                }
              ],
              widgetconfigs: [
                {view_label: {active: false, type: 'label', text: 'View Settings', parentname: 'spacing_label'},},
                {view: viewOptionConfigs.view.default,},
                {columns_label: {active: false, type: 'label', text: 'Grid Gallery Settings', parentname: 'spacing_label',  dependentOn: {field: 'view', value: 'grid'}},},
                {columns: viewOptionConfigs.columns,},
                {column: viewOptionConfigs.column,},
                {carousel_label: {active: false, type: 'label', text: 'Carousel Gallery Settings', parentname: 'border_label', dependentOn: {field: 'view', value: 'carousel'},},},
                {carousel: viewOptionConfigs.carousel.products2,},
                {masonry_label: {active: false, type: 'label', text: 'Masonry Gallery Settings', parentname: 'border_label', dependentOn: {field: 'view', value: 'masonry'}},},
                {masonry: viewOptionConfigs.masonry,},
                {card_label: {active: false, type: 'label', text: 'Card Layout', parentname: 'alignment_label'},},
                {card_layout: {active: false, type: 'radiogroup', isButton: true, value: false, options: ['vertical', 'horizontal']},},
                {card_padding: {
                    active: false,
                    type: 'numbergroup',
                    parentlabel: '',
                    left: null,
                    right: null,
                    top: null,
                    bottom: null, 
                  },    
                  },
                  {card_margin: {
                      active: false,
                      type: 'numbergroup',
                      parentlabel: '',
                      left: null,
                      right: null,
                      top: null,
                      bottom: null,
                  },
                  },
                  {card_border_style: {
                        active: false, type: 'select', value: '', options: ['dotted','dashed','solid','double','groove','ridge','inset','outset','none','hidden']
                  },
                  },
                  {card_border: {
                      active: true,
                      type: 'numbergroup',
                      parentlabel: '',
                      left: 0,
                      right: 0,
                      top: 0,
                      bottom: 0,
                  },  
                  },
                  {card_border_colour: {
                      active: false,
                      value: '#000000',
                      type: 'color'
                    },
                  },
                  {card_border_radius: {
                      active: false,
                      type: 'numbergroup',
                      parentlabel: '',
                      top_left: null,
                      top_right: null,
                      bottom_left: null,
                      bottom_right: null,
                  }, 
                  
                    },
                    {card_body_padding: {
                    active: false,
                    type: 'numbergroup',
                    parentlabel: '',
                    left: null,
                    right: null,
                    top: null,
                    bottom: null, 
                  },    
                  },
                  {card_body_margin: {
                      active: false,
                      type: 'numbergroup',
                      parentlabel: '',
                      left: null,
                      right: null,
                      top: null,
                      bottom: null,
                  },
                  },
                  {card_body_border_style: {
                        active: false, type: 'select', value: '', options: ['dotted','dashed','solid','double','groove','ridge','inset','outset','none','hidden']
                  },
                  },
                  {card_body_border: {
                      active: true,
                      type: 'numbergroup',
                      parentlabel: '',
                      left: 0,
                      right: 0,
                      top: 0,
                      bottom: 0,
                  },  
                  },
                  {card_body_border_colour: {
                      active: false,
                      value: '#000000',
                      type: 'color'
                    },
                  },
                  {card_body_border_radius: {
                      active: false,
                      type: 'numbergroup',
                      parentlabel: '',
                      top_left: null,
                      top_right: null,
                      bottom_left: null,
                      bottom_right: null,
                  }, 
                },
                {title_label: {active: false, type: 'label', text: 'Card Title Options', parentname: 'alignment_label'},},
                {title: viewOptionConfigs.title_font
                },
                {text_label: {active: false, type: 'label', text: 'Card Body Text Options', parentname: 'alignment_label'},},
                {text: viewOptionConfigs.font2
                },
                {button_label: {active: false, type: 'label', text: 'Button Styles', parentname: 'alignment_label'},},
                {show_button: {active: false, type: 'radiogroup', isButton: true, value: false, options: [true,false]},},
                {button_position: {active: false, type: 'radiogroup', isButton: true, value: false, options: ['left', 'right', 'center']},},
                {button_hover_effect: {active: false, type: 'radiogroup', isButton: true, value: false, options: [true,false]},},
                {button_colour: {
                    active: false,
                    value: '#000000',
                    type: 'color'
                },
                },
                {button_text_colour: {
                    active: false,
                    value: '#000000',
                    type: 'color'
                },
                },
                {button_border_style: {
                    active: false, type: 'select', value: '', options: ['dotted','dashed','solid','double','groove','ridge','inset','outset','none','hidden']
                },
                },
                {button_border: {
                    active: true,
                    type: 'numbergroup',
                    parentlabel: '',
                    left: 0,
                    right: 0,
                    top: 0,
                    bottom: 0,
                },  
                },
                {button_border_radius: {
                    active: false,
                    type: 'numbergroup',
                    parentlabel: '',
                    top_left: null,
                    top_right: null,
                    bottom_left: null,
                    bottom_right: null,
                },
                },
                {button_border_colour: {
                    active: false,
                    value: '#000000',
                    type: 'color'
                },
                },
                {alignment_label: {active: false, type: 'label', text: 'Image Alignment', parentname: 'alignment_label'},
                },
                {text_align: {active: false, type: 'radiogroup', isButton: true, value: 'text-left', options: ['text-left', 'text-center', 'text-right']},
                },
                {fullwidth: {active: false, type: 'radiogroup', isButton: true, value: false, options: [true, false]},
                },
                {sizing_label: {active: false, type: 'label', text: 'Image Sizing', parentname: 'alignment_label'},
                },
                {image_width: {active: false, type: 'range', value: 'auto', units: '%', unit_options: ['px', '%'],  max: 2400, min: 0, parentlabel: 'sizing_label'},
                },
                {image_max_width: {active: false, type: 'range', value: 'auto', units: '%', unit_options: ['px', '%'],  max: 2400, min: 0, parentlabel: 'sizing_label'},
                },
                {image_height: {active: false, type: 'range', value: 'auto', units: '%', unit_options: ['px', '%'],  max: 2400, min: 0, parentlabel: 'sizing_label'},
                },
                {image_max_height: {active: false, type: 'range', value: 'auto', units: '%', unit_options: ['px', '%'],  max: 2400, min: 0, parentlabel: 'sizing_label'},
                },
                {spacing_label: {active: false, type: 'label', text: 'Image Spacing', parentname: 'alignment_label'},
                },
                {image_padding: {
                    active: false,
                    type: 'numbergroup',
                    parentlabel: '',
                    left: null,
                    right: null,
                    top: null,
                    bottom: null, 
                },
                },
                {image_margin: {
                    active: false,
                    type: 'numbergroup',
                    parentlabel: '',
                    left: null,
                    right: null,
                    top: null,
                    bottom: null,
                },
                },
                {image_border_label: {active: false, type: 'label', text: 'Borders', parentname: 'border_label'},
                },
                {image_border_style: {
                    active: false, type: 'select', value: '', options: ['dotted','dashed','solid','double','groove','ridge','inset','outset','none','hidden']
                },
                },
                {image_border: {
                    active: true,
                    type: 'numbergroup',
                    parentlabel: '',
                    left: 0,
                    right: 0,
                    top: 0,
                    bottom: 0,
                },
                },
                {image_border_colour: {
                    active: false,
                    value: '#000000',
                    type: 'color'
                },
                },
                {image_border_radius: {
                    active: false,
                    type: 'numbergroup',
                    parentlabel: '',
                    top_left: null,
                    top_right: null,
                    bottom_left: null,
                    bottom_right: null,
                },
                },
              ],
              widgetstyles: '',
              widgetelements: {
                    active_elements:  viewOptionDefaultValues.show_elements.products,
                    elements: viewOptionConfigs.show_elements.products.subfields,
                  },
              widgetfilters: {
                    filter: {categories: {active: 0, type: 'customselect', value: ''}, collections: {active: 0, type: 'customselect', value: ''}, price_range: {active: 0, type: 'multirange', value: [0,999999]}, page: {active: 0, type: 'number', value: 1}, limit: {active: 0, type: 'range', value: 25}, order: {active: 0, type: 'select', value: 'DESC', options: ['ASC','DESC']}, sortby: {active: 0, type: 'select', value: 'id', options: ['id', 'name', 'created_at', 'updated_at']}},
                    active_filters: {categories: {active: 0, type: 'customselect', value: ''}, collections: {active: 0, type: 'customselect', value: ''}, price_range: {active: 0, type: 'multirange', value: [0,999999]}, page: {active: 0, type: 'number', value: 1}, limit: {active: 0, type: 'range', value: 25}, order: {active: 0, type: 'select', value: 'DESC', options: ['ASC','DESC']}, sortby: {active: 0, type: 'select', value: 'id', options: ['id', 'name', 'created_at', 'updated_at']}},
              },
              editable: 0,
              id: '',
            },
            {
              widgetname: 'Collections',
              widgettype: 'collections',
              widgeticon: 'bx bx-grid',
               widgetcontent: [
                {config: {
                  view: 'grid',
                  view_options: ['grid', 'list', 'carousel'],
                  columns: '',
                  gutters: '',
                  carousel: {
                    autoplay: {type: 'switch', value: false},
                    arrows_navigation: {type: 'switch', value: false},
                    dots_navigation: {type: 'switch', value: false},
                    total: {type: 'number', value: 12},
                    show: {type: 'number', value: 4},
                    loop: {type: 'switch', value: false},
                  },
                  size: {type: 'cols', xl: 4, lg: 4, md: 4, sm: 12, xs: 12 },
                  column_templates: viewOptionConfigs.column_templates,
                  
                },
                },
                {list: [],
                },
                {view: viewOptionDefaultValues.view,
                },
                {columns: viewOptionDefaultValues.columns,
                },
                {column: viewOptionDefaultValues.column,
                },
                {carousel: viewOptionDefaultValues.carousel,
                },
                {masonry: viewOptionDefaultValues.masonry,                
                },
                {card_layout: {value: 'vertical', units: ''},
               },
               { card_padding: {
                    active: false,
                    type: 'numbergroup',
                    parentlabel: '',
                    left: null,
                    right: null,
                    top: null,
                    bottom: null, 
                  },    
                  },
                  {card_margin: {
                      active: false,
                      type: 'numbergroup',
                      parentlabel: '',
                      left: null,
                      right: null,
                      top: null,
                      bottom: null,
                  },
                  },
                  {card_border_style: {
                        active: false, type: 'select', value: '', options: ['dotted','dashed','solid','double','groove','ridge','inset','outset','none','hidden']
                  },
                  },
                  {card_border: {
                      active: true,
                      type: 'numbergroup',
                      parentlabel: '',
                      left: 0,
                      right: 0,
                      top: 0,
                      bottom: 0,
                  },  
                  },
                  {card_border_colour: {
                      active: false,
                      value: '#000000',
                      type: 'color'
                    },
                  },
                  {card_border_radius: {
                      active: false,
                      type: 'numbergroup',
                      parentlabel: '',
                      top_left: null,
                      top_right: null,
                      bottom_left: null,
                      bottom_right: null,
                  }, 
                  
                },
                {card_body_padding: {
                    active: false,
                    type: 'numbergroup',
                    parentlabel: '',
                    left: null,
                    right: null,
                    top: null,
                    bottom: null, 
                  },    
                  },
                  {card_body_margin: {
                      active: false,
                      type: 'numbergroup',
                      parentlabel: '',
                      left: null,
                      right: null,
                      top: null,
                      bottom: null,
                  },
                  },
                  {card_body_border_style: {
                        active: false, type: 'select', value: '', options: ['dotted','dashed','solid','double','groove','ridge','inset','outset','none','hidden']
                  },
                  },
                  {card_body_border: {
                      active: true,
                      type: 'numbergroup',
                      parentlabel: '',
                      left: 0,
                      right: 0,
                      top: 0,
                      bottom: 0,
                  },  
                  },
                  {card_body_border_colour: {
                      active: false,
                      value: '#000000',
                      type: 'color'
                    },
                  },
                  {card_body_border_radius: {
                      active: false,
                      type: 'numbergroup',
                      parentlabel: '',
                      top_left: null,
                      top_right: null,
                      bottom_left: null,
                      bottom_right: null,
                  }, 
                },
                {
                    show_button: {value: true, units: ''},
                },
                {title: viewOptionDefaultValues.title_font
                },
                {text: viewOptionDefaultValues.font2
                },
                {button_position: {value: 'vertical', units: ''},
                },
                {button_hover_effect: {value: false, units: ''},
                },
                {button_colour: {
                    active: false,
                    value: '',
                    units: ''
                },
                },
                {button_text_colour: {
                    active: false,
                    value: '',
                    units: ''
                },
                },
                {button_border_radius: {
                    active: true,
                    type: 'numbergroup',
                    parentlabel: '',
                    left: 0,
                    right: 0,
                    top: 0,
                    bottom: 0,
                },
                },
                {button_border_style: {
                    active: false,
                    value: '',
                    units: ''
                },
                },
                {button_border: {
                    active: true,
                    type: 'numbergroup',
                    parentlabel: '',
                    left: 0,
                    right: 0,
                    top: 0,
                    bottom: 0,
                },  
                },
                {button_border_colour: {
                    active: false,
                    value: '',
                    units: ''
                },
                },
                {text_align: {value: 'text-left', units: ''},
                },
                {fullwidth: {value: false, units: ''},
                },
                {image_width: {value: 'auto', units: '%'},
                },
                {image_height: {value: 'auto', units: '%'},
                },
                {image_max_width: {value: 'auto', units: '%'},
                },
                {image_max_height: {value: 'auto', units: '%'},
                },
                {image_padding: {
                    active: false,
                    type: 'numbergroup',
                    parentlabel: '',
                    left: null,
                    right: null,
                    top: null,
                    bottom: null, 
                },    
                },
                {image_margin: {
                    active: false,
                    type: 'numbergroup',
                    parentlabel: '',
                    left: null,
                    right: null,
                    top: null,
                    bottom: null,
                },
                },
                {image_border_label: {active: false, type: 'label', text: 'Borders', parentname: 'border_label'},
                },
                {image_border_style: {
                      active: false, type: 'select', value: '', options: ['dotted','dashed','solid','double','groove','ridge','inset','outset','none','hidden']
                },
                },
                {image_border: {
                    active: true,
                    type: 'numbergroup',
                    parentlabel: '',
                    left: 0,
                    right: 0,
                    top: 0,
                    bottom: 0,
                },  
                },
                {image_border_colour: {
                    active: false,
                    value: '#000000',
                    type: 'color'
                  },
                },
                {image_border_radius: {
                    active: false,
                    type: 'numbergroup',
                    parentlabel: '',
                    top_left: null,
                    top_right: null,
                    bottom_left: null,
                    bottom_right: null,
                },
                }
              ],
              widgetconfigs: [
                {view_label: {active: false, type: 'label', text: 'View Settings', parentname: 'spacing_label'},},
                {view: viewOptionConfigs.view.default,},
                {columns_label: {active: false, type: 'label', text: 'Grid Gallery Settings', parentname: 'spacing_label',  dependentOn: {field: 'view', value: 'grid'}},},
                {columns: viewOptionConfigs.columns,},
                {column: viewOptionConfigs.column,},
                {carousel_label: {active: false, type: 'label', text: 'Carousel Gallery Settings', parentname: 'border_label', dependentOn: {field: 'view', value: 'carousel'},},},
                {carousel: viewOptionConfigs.carousel.products2,},
                {masonry_label: {active: false, type: 'label', text: 'Masonry Gallery Settings', parentname: 'border_label', dependentOn: {field: 'view', value: 'masonry'}},},
                {masonry: viewOptionConfigs.masonry,},
                {card_label: {active: false, type: 'label', text: 'Card Layout', parentname: 'alignment_label'},},
                {card_layout: {active: false, type: 'radiogroup', isButton: true, value: false, options: ['vertical', 'horizontal']},},
                {card_padding: {
                    active: false,
                    type: 'numbergroup',
                    parentlabel: '',
                    left: null,
                    right: null,
                    top: null,
                    bottom: null, 
                  },    
                  },
                  {card_margin: {
                      active: false,
                      type: 'numbergroup',
                      parentlabel: '',
                      left: null,
                      right: null,
                      top: null,
                      bottom: null,
                  },
                  },
                  {card_border_style: {
                        active: false, type: 'select', value: '', options: ['dotted','dashed','solid','double','groove','ridge','inset','outset','none','hidden']
                  },
                  },
                  {card_border: {
                      active: true,
                      type: 'numbergroup',
                      parentlabel: '',
                      left: 0,
                      right: 0,
                      top: 0,
                      bottom: 0,
                  },  
                  },
                  {card_border_colour: {
                      active: false,
                      value: '#000000',
                      type: 'color'
                    },
                  },
                  {card_border_radius: {
                      active: false,
                      type: 'numbergroup',
                      parentlabel: '',
                      top_left: null,
                      top_right: null,
                      bottom_left: null,
                      bottom_right: null,
                  }, 
                  
                    },
                    {card_body_padding: {
                    active: false,
                    type: 'numbergroup',
                    parentlabel: '',
                    left: null,
                    right: null,
                    top: null,
                    bottom: null, 
                  },    
                  },
                  {card_body_margin: {
                      active: false,
                      type: 'numbergroup',
                      parentlabel: '',
                      left: null,
                      right: null,
                      top: null,
                      bottom: null,
                  },
                  },
                  {card_body_border_style: {
                        active: false, type: 'select', value: '', options: ['dotted','dashed','solid','double','groove','ridge','inset','outset','none','hidden']
                  },
                  },
                  {card_body_border: {
                      active: true,
                      type: 'numbergroup',
                      parentlabel: '',
                      left: 0,
                      right: 0,
                      top: 0,
                      bottom: 0,
                  },  
                  },
                  {card_body_border_colour: {
                      active: false,
                      value: '#000000',
                      type: 'color'
                    },
                  },
                  {card_body_border_radius: {
                      active: false,
                      type: 'numbergroup',
                      parentlabel: '',
                      top_left: null,
                      top_right: null,
                      bottom_left: null,
                      bottom_right: null,
                  }, 
                },
                {title_label: {active: false, type: 'label', text: 'Card Title Options', parentname: 'alignment_label'},},
                {title: viewOptionConfigs.title_font
                },
                {text_label: {active: false, type: 'label', text: 'Card Body Text Options', parentname: 'alignment_label'},},
                {text: viewOptionConfigs.font2
                },
                {button_label: {active: false, type: 'label', text: 'Button Styles', parentname: 'alignment_label'},},
                {show_button: {active: false, type: 'radiogroup', isButton: true, value: false, options: [true,false]},},
                {button_position: {active: false, type: 'radiogroup', isButton: true, value: false, options: ['left', 'right', 'center']},},
                {button_hover_effect: {active: false, type: 'radiogroup', isButton: true, value: false, options: [true,false]},},
                {button_colour: {
                    active: false,
                    value: '#000000',
                    type: 'color'
                },
                },
                {button_text_colour: {
                    active: false,
                    value: '#000000',
                    type: 'color'
                },
                },
                {button_border_style: {
                    active: false, type: 'select', value: '', options: ['dotted','dashed','solid','double','groove','ridge','inset','outset','none','hidden']
                },
                },
                {button_border: {
                    active: true,
                    type: 'numbergroup',
                    parentlabel: '',
                    left: 0,
                    right: 0,
                    top: 0,
                    bottom: 0,
                },  
                },
                {button_border_radius: {
                    active: false,
                    type: 'numbergroup',
                    parentlabel: '',
                    top_left: null,
                    top_right: null,
                    bottom_left: null,
                    bottom_right: null,
                },
                },
                {button_border_colour: {
                    active: false,
                    value: '#000000',
                    type: 'color'
                },
                },
                {alignment_label: {active: false, type: 'label', text: 'Image Alignment', parentname: 'alignment_label'},
                },
                {text_align: {active: false, type: 'radiogroup', isButton: true, value: 'text-left', options: ['text-left', 'text-center', 'text-right']},
                },
                {fullwidth: {active: false, type: 'radiogroup', isButton: true, value: false, options: [true, false]},
                },
                {sizing_label: {active: false, type: 'label', text: 'Image Sizing', parentname: 'alignment_label'},
                },
                {image_width: {active: false, type: 'range', value: 'auto', units: '%', unit_options: ['px', '%'],  max: 2400, min: 0, parentlabel: 'sizing_label'},
                },
                {image_max_width: {active: false, type: 'range', value: 'auto', units: '%', unit_options: ['px', '%'],  max: 2400, min: 0, parentlabel: 'sizing_label'},
                },
                {image_height: {active: false, type: 'range', value: 'auto', units: '%', unit_options: ['px', '%'],  max: 2400, min: 0, parentlabel: 'sizing_label'},
                },
                {image_max_height: {active: false, type: 'range', value: 'auto', units: '%', unit_options: ['px', '%'],  max: 2400, min: 0, parentlabel: 'sizing_label'},
                },
                {spacing_label: {active: false, type: 'label', text: 'Image Spacing', parentname: 'alignment_label'},
                },
                {image_padding: {
                    active: false,
                    type: 'numbergroup',
                    parentlabel: '',
                    left: null,
                    right: null,
                    top: null,
                    bottom: null, 
                },
                },
                {image_margin: {
                    active: false,
                    type: 'numbergroup',
                    parentlabel: '',
                    left: null,
                    right: null,
                    top: null,
                    bottom: null,
                },
                },
                {image_border_label: {active: false, type: 'label', text: 'Borders', parentname: 'border_label'},
                },
                {image_border_style: {
                    active: false, type: 'select', value: '', options: ['dotted','dashed','solid','double','groove','ridge','inset','outset','none','hidden']
                },
                },
                {image_border: {
                    active: true,
                    type: 'numbergroup',
                    parentlabel: '',
                    left: 0,
                    right: 0,
                    top: 0,
                    bottom: 0,
                },
                },
                {image_border_colour: {
                    active: false,
                    value: '#000000',
                    type: 'color'
                },
                },
                {image_border_radius: {
                    active: false,
                    type: 'numbergroup',
                    parentlabel: '',
                    top_left: null,
                    top_right: null,
                    bottom_left: null,
                    bottom_right: null,
                },
                },
              ],
              widgetstyles: '',
              widgetelements: {
                    active_elements: viewOptionDefaultValues.show_elements.products,
                    elements: viewOptionConfigs.show_elements.products.subfields,
                  },
              widgetfilters: {
                    filter: {page: {active: 0, type: 'number', value: 1}, limit: {active: 0, type: 'range', value: 25}, order: {active: 0, type: 'select', value: 'DESC', options: ['ASC','DESC']}, sortby: {active: 0, type: 'select', value: 'id', options: ['id', 'name', 'created_at', 'updated_at']}},
                    active_filters: {page: {active: 0, type: 'number', value: 1}, limit: {active: 0, type: 'range', value: 25}, order: {active: 0, type: 'select', value: 'DESC', options: ['ASC','DESC']}, sortby: {active: 0, type: 'select', value: 'id', options: ['id', 'name', 'created_at', 'updated_at']}},
              },
              editable: 0,
              id: '',
            },
            {
              widgetname: 'Categories',
              widgettype: 'categories',
              widgeticon: 'bx bx-grid',
               widgetcontent: [
                {config: {
                  view: 'grid',
                  view_options: ['grid', 'list', 'carousel'],
                  columns: '',
                  gutters: '',
                  carousel: {
                    autoplay: {type: 'switch', value: false},
                    arrows_navigation: {type: 'switch', value: false},
                    dots_navigation: {type: 'switch', value: false},
                    total: {type: 'number', value: 12},
                    show: {type: 'number', value: 4},
                    loop: {type: 'switch', value: false},
                  },
                  size: {type: 'cols', xl: 4, lg: 4, md: 4, sm: 12, xs: 12 },
                  column_templates: viewOptionConfigs.column_templates,
                  
                },
                },
                {list: [],
                },
                {view: viewOptionDefaultValues.view,
                },
                {columns: viewOptionDefaultValues.columns,
                },
                {column: viewOptionDefaultValues.column,
                },
                {carousel: viewOptionDefaultValues.carousel,
                },
                {masonry: viewOptionDefaultValues.masonry,                
                },
                {card_layout: {value: 'vertical', units: ''},
               },
               { card_padding: {
                    active: false,
                    type: 'numbergroup',
                    parentlabel: '',
                    left: null,
                    right: null,
                    top: null,
                    bottom: null, 
                  },    
                  },
                  {card_margin: {
                      active: false,
                      type: 'numbergroup',
                      parentlabel: '',
                      left: null,
                      right: null,
                      top: null,
                      bottom: null,
                  },
                  },
                  {card_border_style: {
                        active: false, type: 'select', value: '', options: ['dotted','dashed','solid','double','groove','ridge','inset','outset','none','hidden']
                  },
                  },
                  {card_border: {
                      active: true,
                      type: 'numbergroup',
                      parentlabel: '',
                      left: 0,
                      right: 0,
                      top: 0,
                      bottom: 0,
                  },  
                  },
                  {card_border_colour: {
                      active: false,
                      value: '#000000',
                      type: 'color'
                    },
                  },
                  {card_border_radius: {
                      active: false,
                      type: 'numbergroup',
                      parentlabel: '',
                      top_left: null,
                      top_right: null,
                      bottom_left: null,
                      bottom_right: null,
                  }, 
                  
                },
                {card_body_padding: {
                    active: false,
                    type: 'numbergroup',
                    parentlabel: '',
                    left: null,
                    right: null,
                    top: null,
                    bottom: null, 
                  },    
                  },
                  {card_body_margin: {
                      active: false,
                      type: 'numbergroup',
                      parentlabel: '',
                      left: null,
                      right: null,
                      top: null,
                      bottom: null,
                  },
                  },
                  {card_body_border_style: {
                        active: false, type: 'select', value: '', options: ['dotted','dashed','solid','double','groove','ridge','inset','outset','none','hidden']
                  },
                  },
                  {card_body_border: {
                      active: true,
                      type: 'numbergroup',
                      parentlabel: '',
                      left: 0,
                      right: 0,
                      top: 0,
                      bottom: 0,
                  },  
                  },
                  {card_body_border_colour: {
                      active: false,
                      value: '#000000',
                      type: 'color'
                    },
                  },
                  {card_body_border_radius: {
                      active: false,
                      type: 'numbergroup',
                      parentlabel: '',
                      top_left: null,
                      top_right: null,
                      bottom_left: null,
                      bottom_right: null,
                  }, 
                },
                {
                    show_button: {value: true, units: ''},
                },
                {title: viewOptionDefaultValues.title_font
                },
                {text: viewOptionDefaultValues.font2
                },
                {button_position: {value: 'vertical', units: ''},
                },
                {button_hover_effect: {value: false, units: ''},
                },
                {button_colour: {
                    active: false,
                    value: '',
                    units: ''
                },
                },
                {button_text_colour: {
                    active: false,
                    value: '',
                    units: ''
                },
                },
                {button_border_radius: {
                    active: true,
                    type: 'numbergroup',
                    parentlabel: '',
                    left: 0,
                    right: 0,
                    top: 0,
                    bottom: 0,
                },
                },
                {button_border_style: {
                    active: false,
                    value: '',
                    units: ''
                },
                },
                {button_border: {
                    active: true,
                    type: 'numbergroup',
                    parentlabel: '',
                    left: 0,
                    right: 0,
                    top: 0,
                    bottom: 0,
                },  
                },
                {button_border_colour: {
                    active: false,
                    value: '',
                    units: ''
                },
                },
                {text_align: {value: 'text-left', units: ''},
                },
                {fullwidth: {value: false, units: ''},
                },
                {image_width: {value: 'auto', units: '%'},
                },
                {image_height: {value: 'auto', units: '%'},
                },
                {image_max_width: {value: 'auto', units: '%'},
                },
                {image_max_height: {value: 'auto', units: '%'},
                },
                {image_padding: {
                    active: false,
                    type: 'numbergroup',
                    parentlabel: '',
                    left: null,
                    right: null,
                    top: null,
                    bottom: null, 
                },    
                },
                {image_margin: {
                    active: false,
                    type: 'numbergroup',
                    parentlabel: '',
                    left: null,
                    right: null,
                    top: null,
                    bottom: null,
                },
                },
                {image_border_label: {active: false, type: 'label', text: 'Borders', parentname: 'border_label'},
                },
                {image_border_style: {
                      active: false, type: 'select', value: '', options: ['dotted','dashed','solid','double','groove','ridge','inset','outset','none','hidden']
                },
                },
                {image_border: {
                    active: true,
                    type: 'numbergroup',
                    parentlabel: '',
                    left: 0,
                    right: 0,
                    top: 0,
                    bottom: 0,
                },  
                },
                {image_border_colour: {
                    active: false,
                    value: '#000000',
                    type: 'color'
                  },
                },
                {image_border_radius: {
                    active: false,
                    type: 'numbergroup',
                    parentlabel: '',
                    top_left: null,
                    top_right: null,
                    bottom_left: null,
                    bottom_right: null,
                },
                }
              ],
              widgetconfigs: [
                {view_label: {active: false, type: 'label', text: 'View Settings', parentname: 'spacing_label'},},
                {view: viewOptionConfigs.view.default,},
                {columns_label: {active: false, type: 'label', text: 'Grid Gallery Settings', parentname: 'spacing_label',  dependentOn: {field: 'view', value: 'grid'}},},
                {columns: viewOptionConfigs.columns,},
                {column: viewOptionConfigs.column,},
                {carousel_label: {active: false, type: 'label', text: 'Carousel Gallery Settings', parentname: 'border_label', dependentOn: {field: 'view', value: 'carousel'},},},
                {carousel: viewOptionConfigs.carousel.products2,},
                {masonry_label: {active: false, type: 'label', text: 'Masonry Gallery Settings', parentname: 'border_label', dependentOn: {field: 'view', value: 'masonry'}},},
                {masonry: viewOptionConfigs.masonry,},
                {card_label: {active: false, type: 'label', text: 'Card Layout', parentname: 'alignment_label'},},
                {card_layout: {active: false, type: 'radiogroup', isButton: true, value: false, options: ['vertical', 'horizontal']},},
                {card_padding: {
                    active: false,
                    type: 'numbergroup',
                    parentlabel: '',
                    left: null,
                    right: null,
                    top: null,
                    bottom: null, 
                  },    
                  },
                  {card_margin: {
                      active: false,
                      type: 'numbergroup',
                      parentlabel: '',
                      left: null,
                      right: null,
                      top: null,
                      bottom: null,
                  },
                  },
                  {card_border_style: {
                        active: false, type: 'select', value: '', options: ['dotted','dashed','solid','double','groove','ridge','inset','outset','none','hidden']
                  },
                  },
                  {card_border: {
                      active: true,
                      type: 'numbergroup',
                      parentlabel: '',
                      left: 0,
                      right: 0,
                      top: 0,
                      bottom: 0,
                  },  
                  },
                  {card_border_colour: {
                      active: false,
                      value: '#000000',
                      type: 'color'
                    },
                  },
                  {card_border_radius: {
                      active: false,
                      type: 'numbergroup',
                      parentlabel: '',
                      top_left: null,
                      top_right: null,
                      bottom_left: null,
                      bottom_right: null,
                  }, 
                  
                    },
                    {card_body_padding: {
                    active: false,
                    type: 'numbergroup',
                    parentlabel: '',
                    left: null,
                    right: null,
                    top: null,
                    bottom: null, 
                  },    
                  },
                  {card_body_margin: {
                      active: false,
                      type: 'numbergroup',
                      parentlabel: '',
                      left: null,
                      right: null,
                      top: null,
                      bottom: null,
                  },
                  },
                  {card_body_border_style: {
                        active: false, type: 'select', value: '', options: ['dotted','dashed','solid','double','groove','ridge','inset','outset','none','hidden']
                  },
                  },
                  {card_body_border: {
                      active: true,
                      type: 'numbergroup',
                      parentlabel: '',
                      left: 0,
                      right: 0,
                      top: 0,
                      bottom: 0,
                  },  
                  },
                  {card_body_border_colour: {
                      active: false,
                      value: '#000000',
                      type: 'color'
                    },
                  },
                  {card_body_border_radius: {
                      active: false,
                      type: 'numbergroup',
                      parentlabel: '',
                      top_left: null,
                      top_right: null,
                      bottom_left: null,
                      bottom_right: null,
                  }, 
                },
                {title_label: {active: false, type: 'label', text: 'Card Title Options', parentname: 'alignment_label'},},
                {title: viewOptionConfigs.title_font
                },
                {text_label: {active: false, type: 'label', text: 'Card Body Text Options', parentname: 'alignment_label'},},
                {text: viewOptionConfigs.font2
                },
                {button_label: {active: false, type: 'label', text: 'Button Styles', parentname: 'alignment_label'},},
                {show_button: {active: false, type: 'radiogroup', isButton: true, value: false, options: [true,false]},},
                {button_position: {active: false, type: 'radiogroup', isButton: true, value: false, options: ['left', 'right', 'center']},},
                {button_hover_effect: {active: false, type: 'radiogroup', isButton: true, value: false, options: [true,false]},},
                {button_colour: {
                    active: false,
                    value: '#000000',
                    type: 'color'
                },
                },
                {button_text_colour: {
                    active: false,
                    value: '#000000',
                    type: 'color'
                },
                },
                {button_border_style: {
                    active: false, type: 'select', value: '', options: ['dotted','dashed','solid','double','groove','ridge','inset','outset','none','hidden']
                },
                },
                {button_border: {
                    active: true,
                    type: 'numbergroup',
                    parentlabel: '',
                    left: 0,
                    right: 0,
                    top: 0,
                    bottom: 0,
                },  
                },
                {button_border_radius: {
                    active: false,
                    type: 'numbergroup',
                    parentlabel: '',
                    top_left: null,
                    top_right: null,
                    bottom_left: null,
                    bottom_right: null,
                },
                },
                {button_border_colour: {
                    active: false,
                    value: '#000000',
                    type: 'color'
                },
                },
                {alignment_label: {active: false, type: 'label', text: 'Image Alignment', parentname: 'alignment_label'},
                },
                {text_align: {active: false, type: 'radiogroup', isButton: true, value: 'text-left', options: ['text-left', 'text-center', 'text-right']},
                },
                {fullwidth: {active: false, type: 'radiogroup', isButton: true, value: false, options: [true, false]},
                },
                {sizing_label: {active: false, type: 'label', text: 'Image Sizing', parentname: 'alignment_label'},
                },
                {image_width: {active: false, type: 'range', value: 'auto', units: '%', unit_options: ['px', '%'],  max: 2400, min: 0, parentlabel: 'sizing_label'},
                },
                {image_max_width: {active: false, type: 'range', value: 'auto', units: '%', unit_options: ['px', '%'],  max: 2400, min: 0, parentlabel: 'sizing_label'},
                },
                {image_height: {active: false, type: 'range', value: 'auto', units: '%', unit_options: ['px', '%'],  max: 2400, min: 0, parentlabel: 'sizing_label'},
                },
                {image_max_height: {active: false, type: 'range', value: 'auto', units: '%', unit_options: ['px', '%'],  max: 2400, min: 0, parentlabel: 'sizing_label'},
                },
                {spacing_label: {active: false, type: 'label', text: 'Image Spacing', parentname: 'alignment_label'},
                },
                {image_padding: {
                    active: false,
                    type: 'numbergroup',
                    parentlabel: '',
                    left: null,
                    right: null,
                    top: null,
                    bottom: null, 
                },
                },
                {image_margin: {
                    active: false,
                    type: 'numbergroup',
                    parentlabel: '',
                    left: null,
                    right: null,
                    top: null,
                    bottom: null,
                },
                },
                {image_border_label: {active: false, type: 'label', text: 'Borders', parentname: 'border_label'},
                },
                {image_border_style: {
                    active: false, type: 'select', value: '', options: ['dotted','dashed','solid','double','groove','ridge','inset','outset','none','hidden']
                },
                },
                {image_border: {
                    active: true,
                    type: 'numbergroup',
                    parentlabel: '',
                    left: 0,
                    right: 0,
                    top: 0,
                    bottom: 0,
                },
                },
                {image_border_colour: {
                    active: false,
                    value: '#000000',
                    type: 'color'
                },
                },
                {image_border_radius: {
                    active: false,
                    type: 'numbergroup',
                    parentlabel: '',
                    top_left: null,
                    top_right: null,
                    bottom_left: null,
                    bottom_right: null,
                },
                },
              ],
              widgetstyles: '',
              widgetelements: {
                    active_elements: viewOptionDefaultValues.show_elements.products,
                    elements: viewOptionConfigs.show_elements.products.subfields,
                  },
              widgetfilters: {
                    filter: {page: {active: 0, type: 'number', value: 1}, limit: {active: 0, type: 'range', value: 25}, order: {active: 0, type: 'select', value: 'DESC', options: ['ASC','DESC']}, sortby: {active: 0, type: 'select', value: 'id', options: ['id', 'name', 'created_at', 'updated_at']}},
                    active_filters: {page: {active: 0, type: 'number', value: 1}, limit: {active: 0, type: 'range', value: 25}, order: {active: 0, type: 'select', value: 'DESC', options: ['ASC','DESC']}, sortby: {active: 0, type: 'select', value: 'id', options: ['id', 'name', 'created_at', 'updated_at']}},
              },
              editable: 0,
              id: '',
            },
            {
              widgetname: 'Listings',
              widgettype: 'listings',
              widgeticon: 'bx bx-home-circle',
              widgetcontent: [
                {
                    config: {
                          view: 'grid',
                          view_options: ['grid', 'list', 'carousel'],
                          columns: '',
                          gutters: '',
                          carousel: {
                            autoplay: {type: 'switch', value: false},
                            arrows_navigation: {type: 'switch', value: false},
                            dots_navigation: {type: 'switch', value: false},
                            total: {type: 'number', value: 12},
                            show: {type: 'number', value: 4},
                            loop: {type: 'switch', value: false},
                          },
                          size: {type: 'cols', xl: 4, lg: 4, md: 4, sm: 12, xs: 12 },
                          column_templates: viewOptionConfigs.column_templates,
                          
                        },
                },
                {list: [],},
                {view: viewOptionDefaultValues.view,},
                {columns: viewOptionDefaultValues.columns,},
                {column: viewOptionDefaultValues.column,},
                {carousel: viewOptionDefaultValues.carousel,},
                {masonry: viewOptionDefaultValues.masonry,
                },
                {text_align: {value: 'text-left', units: ''},
                },
                {fullwidth: {value: false, units: ''},
                },
                {image_width: {value: 'auto', units: '%'},
                },
                {image_height: {value: 'auto', units: '%'},
                },
                {image_max_width: {value: 'auto', units: '%'},
                },
                {image_max_height: {value: 'auto', units: '%'},
                },
                {image_padding: {
                    active: false,
                    type: 'numbergroup',
                    parentlabel: '',
                    left: null,
                    right: null,
                    top: null,
                    bottom: null, 
                },    
                },
                {image_margin: {
                    active: false,
                    type: 'numbergroup',
                    parentlabel: '',
                    left: null,
                    right: null,
                    top: null,
                    bottom: null,
                },
                },
                {image_border_label: {active: false, type: 'label', text: 'Borders', parentname: 'border_label'},
                },
                {image_border_style: {
                      active: false, type: 'select', value: '', options: ['dotted','dashed','solid','double','groove','ridge','inset','outset','none','hidden']
                },
                },
                {image_border: {
                    active: true,
                    type: 'numbergroup',
                    parentlabel: '',
                    left: 0,
                    right: 0,
                    top: 0,
                    bottom: 0,
                },  
                },
                {image_border_colour: {
                    active: false,
                    value: '#000000',
                    type: 'color'
                  },
                },
                {
                    image_border_radius: {
                    active: false,
                    type: 'numbergroup',
                    parentlabel: '',
                    top_left: null,
                    top_right: null,
                    bottom_left: null,
                    bottom_right: null,
                    },
                },
              ],
              widgetconfigs: [
                {view_label: {active: false, type: 'label', text: 'View Settings', parentname: 'spacing_label'},},
                {view: viewOptionConfigs.view.default,},
                {columns_label: {active: false, type: 'label', text: 'Grid Gallery Settings', parentname: 'spacing_label',  dependentOn: {field: 'view', value: 'grid'}},},
                {columns: viewOptionConfigs.columns,},
                {column: viewOptionConfigs.column,},
                {carousel_label: {active: false, type: 'label', text: 'Carousel Gallery Settings', parentname: 'border_label', dependentOn: {field: 'view', value: 'carousel'},},},
                {carousel: viewOptionConfigs.carousel.default,},
                {masonry_label: {active: false, type: 'label', text: 'Masonry Gallery Settings', parentname: 'border_label', dependentOn: {field: 'view', value: 'masonry'}},},
                {masonry: viewOptionConfigs.masonry,},
                {alignment_label: {active: false, type: 'label', text: 'Image Alignment', parentname: 'alignment_label'},},
                {text_align: {active: false, type: 'radiogroup', isButton: true, value: 'text-left', options: ['text-left', 'text-center', 'text-right']},},
                {fullwidth: {active: false, type: 'radiogroup', isButton: true, value: false, options: [true, false]},},
                {sizing_label: {active: false, type: 'label', text: 'Image Sizing', parentname: 'alignment_label'},},
                {image_width: {active: false, type: 'range', value: 'auto', units: '%', unit_options: ['px', '%'],  max: 2400, min: 0, parentlabel: 'sizing_label'},},
                {image_max_width: {active: false, type: 'range', value: 'auto', units: '%', unit_options: ['px', '%'],  max: 2400, min: 0, parentlabel: 'sizing_label'},},
                {image_height: {active: false, type: 'range', value: 'auto', units: '%', unit_options: ['px', '%'],  max: 2400, min: 0, parentlabel: 'sizing_label'},},
                {image_max_height: {active: false, type: 'range', value: 'auto', units: '%', unit_options: ['px', '%'],  max: 2400, min: 0, parentlabel: 'sizing_label'},},
                {spacing_label: {active: false, type: 'label', text: 'Image Spacing', parentname: 'alignment_label'},},
                {image_padding: {
                    active: false,
                    type: 'numbergroup',
                    parentlabel: '',
                    left: null,
                    right: null,
                    top: null,
                    bottom: null, 
                },
                },
                {image_margin: {
                    active: false,
                    type: 'numbergroup',
                    parentlabel: '',
                    left: null,
                    right: null,
                    top: null,
                    bottom: null,
                },
                },
                {image_border_label: {active: false, type: 'label', text: 'Borders', parentname: 'border_label'},
                },
                {image_border_style: {
                    active: false, type: 'select', value: '', options: ['dotted','dashed','solid','double','groove','ridge','inset','outset','none','hidden']
                },
                },
                {image_border: {
                    active: true,
                    type: 'numbergroup',
                    parentlabel: '',
                    left: 0,
                    right: 0,
                    top: 0,
                    bottom: 0,
                },
                },
                {image_border_colour: {
                    active: false,
                    value: '#000000',
                    type: 'color'
                },
                },
                {image_border_radius: {
                    active: false,
                    type: 'numbergroup',
                    parentlabel: '',
                    top_left: null,
                    top_right: null,
                    bottom_left: null,
                    bottom_right: null,
                },
                },
              ],
              widgetstyles: '',
              widgetelements: {
                    active_elements: viewOptionDefaultValues.show_elements.products,
                    elements: viewOptionConfigs.show_elements.products.subfields,
              },
              widgetfilters: {
                    filter: {listing_type: {active: 0, type: 'custommultiselect', options: []}, page: {active: 0, type: 'number', value: 1}, limit: {active: 0, type: 'range', value: 25}, order: {active: 0, type: 'select', value: 'DESC', options: ['ASC','DESC']}, sortby: {active: 0, type: 'select', value: 'id', options: ['id', 'name', 'created_at', 'updated_at']}},
                    active_filters: {listing_type: {active: 0, type: 'custommultiselect', options: []}, page: {active: 0, type: 'number', value: 1}, limit: {active: 0, type: 'range', value: 25}, order: {active: 0, type: 'select', value: 'DESC', options: ['ASC','DESC']}, sortby: {active: 0, type: 'select', value: 'id', options: ['id', 'name', 'created_at', 'updated_at']}},
              },
              editable: 0,
              id: '',
            },
            {
              widgetname: 'Listings Map',
              widgettype: 'listingsmap',
              widgeticon: 'bx bx-map-pin',
              widgetcontent: [
                {config: {
                      view: 'grid',
                      view_options: ['grid', 'list'],
                      columns: '',
                      gutters: '',
                      size: {type: 'cols', xl: 4, lg: 4, md: 4, sm: 12, xs: 12 },
                      column_templates: {
                        one_column:  {type: 'cols', xl: 12, lg: 12, md: 12, sm: 12, xs: 12 },
                        two_columns:  {type: 'cols', xl: 6, lg: 6, md: 6, sm: 12, xs: 12 },
                        three_columns:  {type: 'cols', xl: 4, lg: 4, md: 4, sm: 12, xs: 12 },
                        four_columns:  {type: 'cols', xl: 3, lg: 3, md: 3, sm: 6, xs: 12 },
                      },
                      
                    },
                },
                {list: [],},
                {show_list: {value: false, units: ''},},
                {view: {value: '', units: ''},},
                {columns: viewOptionDefaultValues.columns,},
                {column: viewOptionDefaultValues.column,},
                {carousel: viewOptionDefaultValues.carousel,},
                {masonry: viewOptionDefaultValues.masonry,},
                {text_align: {value: 'text-left', units: ''},
                },
                {fullwidth: {value: false, units: ''},
                },
                {map_width: {value: 'auto', units: '%'},
                },
                {map_height: {value: 'auto', units: '%'},
                },
                {map_max_width: {value: 'auto', units: '%'},
                },
                {map_max_height: {value: 'auto', units: '%'},
                },
                {map_padding: {
                    active: false,
                    type: 'numbergroup',
                    parentlabel: '',
                    left: null,
                    right: null,
                    top: null,
                    bottom: null, 
                },    
                },
                {map_margin: {
                    active: false,
                    type: 'numbergroup',
                    parentlabel: '',
                    left: null,
                    right: null,
                    top: null,
                    bottom: null,
                },
                },
                {map_border_label: {active: false, type: 'label', text: 'Borders', parentname: 'border_label'},
                },
                {map_border_style: {
                      active: false, type: 'select', value: '', options: ['dotted','dashed','solid','double','groove','ridge','inset','outset','none','hidden']
                },
                },
                {map_border: {
                    active: true,
                    type: 'numbergroup',
                    parentlabel: '',
                    left: 0,
                    right: 0,
                    top: 0,
                    bottom: 0,
                },  
                },
                {map_border_colour: {
                    active: false,
                    value: '#000000',
                    type: 'color'
                  },
                },
                {map_border_radius: {
                    active: false,
                    type: 'numbergroup',
                    parentlabel: '',
                    top_left: null,
                    top_right: null,
                    bottom_left: null,
                    bottom_right: null,
                    },
                },
              ],
              widgetconfigs: [
                {show_list_label: {active: false, type: 'label', text: 'List Settings', parentname: 'spacing_label'},},
                {show_list: {active: false, type: 'radiogroup', isButton: true, value: false, options: [true, false]},},
                {view_label: {active: false, type: 'label', text: 'View Settings', parentname: 'spacing_label', dependentOn: {field: 'show_list', value: true}},},
                {view: {active: false, type: 'select', value: '', options: ['', 'grid', 'list', 'carousel', 'masonry'], dependentOn: {field: 'show_list', value: true}},},
                {columns_label: {active: false, type: 'label', text: 'Grid Gallery Settings', parentname: 'spacing_label',  dependentOn: {field: 'view', value: 'grid'}},},
                {columns: viewOptionConfigs.columns,},
                {column: viewOptionConfigs.column,},
                {carousel_label: {active: false, type: 'label', text: 'Carousel Gallery Settings', parentname: 'border_label', dependentOn: {field: 'view', value: 'carousel'},},},
                {carousel: viewOptionConfigs.carousel.default,},
                {masonry_label: {active: false, type: 'label', text: 'Masonry Gallery Settings', parentname: 'border_label', dependentOn: {field: 'view', value: 'masonry'}},},
                {masonry: viewOptionConfigs.masonry,},
                {alignment_label: {active: false, type: 'label', text: 'Map Alignment', parentname: 'alignment_label'},},
                {text_align: {active: false, type: 'radiogroup', isButton: true, value: 'text-left', options: ['text-left', 'text-center', 'text-right']},},
                {fullwidth: {active: false, type: 'radiogroup', isButton: true, value: false, options: [true, false]},},
                {sizing_label: {active: false, type: 'label', text: 'Map Sizing', parentname: 'alignment_label'},},
                {map_width: {active: false, type: 'range', value: 'auto', units: '%', unit_options: ['px', '%'],  max: 2400, min: 0, parentlabel: 'sizing_label'},},
                {map_max_width: {active: false, type: 'range', value: 'auto', units: '%', unit_options: ['px', '%'],  max: 2400, min: 0, parentlabel: 'sizing_label'},},
                {map_height: {active: false, type: 'range', value: 'auto', units: '%', unit_options: ['px', '%'],  max: 2400, min: 0, parentlabel: 'sizing_label'},},
                {map_max_height: {active: false, type: 'range', value: 'auto', units: '%', unit_options: ['px', '%'],  max: 2400, min: 0, parentlabel: 'sizing_label'},},
                {spacing_label: {active: false, type: 'label', text: 'Map Spacing', parentname: 'alignment_label'},},
                {map_padding: {
                    active: false,
                    type: 'numbergroup',
                    parentlabel: '',
                    left: null,
                    right: null,
                    top: null,
                    bottom: null, 
                },
                },
                {map_margin: {
                    active: false,
                    type: 'numbergroup',
                    parentlabel: '',
                    left: null,
                    right: null,
                    top: null,
                    bottom: null,
                },
                },
                {map_border_label: {active: false, type: 'label', text: 'Borders', parentname: 'border_label'},
                },
                {map_border_style: {
                    active: false, type: 'select', value: '', options: ['dotted','dashed','solid','double','groove','ridge','inset','outset','none','hidden']
                },
                },
                {map_border: {
                    active: true,
                    type: 'numbergroup',
                    parentlabel: '',
                    left: 0,
                    right: 0,
                    top: 0,
                    bottom: 0,
                },
                },
                {map_border_colour: {
                    active: false,
                    value: '#000000',
                    type: 'color'
                },
                },
                {map_border_radius: {
                    active: false,
                    type: 'numbergroup',
                    parentlabel: '',
                    top_left: null,
                    top_right: null,
                    bottom_left: null,
                    bottom_right: null,
                },
                },
              ],
              widgetstyles: '',
              widgetelements: {
                    active_elements: viewOptionDefaultValues.show_elements.listingmap,
                    elements: viewOptionConfigs.show_elements.listingmap.subfields,
                  },
              widgetfilters: {
                    filter: {listing_type: {active: 0, type: 'custommultiselect', options: [], value: []}, listings: {active: 0, type: 'customselect', options: [], value: []}, page: {active: 0, type: 'number', value: 1}, limit: {active: 0, type: 'range', value: 25}, order: {active: 0, type: 'select', value: 'DESC', options: ['ASC','DESC']}, sortby: {active: 0, type: 'select', value: 'id', options: ['id', 'name', 'created_at', 'updated_at']}},
                    active_filters: {listing_type: {active: 0, type: 'custommultiselect', options: []}, listings: {active: 0, type: 'customselect', options: [], value: []}, page: {active: 0, type: 'number', value: 1}, limit: {active: 0, type: 'range', value: 25}, order: {active: 0, type: 'select', value: 'DESC', options: ['ASC','DESC']}, sortby: {active: 0, type: 'select', value: 'id', options: ['id', 'name', 'created_at', 'updated_at']}},
              },
              editable: 0,
              id: '',
            },
            {
              widgetname: 'Map',
              widgettype: 'map',
              widgeticon: 'bx bx-map-alt',
              widgetcontent: {
                config: {
                  view: 'roadmap',
                  view_options: ['roadmap', 'satellite', 'hybrid', 'terrain'],
                  zoom_level: {type: 'range', value: 5},
                  
                },
                apikey: '',
                value: {
                  search: {type: 'text', value: ''},
                  searchResult: '',
                  name: {type: 'text', value: ''},
                  address1: {type: 'text', value: ''},
                  address2: {type: 'text', value: ''},
                  address3: {type: 'text', value: ''},
                  postcode: {type: 'text', value: ''},
                  city: {type: 'text', value: ''},
                  longitude: {type: 'hidden', value: 0},
                  latitude: {type: 'hidden', value: 0},
                  gplace_id: {type: 'hidden', value: ''},
                  country_id: {type: 'select', value: 0, options: []},
                  county_id: {type: 'select', value: 0, options: []},
                },
              },
              widgetstyles: '',
              widgetelements: {
                  active_elements: viewOptionDefaultValues.show_elements.map,
                  elements: viewOptionConfigs.show_elements.map.subfields,
              },
              editable: 0,
              id: '',
            },
             
            {
              widgetname: 'Address Block',
              widgettype: 'address',
              widgeticon: 'bx bx-home-circle',
              widgetcontent: {
                config: {
                  view: 'block',
                  view_options: ['block', 'inline'],
                  use_company_address: {type: 'switch', value: false},
                  
                },
                value: {
                  name: {type: 'text', value: ''},
                  address1: {type: 'text', value: ''},
                  address2: {type: 'text', value: ''},
                  address3: {type: 'text', value: ''},
                  postcode: {type: 'text', value: ''},
                  city: {type: 'text', value: ''},
                  longitude: {type: 'hidden', value: 0},
                  latitude: {type: 'hidden', value: 0},
                  gplace_id: {type: 'hidden', value: ''},
                  country_id: {type: 'select', value: 0, options: []},
                  county_id: {type: 'select', value: 0, options: []},
                },
              },
              widgetstyles: '',
              editable: 0,
              id: '',
            },
            /*{
              widgetname: 'Store Address',
              widgettype: 'address',
              widgeticon: 'bx bx-home-circle',
              widgetcontent: {
                 config: {
                  view: 'block',
                  view_options: ['block', 'inline'],
                  use_company_address: {type: 'switch', value: false},
                  
                },
                value: {
                  name: {type: 'text', value: ''},
                  address1: {type: 'text', value: ''},
                  address2: {type: 'text', value: ''},
                  address3: {type: 'text', value: ''},
                  postcode: {type: 'text', value: ''},
                  city: {type: 'text', value: ''},
                  longitude: {type: 'hidden', value: 0},
                  latitude: {type: 'hidden', value: 0},
                  gplace_id: {type: 'hidden', value: ''},
                  country_id: {type: 'select', value: 0, options: []},
                  county_id: {type: 'select', value: 0, options: []},
                },
              },
              widgetstyles: '',
              widgetfilters: {
                    filter: {listings: {active: 0, type: 'customselect', options: []}},
                    active_filters: {listings: {active: 0, type: 'customselect', options: [], value: []}},
              },
              editable: 0,
              id: '',
            },*/
            {
              widgetname: 'Social Share',
              widgettype: 'social',
              widgetaction: 'share',
              widgeticon: 'bx bx-share-alt',
              widgetcontent: [
                {config: {
                  view: 'block',
                  view_options: ['block', 'inline'],
                  use_company_address: {type: 'switch', value: false},
                    },
                },
                {list: [],},
                {list_index: 0,},
                /*list_item: {
                  name: '',
                  network: '',
                  icon: '',
                  handle: '',
                  active: 0,
                  color: '',
                  bg_color: '',
                  icon_size: 0,
                  bg_size: 0,
                  icon_type: '',
                },*/
                {active: {value: 0, units: ''},},
                {colour: {value: '', units: ''},},
                {background_colour: {value: '', units: ''},},
                {padding: {
                    active: false,
                    type: 'numbergroup',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                  },
                },
                {icon_size: {value: 0, units: ''},},
                {padding: {value: 0, units: ''},},
                {icon_type: {value: 'gradient', units: ''},},
                {icon_group_layout: {value: 'stacked', units: ''},},
                {icon_group_position: {value: 'fixed-right', units: ''},},
                {collapsed: {value: false, units: ''},},
              ],
              widgetconfigs: [
                  {styling_label: {active: false, type: 'label', text: 'Global Styling Options', parentname: 'alignment_label'},},
                  {icon_group_layout:  {active: false, type: 'radiogroup', isButton: true, value: false, options: ['stacked', 'inline']},},
                  {icon_group_position:  {active: false, type: 'radiogroup', isButton: true, value: false, options: ['left', 'right', 'fixed-left', 'fixed-right']},},
                  {collapsed:  {active: false, type: 'radiogroup', isButton: true, value: false, options: [true, false]},},
                  {icon_size: {active: false, type: 'range', value: 'auto', units: 'px', unit_options: ['px'],  max: 124, min: 0, parentlabel: 'sizing_label'},},
                  {icon_type:  {active: false, type: 'radiogroup', isButton: true, value: false, options: ['plain', 'square', 'circle']},},
                  {colour: {
                    active: false,
                    value: '#000000',
                    type: 'color'
                  },
                  },
                  {background_colour: {
                    active: false,
                    value: '#000000',
                    type: 'color'
                  },
                  },
                  {padding: {
                    active: false,
                    type: 'numbergroup',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                  },
                },
              ],
              widgetlistconfigs: {
                list_item: [
                  {network_items: {active: false, type: 'label', text: 'Network Options', parentname: 'alignment_label'},
                  },
                  {title:  {type: 'text', value: 'Slide 1'},
                  },
                  {network: {type: 'select', value: 0, options: [{text:'Facebook', value: 'facebook', icons: []}, {text:'Twitter', value: 'twitter', icons: []}, {text:'Linkedin', value: 'linkedin', icons: []}, {text:'Pinterest', value: 'pinterest', icons: []}, {text:'Instagram', value: 'instagram', icons: []}]},
                  },
                  {icon: {value: '', units: ''},
                  },
                  {handle:  {type: 'text', value: 'Slide 1'},
                  },
                  {button_label: {active: false, type: 'label', text: 'Button Options', parentname: 'alignment_label'},
                  },
                  {button_style:  {active: false, type: 'radiogroup', isButton: true, value: false, options: ['default', 'gradient', 'outline']},
                  },
                  {show_counter:  {active: false, type: 'radiogroup', isButton: true, value: false, options: [true,false]},
                  },
                  {styling_label: {active: false, type: 'label', text: 'Styling Options', parentname: 'alignment_label'},
                  },
                  {icon_size: {active: false, type: 'range', value: 'auto', units: 'px', unit_options: ['px'],  max: 124, min: 0, parentlabel: 'sizing_label'},
                  },
                  {icon_type:  {active: false, type: 'radiogroup', isButton: true, value: false, options: ['plain', 'square', 'circle']},
                  },
                  {colour: {
                    active: false,
                    value: '#000000',
                    type: 'color'
                  },
                  },
                  {background_colour: {
                    active: false,
                    value: '#000000',
                    type: 'color'
                  },
                  },
                  {padding: {
                    active: false,
                    type: 'numbergroup',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                  },
                  },
                ],
                list_item_values: [
                  {title: {value: '', units: ''},},
                  {network: {value: '', units: ''},},
                  {icon: {value: '', units: ''},},
                  {handle: {value: '', units: ''},},
                  {active: {value: 0, units: ''},},
                  {colour: {value: '', units: ''},},
                  {background_colour: {value: '', units: ''},},
                  {padding: {
                        active: false,
                        type: 'numbergroup',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                      },
                  },
                  {icon_size: {value: 0, units: ''},},
                  {padding: {value: 0, units: ''},},
                  {icon_type: {value: '', units: ''},},
                  {button_style: {value: '', units: ''},},
                {show_counter: {value: '', units: ''},},
                ],
              },
              widgetstyles: '',
              editable: 0,
              id: '',
            },

            {
              widgetname: 'Social Follow',
              widgettype: 'social',
              widgetaction: 'follow',
              widgeticon: 'bx bxl-twitter',
              widgetcontent: [
                    {config: {
                          view: 'block',
                          view_options: ['block', 'inline'],
                          use_company_address: {type: 'switch', value: false},
                        },
                    },
                    {list: [],},
                    {list_index: 0,},
                    {list_item: {
                          name: '',
                          network: '',
                          icon: '',
                          handle: '',
                          active: 0,    
                          color: '',
                          bg_color: '',
                          icon_size: 0,
                          bg_size: 0,
                          icon_type: '',           
                        },
                    },
                    {icon_types: ['plain', 'square', 'circle'],},
                    {networks: [{text:'Facebook', value: 'facebook', icons: []}, {text:'Twitter', value: 'twitter', icons: []}, {text:'Linkedin', value: 'linkedin', icons: []}, {text:'Pinterest', value: 'pinterest', icons: []}, {text:'Instagram', value: 'instagram', icons: []}],},
                    {active: {value: 0, units: ''},},
                    {colour: {value: '', units: ''},},
                    {background_colour: {value: '', units: ''},},
                    {border_colour: {value: '', units: ''},},
                    {padding: {
                            active: false,
                            type: 'numbergroup',
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                          },
                    },
                    {icon_size: {value: 0, units: ''},},
                    {padding: {value: 0, units: ''},},
                    {icon_type: {value: '', units: ''},},
               
              ],
              widgetconfigs: [
                  {styling_label: {active: false, type: 'label', text: 'Global Styling Options', parentname: 'alignment_label'},
                  },
                  {icon_size: {active: false, type: 'range', value: 'auto', units: 'px', unit_options: ['px'],  max: 124, min: 0, parentlabel: 'sizing_label'},},
                  {icon_type:  {active: false, type: 'radiogroup', isButton: true, value: false, options: ['plain', 'square', 'circle']},},
                  {
                    colour: {
                        active: false,
                        value: '#000000',
                        type: 'color'
                    },
                  },
                  {
                    background_colour: {
                        active: false,
                        value: '#000000',
                        type: 'color'
                    },
                  },
                  {
                    border_colour: {
                        active: false,
                        value: '#000000',
                        type: 'color'
                    },
                  },
                  {
                    padding: {
                        active: false,
                        type: 'numbergroup',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                    }
                  },
              ],
              widgetlistconfigs: {
                list_item: [
                  {network_items: {active: false, type: 'label', text: 'Network Options', parentname: 'alignment_label'},
                  },
                  {title:  {type: 'text', value: 'Slide 1'},
                  },
                  {network: {type: 'select', value: 0, options: [{text:'Facebook', value: 'facebook', icons: []}, {text:'Twitter', value: 'twitter', icons: []}, {text:'Linkedin', value: 'linkedin', icons: []}, {text:'Pinterest', value: 'pinterest', icons: []}, {text:'Instagram', value: 'instagram', icons: []}]},
                  },
                  {icon: {value: '', units: ''},
                  },
                  {handle:  {type: 'text', value: 'Slide 1'},
                  
                  },
                  {styling_label: {active: false, type: 'label', text: 'Styling Options', parentname: 'alignment_label'},
                  },
                  {icon_size: {active: false, type: 'range', value: 'auto', units: 'px', unit_options: ['px'],  max: 124, min: 0, parentlabel: 'sizing_label'},
                  },
                  {icon_type:  {active: false, type: 'radiogroup', isButton: true, value: false, options: ['plain', 'square', 'circle']},
                  },
                  {colour: {
                    active: false,
                    value: '#000000',
                    type: 'color'
                  },
                  },
                  {background_colour: {
                    active: false,
                    value: '#000000',
                    type: 'color'
                  },
                  },
                  {
                    border_colour: {
                        active: false,
                        value: '#000000',
                        type: 'color'
                    },
                  },
                  {
                    padding: {
                        active: false,
                        type: 'numbergroup',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                      },
                  }
                  
                ],
                list_item_values: [
                  {title: {value: '', units: ''},},
                  {network: {value: '', units: ''},},
                  {icon: {value: '', units: ''},},
                  {handle: {value: '', units: ''},},
                  {active: {value: 0, units: ''},},
                  {colour: {value: '', units: ''},},
                  {background_colour: {value: '', units: ''},},
                  {border_colour: {value: '', units: ''},},
                  {padding: {
                    active: false,
                    type: 'numbergroup',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                  },
                  },
                  {icon_size: {value: 0, units: ''},
                  },
                  {padding: {value: 0, units: ''},
                  },
                  {icon_type: {value: '', units: ''},
                   }

                ],
              },
              widgetstyles: '',
              editable: 0,
              id: '',
            },

            {
              widgetname: 'Search Bar',
              widgettype: 'search',
              widgeticon: 'bx bx-search-alt',
              widgetcontent: [
                {config: {
                  view: 'block',
                  view_options: ['block', 'inline'],
                  use_company_address: {type: 'switch', value: false},
                  
                },
                },
                {search: {
                  term: '',
                  area: [],
                  areas: ['Products', 'Services', 'Collections', 'Categories', 'Brands'],
                  max_results: 0,
                  results_per_page: 25,
                  dropdown: false,
                },
                },
                {field_label: {value: '', units: ''},
                },
                {show_button: {value: '', units: ''},
                },
                {button_text: {value: '', units: ''},
                },
                {field_placeholder_text: {value: '', units: ''},
                },
                {field_border: {
                      active: true,
                      type: 'numbergroup',
                      parentlabel: '',
                      left: 0,
                      right: 0,
                      top: 0,
                      bottom: 0,
                },
                },
                {field_border_radius: {
                    active: false,
                      type: 'numbergroup',
                      parentlabel: '',
                      top_left: null,
                      top_right: null,
                      bottom_left: null,
                      bottom_right: null,
                },
                },
                {field_border_color: {value: '', units: ''},
                },
                {show_image: {value: '', units: ''},
                },
                {title: viewOptionDefaultValues.title_font
                },
                {text: viewOptionDefaultValues.font2
                },
              ],
              widgetconfigs: [
                  {field_label: {active: false, type: 'label', text: 'Global Styling Options', parentname: 'alignment_label'},
                  },
                  {show_button: {type: 'radiogroup', isButton: true, value: false, options: [true, false]},
                 },
                 {button_text: {type: 'text', isButton: true, value: false, dependentOn: {field: 'show_button', value: true} },
                  },
                  {field_placeholder_text: {type: 'text', isButton: true, value: false },
                  },
                  {field_border: {
                      active: true,
                      type: 'numbergroup',
                      parentlabel: '',
                      left: 0,
                      right: 0,
                      top: 0,
                      bottom: 0,
                  },
                  },
                  {field_border_radius: {
                    active: false,
                      type: 'numbergroup',
                      parentlabel: '',
                      top_left: null,
                      top_right: null,
                      bottom_left: null,
                      bottom_right: null,
                  },
                  },
                  {field_border_color: { active: false, value: '#000000', type: 'color'},
                  },
                  {results_label: {active: false, type: 'label', text: 'Results Style', parentname: 'alignment_label'},
                  },
                  {show_image: {type: 'radiogroup', isButton: true, value: false, options: [true, false]},
                  },
                  {title_label: {active: false, type: 'label', text: 'Search Results Title Options', parentname: 'alignment_label'},
                  },
                  {title: viewOptionConfigs.title_font
                  },
                  {text_label: {active: false, type: 'label', text: 'Search Results Text Options', parentname: 'alignment_label'},
                  },
                  {text: viewOptionConfigs.font2},
              ],
              widgetstyles: '',
              widgetelements: {
                    active_elements:  viewOptionDefaultValues.show_elements.search,
                    elements: viewOptionConfigs.show_elements.search.subfields,
              },
              widgetfilters: {
                    filter: {search_area: {active: 1, isStacked: true, type: 'multiselect', options: ['Products', 'Services', 'Collections', 'Categories', 'Listings']}, page: {active: 0, type: 'number', value: 1}, limit: {active: 0, type: 'range', value: 16}, order: {active: 0, type: 'select', value: 'DESC', options: ['ASC','DESC']}, sortby: {active: 0, type: 'select', value: 'id', options: ['id', 'name', 'created_at', 'updated_at']}, search: {active: 0, type: 'hidden', units: '', value: ''}},
                    active_filters: { search_area: {active: 1, isStacked: true, type: 'multiselect', options: ['Products', 'Services', 'Collections', 'Categories', 'Listings'], value: []}, page: {active: 0, type: 'number', value: 1}, limit: {active: 0, type: 'range', value: 16}, order: {active: 0, type: 'select', value: 'DESC', options: ['ASC','DESC']}, sortby: {active: 0, type: 'select', value: 'id', options: ['id', 'name', 'created_at', 'updated_at']}, search: {active: 0, type: 'hidden', units: '', value: ''}},
              },
              editable: 0,
              id: '',
            },
            {
              widgetname: 'Contact Form',
              widgettype: 'form',
              widgetaction: 'default-contact',
              widgeticon: 'bx bx-list-plus',
              widgetcontent: [
                //height:  {value: 30, units: 'px'},
                //width:  {value: 100, units: '%'},
                //colour: {value: '', units: ''},
                {button_colour: {value: '', units: ''},},
                {button_text_colour: {value: '', units: ''},},
                {button_border: {value: '', units: ''},},
                {button_border_style: {value: '', units: ''},},
                {button_border_colour: {value: '', units: ''},},
                {button_border_radius: {value: '', units: ''},},
                {field_border_style: {value: '', units: ''},},
                {field_border: {value: '', units: ''},},
                {field_border_radius: {value: '', units: ''},},
                {field_border_colour: {value: '', units: ''},},
              ],
              widgetconfigs: [
                {sizing_label: {active: false, type: 'label', text: 'Button Options', parentname: 'alignment_label'},
                },
                {button_colour: {
                    active: false,
                    value: '#000000',
                    type: 'color'
                },
                },
                {button_text_colour: {
                    active: false,
                    value: '#000000',
                    type: 'color'
                },
                },
                {button_border_style: {
                    active: false, type: 'select', value: '', options: ['dotted','dashed','solid','double','groove','ridge','inset','outset','none','hidden']
                },
                },
                {button_border: {
                    active: true,
                    type: 'numbergroup',
                    parentlabel: '',
                    left: 0,
                    right: 0,
                    top: 0,
                    bottom: 0,
                },  
                },
                {button_border_radius: {
                    active: false,
                    type: 'numbergroup',
                    parentlabel: '',
                    top_left: null,
                    top_right: null,
                    bottom_left: null,
                    bottom_right: null,
                },
                },
                {button_border_colour: {
                    active: false,
                    value: '#000000',
                    type: 'color'
                },
                },
                {field_label: {active: false, type: 'label', text: 'Field Options', parentname: 'alignment_label'},
                },
                {field_border_style: {
                    active: false, type: 'select', value: '', options: ['dotted','dashed','solid','double','groove','ridge','inset','outset','none','hidden']
                },
                },
                {field_border: {
                      active: true,
                      type: 'numbergroup',
                      parentlabel: '',
                      left: 0,
                      right: 0,
                      top: 0,
                      bottom: 0,
                },
                },
                {field_border_radius: {
                    active: false,
                      type: 'numbergroup',
                      parentlabel: '',
                      top_left: null,
                      top_right: null,
                      bottom_left: null,
                      bottom_right: null,
                },
                },
                {field_border_colour: { active: false, value: '#000000', type: 'color'},
                },
              ],
              widgetstyles: '',
              editable: 0,
              id: '',
            },
            {
              widgetname: 'Spacer',
              widgettype: 'spacer',
              widgeticon: 'mdi mdi-arrow-split-horizontal',
              widgetcontent: [
                {spacer_height:  {value: 30, units: 'px'},},
                {spacer_width:  {value: 100, units: '%'},},
                {spacer_max_height:  {value: 30, units: 'px'},},
                {spacer_max_width:  {value: 100, units: '%'},},
                {spacer_background_colour: {value: '', units: ''},},
              ],
              widgetconfigs: [

                {sizing_label: {active: false, type: 'label', text: 'Spacer Options', parentname: 'alignment_label'},                
                },
                {spacer_height: {active: false, type: 'range', value: 'auto', units: '%', unit_options: ['px', '%'],  max: 2400, min: 0, parentlabel: 'sizing_label'},
                },
                {spacer_width: {active: false, type: 'range', value: 'auto', units: '%', unit_options: ['px', '%'],  max: 2400, min: 0, parentlabel: 'sizing_label'},
                },
                {spacer_max_height: {active: false, type: 'range', value: 'auto', units: '%', unit_options: ['px', '%'],  max: 2400, min: 0, parentlabel: 'sizing_label'},
                },
                {spacer_max_width: {active: false, type: 'range', value: 'auto', units: '%', unit_options: ['px', '%'],  max: 2400, min: 0, parentlabel: 'sizing_label'},
                },
                {spacer_background_colour: {
                    active: false,
                    value: '#000000',
                    type: 'color'
                },
                },
              ],
              widgetstyles: '',
              editable: 0,
              id: '',
            },
            {
              widgetname: 'Divider',
              widgettype: 'divider',
              widgeticon: 'mdi mdi-border-horizontal',
              widgetcontent: [

                {bordertype: 'solid',
                },
                {height:  {value: 30, units: 'px'},
                },
                {width:  {value: 100, units: '%'},
                },
                {colour: {value: '', units: ''},
                },
                {opacity: {value: '', units: ''},
                },
                {border_label: {active: false, type: 'label', text: 'Borders', parentname: 'border_label'},
                },
                {border_style: {
                      active: false, type: 'select', value: ''},
                },
                {border: {
                    active: true,
                    parentlabel: '',
                    left: 0,
                    right: 0,
                    top: 0,
                    bottom: 0,
                },  
                },
                {border_colour: {
                    active: false,
                    value: '#000000',
                  },
                },
                {border_radius: {
                    active: false,
                    parentlabel: '',
                    top_left: null,
                    top_right: null,
                    bottom_left: null,
                    bottom_right: null,
                    },
                },
              ],
              widgetconfigs: [
                {sizing_label: {active: false, type: 'label', text: 'Sizing Options', parentname: 'alignment_label'},
                },
                {width: {active: false, type: 'range', value: 'auto', units: '%', unit_options: ['px', '%'],  max: 2400, min: 0, parentlabel: 'sizing_label'},
                },
                {colour: {
                    active: false,
                    value: '#000000',
                    type: 'color'
                },
                },
                {opacity: {active: false, type: 'range', value: 'auto', units: '%',  max: 1.00, min: 0.01, parentlabel: 'sizing_label'},
                },
                {border_label: {active: false, type: 'label', text: 'Border Options', parentname: 'border_label'},
                },
                {border_style: {
                      active: false, type: 'select', value: '', options: ['dotted','dashed','solid','double','groove','ridge','inset','outset','none','hidden']
                },
                },
                {border: {
                    active: true,
                    type: 'numbergroup',
                    parentlabel: '',
                    left: 0,
                    right: 0,
                    top: 0,
                    bottom: 0,
                },  
                },
                {border_colour: {
                    active: false,
                    value: '#000000',
                    type: 'color'
                  },
                },
                {border_radius: {
                    active: false,
                    type: 'numbergroup',
                    parentlabel: '',
                    top_left: null,
                    top_right: null,
                    bottom_left: null,
                    bottom_right: null,
                    },
                }
                
              ],
              widgetstyles: '',
              editable: 0,
              id: '',
            },
            /**{
              widgetname: 'Dynamic Fields',
              widgettype: 'dynamic-field',
              widgeticon: 'mdi-form-textbox',
              widgetcontent: {
                url: '',
                width: 300,
                height: 300,
              },
              editable: 0,
              id: '',
            },**/
          ];

const appraisalWidgets = [
            {
              widgetname: 'Image',
              widgettype: 'image',
              widgeticon: 'bx bx-image',
              widgetcontent: {
                url: '',
                width: 300,
                height: 300,
                alignment: 'text-left',
                fullwidth: false,
              },
              editable: 0,
              id: '',
            },
            {
              widgetname: 'Text',
              widgettype: 'text',
              widgeticon: 'bx bx-text',
              widgetcontent: {
                title: '',
                text: '',
              },
              editable: 0,
              id: '',
            },
            {
              widgetname: 'Spacer',
              widgettype: 'spacer',
              widgeticon: 'mdi mdi-arrow-split-horizontal',
              widgetcontent: {
                height: ''
              },
              editable: 0,
              id: '',
            },
            {
              widgetname: 'Divider',
              widgettype: 'divider',
              widgeticon: 'mdi mdi-border-horizontal',
              widgetcontent: {
                bordertype: 'solid',
                width: 1,
                color: '#000',
                opacity: '',
              },
              widgetoptions:{
                bordertypes: ['dotted','dashed','solid','double','groove','ridge','inset','outset','none','hidden']
              },
              editable: 0,
              id: '',
            },
            {
              widgetname: 'Store Address',
              widgettype: 'address',
              widgeticon: 'bx bx-home-circle',
              widgetcontent: {
                url: '',
                width: 300,
                height: 300,
              },
              editable: 0,
              id: '',
            },
            {
              widgetname: 'Customer Details',
              widgettype: 'customer-address',
              widgeticon: 'bx bx-user-circle',
              widgetcontent: {
                selectcustomer: false, 
                selectedcustomer: null,
                selectedaddress: null,
              },
              editable: 0,
              id: '',
            },
            {
              widgetname: 'Signature',
              widgettype: 'signature',
              widgeticon: 'bx bx-pen',
              widgetcontent: {
                url: '',
                width: 300,
                height: 300,
              },
              editable: 0,
              id: '',
            },
            {
              widgetname: 'Note',
              widgettype: 'note',
              widgeticon: 'bx bx-note',
              widgetcontent: {
                url: '',
                width: 300,
                height: 300,
              },
              editable: 0,
              id: '',
            },
            {
              widgetname: 'Stamp',
              widgettype: 'stamp',
              widgeticon: 'mdi mdi-stamper',
              widgetcontent: {
                url: '',
                width: 300,
                height: 300,
              },
              editable: 0,
              id: '',
            },

            {
              widgetname: 'Dynamic Fields',
              widgettype: 'dynamic-field',
              widgeticon: 'mdi-form-textbox',
              widgetcontent: {
                url: '',
                width: 300,
                height: 300,
              },
              editable: 0,
              id: '',
            },
          ];



export { webPageWidgets, templateWidgets };